import { j as y, a as x, F as Ze } from "./emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import zr, { useRef as Nn, useEffect as We, useId as Ft, useState as de, useMemo as pt, useLayoutEffect as qr, createContext as Yr, useContext as Ln, useCallback as Q } from "react";
import { useQuery as Xr, useMutation as eo } from "@tanstack/react-query";
import { IonDatetime as Fn, IonModal as kn, IonDatetimeButton as Jr, IonInput as Bn, IonItem as Zr, IonLabel as Mn, IonHeader as Qr, IonPopover as to, IonButton as ei } from "@ionic/react";
import { Colors as C } from "./components/1-foundations/Colors/Colors.js";
import { k as no } from "./emotion-react.browser.esm-C9Tl5GZI.js";
import { BoxShadows as ro } from "./components/1-foundations/BoxShadows/BoxShadows.js";
import { I as ne, l as io, a as oo, b as so, c as ao, d as co, e as uo } from "./Icon-CwNA7zVF.js";
import { Asterisk as lo } from "./components/2-atoms/Asterisk/Asterisk.js";
import { t as ti, D as gt, i as ni, a as ri } from "./utils-BhwvO34b.js";
import { Breakpoints as fo } from "./components/1-foundations/Breakpoints/Breakpoints.js";
import { g as Hn, c as j, a as Gn } from "./react-paginate-Lh5zQzpz.js";
import se, { translate as P } from "./components/string-table.js";
import "./components/organisms/LoadingInterstitial/LoadingInterstitial.js";
import { registerPlugin as ho } from "@capacitor/core";
import po, { AxiosError as go } from "axios";
import "./components/contexts/DesignSystemProvider/DesignSystemProvider.js";
import { AuthModel as rt } from "./models/AuthModel.js";
import { formatTime as Xe } from "./utils/formatTime.js";
import { useMediaQuery as mo } from "./utils/useMediaQuery.js";
import { formatDate as vo } from "./utils/formatDate.js";
import './css/FeatureFlagProvider.css';const yo = (e) => ({
  color: e != null && e.color ? C[e.color] : "inherit",
  fontFamily: "inherit",
  fontSize: 12,
  fontWeight: (e == null ? void 0 : e.fontWeight) ?? 400
}), zf = (e) => ({
  color: e != null && e.color ? C[e.color] : "inherit",
  fontFamily: "inherit",
  fontSize: 14,
  fontWeight: (e == null ? void 0 : e.fontWeight) ?? 400
}), So = (e) => ({
  color: e != null && e.color ? C[e.color] : "inherit",
  fontFamily: "inherit",
  fontSize: 16,
  fontStyle: (e == null ? void 0 : e.fontStyle) ?? "normal",
  fontWeight: (e == null ? void 0 : e.fontWeight) ?? 400,
  textDecoration: e != null && e.isStrikethrough ? "line-through" : "none"
}), qf = (e) => ({
  color: e != null && e.color ? C[e.color] : "inherit",
  fontFamily: "inherit",
  fontSize: 20,
  fontWeight: (e == null ? void 0 : e.fontWeight) ?? 400
}), Yf = (e) => ({
  color: e != null && e.color ? C[e.color] : "inherit",
  fontFamily: "inherit",
  fontSize: 24,
  fontWeight: 500
}), Xf = (e) => ({
  color: e != null && e.color ? C[e.color] : "inherit",
  fontFamily: "inherit",
  fontSize: 30,
  fontWeight: 500
}), Eo = {
  secondary: {
    backgroundColor: C.yellow200,
    textColor: "yellow600"
  },
  tertiary: {
    backgroundColor: C.purple200,
    textColor: "purple500"
  },
  success: {
    backgroundColor: C.green200,
    textColor: "green500"
  },
  warning: {
    backgroundColor: C.yellow500,
    textColor: "black"
  },
  danger: {
    backgroundColor: C.red200,
    textColor: "red500"
  },
  light: {
    backgroundColor: "transparent",
    textColor: "slate400"
  },
  medium: {
    backgroundColor: C.slate400,
    textColor: "white200"
  },
  "dynamic-pricing": {
    backgroundColor: C.green500,
    textColor: "white200"
  }
};
function _o(e) {
  const {
    status: t,
    text: n
  } = e, {
    backgroundColor: r,
    textColor: i
  } = Eo[t];
  return /* @__PURE__ */ y("div", {
    css: {
      borderRadius: 4,
      padding: "0px 4px",
      height: 17,
      // This is based on the design system
      backgroundColor: r,
      display: "flex",
      alignItems: "center",
      width: "fit-content",
      ...yo({
        color: i,
        fontWeight: 600
      })
    },
    children: n
  });
}
function Jf(e) {
  var p, m, E, _;
  const {
    type: t = "primary",
    children: n,
    onClick: r,
    isFluid: i = !1,
    status: o = "enabled",
    "data-testid": s
  } = e, a = o === "loading", l = o === "disabled", f = ((p = e.icon) == null ? void 0 : p.position) ?? "left", g = !n && !!((m = e.icon) != null && m.name);
  return /* @__PURE__ */ y("button", {
    "data-testid": s,
    "aria-label": n,
    css: {
      ...ut.buttonContainer,
      ...Co[t],
      ...i && {
        width: "100%"
      },
      ...a && {
        cursor: "not-allowed",
        // Override the border color for secondary buttons
        // while an action is pending
        ...t === "secondary" && {
          borderColor: C.blue600
        }
      },
      ...l || a ? {
        userSelect: "none"
      } : {},
      // override for when there is no children and just an icon
      ...g && ut.iconOnly
    },
    disabled: l || a,
    onClick: l || a ? void 0 : r,
    children: /* @__PURE__ */ x("span", {
      css: {
        display: "inline-flex",
        alignItems: "center",
        flexDirection: a ? "row" : f === "right" ? "row-reverse" : "row",
        gap: n && ((E = e.icon) != null && E.name || a) ? 8 : 0
      },
      children: [a ? /* @__PURE__ */ y(Ao, {
        color: t === "secondary" || t === "tertiary" ? C.blue600 : "currentColor"
      }) : (_ = e.icon) != null && _.name ? /* @__PURE__ */ y(ne, {
        name: e.icon.name,
        color: "currentColor"
      }) : null, n && /* @__PURE__ */ y("span", {
        css: {
          textAlign: "center",
          ...So({
            fontWeight: 600,
            color: a && (t === "secondary" || t === "tertiary") ? "blue600" : void 0
            // will fall back to "inherit"
          })
        },
        children: n
      })]
    })
  });
}
const wo = no`
  100% {
    transform: rotate(360deg);
  }
`;
function Ao(e) {
  const {
    color: t
  } = e;
  return /* @__PURE__ */ y("div", {
    css: {
      display: "inline-block",
      animation: `${wo} 1.5s linear infinite`
    },
    children: /* @__PURE__ */ y(ne, {
      name: "Progress",
      color: t
    })
  });
}
const ut = {
  buttonContainer: {
    display: "flex",
    width: "fit-content",
    // NOTE: Using `6px` vs `8px` top and bottom padding since the 2px border
    // results in `8px` top and bottom padding. This approach is also done for
    // the left and right padding.
    padding: "6px 14px",
    justifyContent: "center",
    alignItems: "center",
    flexShrink: 0,
    borderRadius: 30,
    minWidth: 110
  },
  primary: {
    backgroundColor: C.blue500,
    color: C.white200,
    border: `2px solid ${C.blue500}`,
    boxShadow: ro.default,
    "&:hover": {
      backgroundColor: C.blue600,
      border: `2px solid ${C.blue600}`
    },
    "&:disabled": {
      backgroundColor: C.slate200,
      border: `2px solid ${C.slate200}`,
      color: C.slate400,
      cursor: "not-allowed"
    }
  },
  secondary: {
    backgroundColor: "transparent",
    color: C.blue500,
    border: `2px solid ${C.blue500}`,
    "&:hover": {
      color: C.blue600,
      borderColor: C.blue600
    },
    "&:disabled": {
      color: C.slate400,
      borderColor: C.slate400,
      cursor: "not-allowed"
    }
  },
  tertiary: {
    backgroundColor: "transparent",
    color: C.blue500,
    border: "2px solid transparent",
    "&:hover": {
      color: C.blue600
    },
    "&:disabled": {
      color: C.slate400,
      cursor: "not-allowed"
    }
  },
  iconOnly: {
    border: "none",
    backgroundColor: "transparent",
    boxShadow: "none",
    color: C.blue500,
    minWidth: "auto",
    // Reset the minWidth when in icon only variant
    "&:hover": {
      color: C.blue600
    },
    "&:disabled": {
      color: C.slate400,
      cursor: "not-allowed"
    }
  }
}, Co = {
  primary: ut.primary,
  secondary: ut.secondary,
  tertiary: ut.tertiary
}, it = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: 8
  },
  label: {
    fontWeight: 600,
    color: C.black
  },
  subLabel: {
    lineHeight: "24px",
    fontSize: 14,
    margin: 0
  },
  inputWrapper: ({
    isDisabled: e,
    errorMessage: t
  }) => ({
    borderBottom: `1px solid ${t ? C.red500 : e ? "transparent" : C.slate400}`
  }),
  nativeInput: ({
    isDisabled: e
  }) => ({
    padding: 0,
    border: 0,
    width: "100%",
    maxWidth: "100%",
    maxHeight: "100%",
    color: e ? C.slate400 : C.black,
    background: "transparent",
    outline: "none",
    appearance: "none",
    touchAction: "manipulation",
    resize: "none"
  })
};
function Zf(e) {
  const {
    value: t,
    label: n,
    placeholder: r,
    onChange: i,
    isDisabled: o,
    isRequired: s = !1,
    subLabel: a,
    errorMessage: l
  } = e, f = t || "", g = Nn(null);
  return To(g, f), /* @__PURE__ */ x(Ze, {
    children: [/* @__PURE__ */ x("label", {
      style: it.container,
      className: "container",
      children: [n && /* @__PURE__ */ x("div", {
        style: it.label,
        className: "label",
        children: [n, s && /* @__PURE__ */ y(lo, {})]
      }), a && /* @__PURE__ */ y("p", {
        style: it.subLabel,
        children: a
      }), /* @__PURE__ */ y("div", {
        style: it.inputWrapper({
          isDisabled: o,
          errorMessage: l
        }),
        className: "input-wrapper",
        children: /* @__PURE__ */ y("textarea", {
          className: "placeHolderText",
          style: it.nativeInput({
            isDisabled: o
          }),
          disabled: o,
          autoCapitalize: "off",
          autoComplete: "off",
          autoCorrect: "off",
          spellCheck: !1,
          "aria-label": n,
          placeholder: r,
          value: f,
          ref: g,
          onChange: (p) => i(p.target.value)
        })
      })]
    }), l && /* @__PURE__ */ y(Wn, {
      children: /* @__PURE__ */ y("p", {
        style: {
          margin: 0
        },
        children: l
      })
    })]
  });
}
const To = (e, t) => {
  We(() => {
    if (!e.current) return;
    const n = e.current, r = () => {
      n && (n.style.height = "0px", n.style.height = `${n.scrollHeight}px`);
    }, i = (s) => {
      window.requestAnimationFrame(() => {
        !Array.isArray(s) || s.length === 0 || r();
      });
    }, o = new ResizeObserver(i);
    return o.observe(n), r(), () => {
      o.disconnect();
    };
  }, [e, t]);
};
function Qf(e) {
  const {
    value: t,
    disabledDateRanges: n = [],
    onChange: r,
    isReadOnly: i = !1,
    isStrikethrough: o = !1,
    isFluid: s = !1,
    isDisabled: a = !1
  } = e, l = Ft(), f = Nn(null), [g, p] = de(!1), m = pt(() => ti(n), [n]), E = pt(() => [
    // The component default disabled all weekends, so we add that label here.
    P("DATE_INPUT_WEEKEND_DISABLED_LABEL"),
    ...new Set(n.map(({
      label: S
    }) => S).filter((S) => S !== void 0))
  ], [n]), _ = vo({
    date: gt.fromISO(t ?? ""),
    format: "Jan 1, 2025"
  });
  return i ? t ? _ : P("DATE_INPUT_DEFAULT_LABEL") : o || a ? /* @__PURE__ */ y("button", {
    css: {
      ...He.button,
      width: s ? "100%" : Tt,
      color: C.slate400,
      // Removed is an extra state that just adds a strike through style
      textDecorationLine: o ? "line-through" : "initial",
      // Show a disabled cursor when the button is disabled
      cursor: a || o ? "not-allowed !important" : "pointer !important"
    },
    disabled: !0,
    children: t ? _ : P("DATE_INPUT_DEFAULT_LABEL")
  }) : /* @__PURE__ */ x(Ze, {
    children: [/* @__PURE__ */ y("div", {
      css: {
        display: t ? "block" : "none",
        // Expand this parent to 100%
        width: s ? "100%" : Tt,
        // Expand the shadow DOM button as well
        "ion-datetime-button::part(native)": {
          ...He.button,
          margin: 0,
          width: s ? "100%" : Tt
        }
      },
      children: /* @__PURE__ */ y(Jr, {
        datetime: l
      })
    }), /* @__PURE__ */ y("button", {
      css: {
        ...He.button,
        display: t ? "none" : "block",
        width: Tt,
        textAlign: "center"
      },
      onClick: () => p(!0),
      disabled: o,
      children: P("DATE_INPUT_DEFAULT_LABEL")
    }), /* @__PURE__ */ y(kn, {
      isOpen: g,
      canDismiss: !0,
      onDidDismiss: () => p(!1),
      onWillPresent: () => {
        !t && f.current && f.current.reset();
      },
      keepContentsMounted: !0,
      className: "stackedModal",
      children: /* @__PURE__ */ y(Fn, {
        id: l,
        ref: f,
        value: t,
        min: m == null ? void 0 : m.min,
        max: m == null ? void 0 : m.max,
        presentation: "date",
        isDateEnabled: (S) => {
          const b = ni(S, m.disabledDateRanges);
          return ri(S) && !b;
        },
        onIonChange: (S) => {
          r == null || r(
            // Purposely convert to ISO date so to ignore time and timezone
            // TODO: Why are we getting this TS error, maybe the DateTime
            // will not throw on invalid dates? So add the Luxon setting update.
            // Investigate in https://linear.app/swing-education/issue/MKTP-946
            gt.fromISO(S.detail.value).toISODate()
          );
        },
        children: /* @__PURE__ */ y("slot", {
          slot: "buttons",
          children: /* @__PURE__ */ x("div", {
            css: {
              // The container must have a width since the slot have a width
              // of auto and cannot use "100%". This 300px is derived from
              // the IonModal being 320px with left/right padding of 10px.
              width: 300,
              paddingLeft: 6,
              // Since the component adds 10px padding
              paddingRight: 6,
              // Since the component adds 10px padding
              paddingBottom: 6,
              // Since the component adds 10px padding
              display: "flex",
              flexDirection: "column",
              gap: 16
            },
            children: [/* @__PURE__ */ y("div", {
              css: {
                backgroundColor: C.slate200,
                borderRadius: 8,
                padding: 8
              },
              children: /* @__PURE__ */ y("p", {
                css: {
                  margin: 0,
                  fontSize: 12,
                  fontWeight: 400,
                  lineHeight: "16px"
                },
                children: P("DATE_INPUT_DISABLED_DAYS_DISCLAIMER", {
                  disabledLabels: E
                })
              })
            }), /* @__PURE__ */ x("div", {
              css: {
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              },
              children: [/* @__PURE__ */ y("button", {
                css: {
                  ...He.datePickerButton,
                  color: C.red500
                },
                onClick: () => {
                  var S;
                  return (S = f.current) == null ? void 0 : S.cancel(!0);
                },
                children: P("DATE_INPUT_CANCEL_LABEL")
              }), /* @__PURE__ */ y("button", {
                css: He.datePickerButton,
                onClick: () => {
                  var S;
                  return (S = f == null ? void 0 : f.current) == null ? void 0 : S.confirm(!0);
                },
                children: P("DATE_INPUT_DONE_LABEL")
              })]
            })]
          })
        })
      })
    })]
  });
}
function eh({
  value: e,
  isEnabled: t,
  disabledDateRanges: n,
  disabledLabel: r,
  onChange: i,
  onClose: o
}) {
  const s = Ft(), a = Nn(null), l = pt(() => ti(n), [n]);
  return /* @__PURE__ */ y(kn, {
    isOpen: t,
    canDismiss: !0,
    onDidDismiss: () => {
      o && o();
    },
    onWillPresent: () => {
      !e && a.current && a.current.reset();
    },
    className: "ion-datetime-button-overlay",
    children: /* @__PURE__ */ y(Fn, {
      id: s,
      ref: a,
      value: e,
      min: l == null ? void 0 : l.min,
      max: l == null ? void 0 : l.max,
      presentation: "date",
      isDateEnabled: (f) => {
        const g = ni(f, l.disabledDateRanges);
        return ri(f) && !g;
      },
      onIonChange: (f) => {
        i == null || i(
          // Purposely convert to ISO date so to ignore time and timezone
          // TODO: Why are we getting this TS error, maybe the DateTime
          // will not throw on invalid dates? So add the Luxon setting update.
          // Investigate in https://linear.app/swing-education/issue/MKTP-946
          gt.fromISO(f.detail.value).toISODate()
        );
      },
      children: /* @__PURE__ */ y("slot", {
        slot: "buttons",
        children: /* @__PURE__ */ x("div", {
          css: {
            width: 300,
            paddingLeft: 6,
            // Since the component adds 10px padding
            paddingRight: 6,
            // Since the component adds 10px padding
            paddingBottom: 6,
            // Since the component adds 10px padding
            display: "flex",
            flexDirection: "column",
            gap: 16
          },
          children: [r && /* @__PURE__ */ y("div", {
            css: {
              backgroundColor: C.slate200,
              borderRadius: 8,
              padding: 8
            },
            children: /* @__PURE__ */ y("p", {
              css: {
                margin: 0,
                fontSize: 12,
                fontWeight: 400,
                lineHeight: "16px"
              },
              children: r
            })
          }), /* @__PURE__ */ x("div", {
            css: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center"
            },
            children: [/* @__PURE__ */ y("button", {
              css: {
                ...He.datePickerButton,
                color: C.red500
              },
              onClick: () => {
                var f;
                return (f = a.current) == null ? void 0 : f.cancel(!0);
              },
              children: P("DATE_INPUT_CANCEL_LABEL")
            }), /* @__PURE__ */ y("button", {
              css: He.datePickerButton,
              onClick: () => {
                var f;
                return (f = a == null ? void 0 : a.current) == null ? void 0 : f.confirm(!0);
              },
              children: P("DATE_INPUT_DONE_LABEL")
            })]
          })]
        })
      })
    })
  });
}
const Tt = 130, bo = 24, He = {
  button: {
    height: bo,
    padding: "0 8px",
    borderRadius: 8,
    fontSize: 16,
    lineHeight: "24px",
    textAlign: "center",
    color: "black",
    marginLeft: "auto",
    alignItems: "center",
    background: C.slate200
  },
  datePickerButton: {
    fontSize: 16,
    color: C.blue500,
    background: "transparent"
  }
}, Io = "_errorBlock_3g7j4_1", Do = {
  errorBlock: Io
};
function Wn(e) {
  const {
    children: t,
    customStyles: n
  } = e;
  return /* @__PURE__ */ x("div", {
    className: Do.errorBlock,
    style: n,
    children: [/* @__PURE__ */ y(ne, {
      name: "Alert",
      color: C.red500
    }), t]
  });
}
function th(e) {
  const {
    value: t,
    placeholder: n = "Enter Time",
    onChange: r,
    initialValue: i = gt.now(),
    showTextInputOnDesktop: o = !1,
    isDisabled: s,
    min: a,
    max: l,
    readOnly: f
  } = e, g = mo(fo.mediumDeviceAndUp);
  return f ? t ? Xe({
    date: t,
    format: "1:00 pm"
  }) : "" : /* @__PURE__ */ y(Ze, {
    children: g && o ? /* @__PURE__ */ y(Ro, {
      value: t,
      placeholder: n,
      isDisabled: s,
      initialValue: i,
      min: a,
      max: l,
      onChange: r
    }) : /* @__PURE__ */ y(xo, {
      value: t,
      placeholder: n,
      isDisabled: s,
      initialValue: i,
      min: a,
      max: l,
      onChange: r
    })
  });
}
function Ro(e) {
  const {
    value: t,
    placeholder: n,
    isDisabled: r,
    initialValue: i,
    min: o,
    max: s,
    onChange: a
  } = e, [l, f] = de(t ? Xe({
    date: t,
    format: "1:00 pm"
  }) : "");
  We(() => {
    t ? Xe({
      date: t,
      format: "1:00 pm"
    }) !== l && f(Xe({
      date: t,
      format: "1:00 pm"
    })) : f("");
  }, [t]);
  function g(p) {
    if (!p) return;
    const m = Oo(p);
    if (!m)
      return f(t ? Xe({
        date: t,
        format: "1:00 pm"
      }) : "");
    const E = (t || i).set({
      hour: m.hours,
      minute: m.minutes,
      second: 0,
      millisecond: 0
    });
    return E && Po({
      dateTime: E,
      min: o,
      max: s
    }) && E !== t ? a(E) : t && f(Xe({
      date: t,
      format: "1:00 pm"
    }));
  }
  return /* @__PURE__ */ y("input", {
    type: "text",
    placeholder: n,
    maxLength: 8,
    value: l,
    disabled: r,
    onChange: (p) => f(p.target.value),
    onKeyDown: (p) => {
      p.key === "Enter" && p.target.blur();
    },
    onBlur: () => {
      l && g(l);
    },
    css: {
      // Style the placeholder text
      "&::placeholder": {
        ...ii
      },
      // Basic input styling
      fontSize: 16,
      fontWeight: 400,
      borderRadius: 8,
      background: C.slate200,
      border: "none",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // Apply shared component styles (padding, dimensions, etc.)
      ...hn,
      // Apply disabled styling if needed (grayed out text)
      ...r && dn
    }
  });
}
function xo(e) {
  const {
    value: t,
    placeholder: n,
    isDisabled: r,
    initialValue: i,
    min: o,
    max: s,
    onChange: a
  } = e, l = Ft(), [f, g] = de(!1), p = (
    // If the `min` prop is provided, transform it to an ISO string
    (o == null ? void 0 : o.toISO({
      suppressMilliseconds: !0,
      suppressSeconds: !0
    })) ?? // Otherwise, use the `max` prop to set the `min` time to the start of day
    // NOTE: This is done to make sure that these are on the same day, as
    // DateTime.now() could be a different day.
    (s == null ? void 0 : s.startOf("day").toISO({
      suppressMilliseconds: !0,
      suppressSeconds: !0
    })) ?? void 0
  ), m = (
    // If the `max` prop is provided, transform it to an ISO string
    (s == null ? void 0 : s.toISO({
      suppressMilliseconds: !0,
      suppressSeconds: !0
    })) ?? // Otherwise, use the `min` prop to set the `max` time to the end of day
    // NOTE: This is done to make sure that these are on the same day, as
    // DateTime.now() could be a different day.
    (o == null ? void 0 : o.endOf("day").toISO({
      suppressMilliseconds: !0,
      suppressSeconds: !0
    })) ?? void 0
  );
  return /* @__PURE__ */ x(Ze, {
    children: [/* @__PURE__ */ y("div", {
      css: {
        display: t ? "none" : "block"
      },
      children: /* @__PURE__ */ y("button", {
        disabled: r,
        onClick: () => {
          r || g(!0);
        },
        css: {
          fontSize: 16,
          fontWeight: 400,
          borderRadius: 8,
          background: C.slate200,
          border: "none",
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          // Apply placeholder styling (gray text)
          ...ii,
          // Apply shared input styles (padding, dimensions)
          ...hn,
          // Apply disabled styling if needed (grayed out)
          ...r && dn
        },
        children: n
      })
    }), /* @__PURE__ */ y("div", {
      css: {
        display: t ? "block" : "none"
      },
      children: /* @__PURE__ */ y(Jr, {
        onClick: () => {
          r || g(!0);
        },
        datetime: l,
        disabled: r,
        css: {
          // To change the background color of the input itself.
          // See https://ionicframework.com/docs/api/datetime-button#css-shadow-parts
          "&::part(native)": {
            backgroundColor: C.slate200,
            // To lowercase the AM/PM (e.g., "2:30 pm" instead of "2:30 PM")
            textTransform: "lowercase",
            // Apply shared input styles (padding, dimensions)
            ...hn,
            // Apply disabled styling if needed (grayed out)
            ...r && dn
          }
        }
      })
    }), /* @__PURE__ */ y(kn, {
      isOpen: f,
      keepContentsMounted: !0,
      className: "stackedModal ion-datetime-button-overlay",
      backdropDismiss: !0,
      onDidDismiss: () => {
        g(!1);
      },
      children: /* @__PURE__ */ y(Fn, {
        showDefaultButtons: !0,
        className: "lowercase",
        id: l,
        presentation: "time",
        value: t ? t.toISO() : i.toISO(),
        min: p,
        max: m,
        onIonChange: (E) => {
          a(gt.fromISO(E.detail.value));
        }
      })
    })]
  });
}
const hn = {
  // TODO: The following styles do not match the Figma design due to the
  // `IonDateTimeButton` component using these styles. To resolve this,
  // we must update the `IonDatetimeButton` as well.
  width: "100%",
  maxWidth: 100,
  margin: 0,
  paddingLeft: 8,
  paddingRight: 8,
  paddingTop: 0,
  paddingBottom: 0,
  lineHeight: "24px",
  textAlign: "center",
  outline: "none",
  whiteSpace: "nowrap"
}, dn = {
  color: C.slate400
}, ii = {
  color: C.slate600
}, Oo = (e) => {
  const t = /^([1-9]|1[0-2]):([0-5][0-9])\s?([AaPp][Mm])$/, n = /^([0-9]|[01][0-9]|2[0-3]):([0-5][0-9])$/;
  if (!t.test(e) && !n.test(e))
    return;
  const r = e.match(t);
  if (r) {
    let o = Number(r[1]);
    const s = Number(r[2]), a = r[3].toUpperCase();
    return a === "AM" && o === 12 ? o = 0 : a === "PM" && o !== 12 && (o = o + 12), {
      hours: o,
      minutes: s
    };
  }
  const i = e.match(n);
  if (i)
    return {
      hours: Number(i[1]),
      minutes: Number(i[2])
    };
};
function Po({
  dateTime: e,
  min: t,
  max: n
}) {
  if (t && n && t > n)
    throw new Error(`TimeInput.tsx isTimeWithinConstraints(): min (${t.toFormat("h:mm a")}) cannot be greater than max (${n.toFormat("h:mm a")})`);
  if (t && n && n < t)
    throw new Error(`TimeInput.tsx isTimeWithinConstraints(): max (${n.toFormat("h:mm a")}) cannot be smaller than min (${t.toFormat("h:mm a")})`);
  return !(t && e < t || n && e > n);
}
var oi = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(e) {
  (function() {
    var t = {}.hasOwnProperty;
    function n() {
      for (var o = "", s = 0; s < arguments.length; s++) {
        var a = arguments[s];
        a && (o = i(o, r.call(this, a)));
      }
      return o;
    }
    function r(o) {
      if (typeof o == "string" || typeof o == "number")
        return this && this[o] || o;
      if (typeof o != "object")
        return "";
      if (Array.isArray(o))
        return n.apply(this, o);
      if (o.toString !== Object.prototype.toString && !o.toString.toString().includes("[native code]"))
        return o.toString();
      var s = "";
      for (var a in o)
        t.call(o, a) && o[a] && (s = i(s, this && this[a] || a));
      return s;
    }
    function i(o, s) {
      return s ? o ? o + " " + s : o + s : o;
    }
    e.exports ? (n.default = n, e.exports = n) : window.classNames = n;
  })();
})(oi);
var Uo = oi.exports;
const No = /* @__PURE__ */ Hn(Uo), Lo = "_danger_1l53h_27", Fo = "_success_1l53h_33", ko = "_warning_1l53h_39", Bo = "_info_1l53h_45", Mo = "_disclaimer_1l53h_51", re = {
  "alert-box": "_alert-box_1l53h_1",
  "alert-box-grid": "_alert-box-grid_1l53h_13",
  "alert-box-header": "_alert-box-header_1l53h_20",
  "alert-box-body": "_alert-box-body_1l53h_21",
  danger: Lo,
  success: Fo,
  warning: ko,
  info: Bo,
  disclaimer: Mo,
  "mt-1": "_mt-1_1l53h_57",
  "col-span-full": "_col-span-full_1l53h_61",
  "col-span-1": "_col-span-1_1l53h_65",
  "col-start-1": "_col-start-1_1l53h_69",
  "col-span-2": "_col-span-2_1l53h_73",
  "col-start-2": "_col-start-2_1l53h_77"
}, Qt = No.bind(re);
function mt(e) {
  const {
    color: t,
    title: n,
    showIcon: r = !1,
    children: i,
    className: o,
    onDismiss: s = null
  } = e, a = Ho(t);
  return /* @__PURE__ */ y("div", {
    className: `${re["alert-box"]} ${re[t]} ${o || ""}`,
    children: /* @__PURE__ */ x("div", {
      className: Qt(`${re["alert-box-grid"]}`),
      children: [r && a && /* @__PURE__ */ y("div", {
        css: {
          display: "flex",
          alignItems: "start"
        },
        children: a
      }), n && /* @__PURE__ */ y("div", {
        className: Qt({
          [`${re["alert-box-header"]}`]: !0,
          [`${re["col-span-full"]}`]: !r && !s,
          [`${re["col-start-1"]}`]: !r && s,
          [`${re["col-start-2"]}`]: r && !s,
          [`${re["col-span-2"]}`]: (r || s) && !(r && s)
        }),
        children: /* @__PURE__ */ y("h5", {
          css: {
            marginLeft: 0,
            marginRight: 0,
            marginTop: 0,
            marginBottom: 0,
            // Override the font size for h5 tags
            fontSize: "16px !important",
            fontWeight: 600
          },
          children: n
        })
      }), n && /* @__PURE__ */ y(lr, {
        onDismiss: s
      }), i && /* @__PURE__ */ y("div", {
        css: {
          fontSize: 16,
          fontWeight: 400
        },
        className: Qt({
          [`${re["alert-box-body"]}`]: !0,
          [`${re["col-span-full"]}`]: !r && !s,
          [`${re["col-start-1"]}`]: !r && s,
          [`${re["col-start-2"]}`]: r,
          [`${re["col-span-1"]}`]: r && s,
          [`${re["col-span-2"]}`]: (r || s) && !(r && s)
        }),
        children: i
      }), !n && /* @__PURE__ */ y(lr, {
        onDismiss: s
      })]
    })
  });
}
function lr(e) {
  const {
    onDismiss: t
  } = e;
  return t ? /* @__PURE__ */ y("button", {
    onClick: t,
    css: {
      backgroundColor: "transparent"
    },
    children: /* @__PURE__ */ y(ne, {
      name: "Close"
    })
  }) : null;
}
function Ho(e) {
  switch (e) {
    case "danger":
      return /* @__PURE__ */ y(ne, {
        name: "Alert",
        color: C.red500
      });
    case "success":
      return /* @__PURE__ */ y(ne, {
        name: "Check Circle",
        color: C.green500
      });
    case "warning":
      return /* @__PURE__ */ y(ne, {
        name: "Alert",
        color: C.yellow600
      });
    case "info":
      return /* @__PURE__ */ y(ne, {
        name: "Info",
        color: C.purple500
      });
    case "disclaimer":
      return /* @__PURE__ */ y(ne, {
        name: "Info",
        color: C.blue600
      });
  }
}
function Go(e) {
  const t = Ft(), {
    app: n,
    buildProfile: r,
    email: i,
    error: o,
    platform: s,
    provider: a,
    readOnly: l
  } = e, f = "onEmailInput" in e ? e.onEmailInput : () => {
  }, g = "onEmailEdit" in e ? e.onEmailEdit : () => {
  };
  return /* @__PURE__ */ x("div", {
    css: {
      width: "inherit"
    },
    children: [/* @__PURE__ */ y("label", {
      htmlFor: t,
      css: {
        color: C.black,
        fontWeight: "var(--swing-font-medium)",
        paddingLeft: 16
      },
      children: P("EMAIL_FIELD_LOGIN_INPUT_PLACEHOLDER")
    }), /* @__PURE__ */ x("div", {
      css: {
        display: "flex",
        width: "100%",
        borderBottom: "1px solid",
        borderColor: o ? C.red500 : C.slate400
      },
      children: [/* @__PURE__ */ y(Bn, {
        id: t,
        type: "email",
        name: "email",
        value: i,
        onIonInput: (p) => {
          f(p.detail.value);
        },
        spellCheck: "false",
        readonly: l,
        "aria-label": P("EMAIL_FIELD_LOGIN_INPUT_PLACEHOLDER"),
        inputmode: "email",
        css: {
          paddingLeft: "16px !important",
          "--highlight-color-focused": "none"
        }
      }), l && /* @__PURE__ */ y("button", {
        type: "button",
        onClick: () => g(i),
        "aria-pressed": "true",
        "aria-label": P("EMAIL_FIELD_LOGIN_INPUT_ARIA_EDIT_LABEL"),
        css: {
          background: "none"
        },
        children: /* @__PURE__ */ y(ne, {
          name: "Edit",
          color: C.blue500
        })
      })]
    }), o && /* @__PURE__ */ y(Oa, {
      app: n,
      buildProfile: r,
      error: o,
      platform: s,
      provider: a
    })]
  });
}
function nh(e) {
  const {
    content: t,
    hasDivider: n,
    badge: r,
    leftIcon: i,
    rightIcon: o
  } = e, s = Wo({
    hasLeftIcon: !!i,
    hasRightIcon: !!(o != null && o.icon)
  });
  return /* @__PURE__ */ x(Ze, {
    children: [/* @__PURE__ */ x("div", {
      css: [Ve.row, s],
      children: [i && i, /* @__PURE__ */ x("div", {
        css: Ve.contentRow,
        children: [/* @__PURE__ */ y("div", {
          children: t
        }), r && /* @__PURE__ */ y("div", {
          css: {
            flexShrink: 0
          },
          children: /* @__PURE__ */ y(_o, {
            status: r.status,
            text: r.text
          })
        })]
      }), (o == null ? void 0 : o.icon) && /* @__PURE__ */ y("span", {
        css: {
          cursor: "pointer"
        },
        onClick: o.onClick,
        children: o.icon
      })]
    }), n && /* @__PURE__ */ y("div", {
      css: Ve.divider
    })]
  });
}
function Wo(e) {
  const {
    hasLeftIcon: t,
    hasRightIcon: n
  } = e;
  return t && n ? Ve.iconBoth : t ? Ve.iconLeft : n ? Ve.iconRight : Ve.iconNone;
}
const Ve = {
  row: {
    display: "grid",
    gap: "0 16px",
    padding: "14px 16px"
  },
  iconNone: {
    gridTemplateColumns: "1fr"
  },
  iconLeft: {
    gridTemplateColumns: "24px 1fr"
  },
  iconRight: {
    gridTemplateColumns: "1fr 24px"
  },
  iconBoth: {
    gridTemplateColumns: "24px 1fr 24px"
  },
  divider: {
    width: "100%",
    height: 1,
    backgroundColor: C.slate200
  },
  contentRow: {
    display: "flex",
    alignItems: "center",
    gap: 8
  }
}, Vo = "_passwordToggle_rixpr_1", $o = "_backgroundGray_rixpr_9", jo = "_showLabel_rixpr_14", Ko = "_inputError_rixpr_18", lt = {
  passwordToggle: Vo,
  backgroundGray: $o,
  showLabel: jo,
  inputError: Ko,
  "icon-tooltip": "_icon-tooltip_rixpr_22"
};
function si(e) {
  const {
    passwordLabel: t,
    onPasswordInput: n,
    error: r,
    password: i
  } = e, [o, s] = de(!1);
  return /* @__PURE__ */ x("div", {
    style: {
      width: "inherit"
    },
    children: [/* @__PURE__ */ y(Qr, {
      className: "ion-padding-start ion-no-border",
      children: /* @__PURE__ */ y(Mn, {
        style: {
          fontWeight: "var(--swing-font-medium)"
        },
        children: t
      })
    }), /* @__PURE__ */ x(Zr, {
      lines: "full",
      className: `${lt.backgroundGray} ${r ? lt.inputError : ""}`,
      css: {
        width: "100%",
        "--border-color": C.slate400,
        "--min-height": "auto"
      },
      children: [/* @__PURE__ */ y(Bn, {
        "data-testid": "password-input",
        type: o ? "text" : "password",
        value: i,
        onIonInput: (a) => n(a.detail.value || ""),
        spellCheck: "false",
        "aria-label": t,
        clearOnEdit: !1
      }), /* @__PURE__ */ y(qo, {
        showPassword: o,
        onShowPassword: (a) => s(a)
      })]
    }), r && /* @__PURE__ */ y(zo, {
      error: r
    })]
  });
}
const zo = ({
  error: e
}) => /* @__PURE__ */ y(Wn, {
  customStyles: {
    fontSize: 14
  },
  children: /* @__PURE__ */ y("span", {
    children: e
  })
});
function qo(e) {
  const {
    showPassword: t,
    onShowPassword: n
  } = e, r = t ? se("PASSWORD_FIELD_LOGIN_PASSWORD_HIDE_LABEL") : se("PASSWORD_FIELD_LOGIN_PASSWORD_SHOW_LABEL"), i = t ? se("PASSWORD_FIELD_LOGIN_PASSWORD_ARIA_HIDE_LABEL") : se("PASSWORD_FIELD_LOGIN_PASSWORD_ARIA_SHOW_LABEL");
  return /* @__PURE__ */ x("button", {
    type: "button",
    onClick: () => n(!t),
    "aria-pressed": t,
    "aria-label": i,
    className: lt.passwordToggle,
    children: [t ? /* @__PURE__ */ y(ne, {
      name: "Eye Off",
      color: C.blue500
    }) : /* @__PURE__ */ y(ne, {
      name: "Eye On",
      color: C.blue500
    }), /* @__PURE__ */ y("span", {
      className: `${lt["icon-tooltip"]} ${lt.showLabel}`,
      style: {
        fontWeight: "var(--swing-font-medium)"
      },
      children: r
    })]
  });
}
const Yo = "_validationSuccess_1gwiy_1", Xo = "_validationFailure_1gwiy_5", Jo = "_validationContainer_1gwiy_9", Zo = "_validationList_1gwiy_17", Qo = "_validationItem_1gwiy_22", ft = {
  validationSuccess: Yo,
  validationFailure: Xo,
  validationContainer: Jo,
  validationList: Zo,
  validationItem: Qo
};
function es(e) {
  const {
    validationObject: t
  } = e;
  return /* @__PURE__ */ x("div", {
    className: ft.validationContainer,
    style: {
      width: "inherit"
    },
    children: [/* @__PURE__ */ x(Mn, {
      style: {
        fontWeight: "var(--swing-font-medium)"
      },
      children: [se("PASSWORD_VALIDATION_FIELD_RESET_PASSWORD_VALIDATION_LABEL"), ":"]
    }), /* @__PURE__ */ y("ul", {
      className: ft.validationList,
      children: t.map((n, r) => /* @__PURE__ */ y(ts, {
        isPasswordValid: n.isValid,
        validationMessage: n.message
      }, r))
    })]
  });
}
function ts(e) {
  const {
    isPasswordValid: t,
    validationMessage: n
  } = e;
  return /* @__PURE__ */ y("li", {
    className: `${t ? ft.validationSuccess : ft.validationFailure} ${ft.validationItem}`,
    children: /* @__PURE__ */ x("div", {
      style: {
        display: "flex"
      },
      children: [n, " ", t ? /* @__PURE__ */ y(ne, {
        name: "Check",
        color: C.green500
      }) : /* @__PURE__ */ y(ne, {
        name: "Close",
        color: C.red500
      })]
    })
  });
}
const bt = {
  RESET_VALIDATION_UPPERCASE: "(?=.*[A-Z])",
  RESET_VALIDATION_LOWERCASE: "(?=.*[a-z])",
  RESET_VALIDATION_NUMBER: "(?=.*?[0-9])",
  RESET_VALIDATION_MIN_CHARACTERS: ".{8,}"
};
var ai = {}, Vn = {}, $n = {}, $e = {}, jn = {}, Kn = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.Doctype = e.CDATA = e.Tag = e.Style = e.Script = e.Comment = e.Directive = e.Text = e.Root = e.isTag = e.ElementType = void 0;
  var t;
  (function(r) {
    r.Root = "root", r.Text = "text", r.Directive = "directive", r.Comment = "comment", r.Script = "script", r.Style = "style", r.Tag = "tag", r.CDATA = "cdata", r.Doctype = "doctype";
  })(t = e.ElementType || (e.ElementType = {}));
  function n(r) {
    return r.type === t.Tag || r.type === t.Script || r.type === t.Style;
  }
  e.isTag = n, e.Root = t.Root, e.Text = t.Text, e.Directive = t.Directive, e.Comment = t.Comment, e.Script = t.Script, e.Style = t.Style, e.Tag = t.Tag, e.CDATA = t.CDATA, e.Doctype = t.Doctype;
})(Kn);
var N = {}, Ue = j && j.__extends || /* @__PURE__ */ function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i) Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    if (typeof n != "function" && n !== null)
      throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), ht = j && j.__assign || function() {
  return ht = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, ht.apply(this, arguments);
};
Object.defineProperty(N, "__esModule", { value: !0 });
N.cloneNode = N.hasChildren = N.isDocument = N.isDirective = N.isComment = N.isText = N.isCDATA = N.isTag = N.Element = N.Document = N.CDATA = N.NodeWithChildren = N.ProcessingInstruction = N.Comment = N.Text = N.DataNode = N.Node = void 0;
var ae = Kn, zn = (
  /** @class */
  function() {
    function e() {
      this.parent = null, this.prev = null, this.next = null, this.startIndex = null, this.endIndex = null;
    }
    return Object.defineProperty(e.prototype, "parentNode", {
      // Read-write aliases for properties
      /**
       * Same as {@link parent}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.parent;
      },
      set: function(t) {
        this.parent = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "previousSibling", {
      /**
       * Same as {@link prev}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.prev;
      },
      set: function(t) {
        this.prev = t;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "nextSibling", {
      /**
       * Same as {@link next}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.next;
      },
      set: function(t) {
        this.next = t;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.cloneNode = function(t) {
      return t === void 0 && (t = !1), qn(this, t);
    }, e;
  }()
);
N.Node = zn;
var kt = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.data = n, r;
    }
    return Object.defineProperty(t.prototype, "nodeValue", {
      /**
       * Same as {@link data}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.data;
      },
      set: function(n) {
        this.data = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(zn)
);
N.DataNode = kt;
var ci = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = ae.ElementType.Text, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 3;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(kt)
);
N.Text = ci;
var ui = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = ae.ElementType.Comment, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 8;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(kt)
);
N.Comment = ui;
var li = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t(n, r) {
      var i = e.call(this, r) || this;
      return i.name = n, i.type = ae.ElementType.Directive, i;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(kt)
);
N.ProcessingInstruction = li;
var Bt = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t(n) {
      var r = e.call(this) || this;
      return r.children = n, r;
    }
    return Object.defineProperty(t.prototype, "firstChild", {
      // Aliases
      /** First child of the node. */
      get: function() {
        var n;
        return (n = this.children[0]) !== null && n !== void 0 ? n : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "lastChild", {
      /** Last child of the node. */
      get: function() {
        return this.children.length > 0 ? this.children[this.children.length - 1] : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "childNodes", {
      /**
       * Same as {@link children}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.children;
      },
      set: function(n) {
        this.children = n;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(zn)
);
N.NodeWithChildren = Bt;
var fi = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = ae.ElementType.CDATA, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 4;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Bt)
);
N.CDATA = fi;
var hi = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.type = ae.ElementType.Root, n;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 9;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Bt)
);
N.Document = hi;
var di = (
  /** @class */
  function(e) {
    Ue(t, e);
    function t(n, r, i, o) {
      i === void 0 && (i = []), o === void 0 && (o = n === "script" ? ae.ElementType.Script : n === "style" ? ae.ElementType.Style : ae.ElementType.Tag);
      var s = e.call(this, i) || this;
      return s.name = n, s.attribs = r, s.type = o, s;
    }
    return Object.defineProperty(t.prototype, "nodeType", {
      get: function() {
        return 1;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "tagName", {
      // DOM Level 1 aliases
      /**
       * Same as {@link name}.
       * [DOM spec](https://dom.spec.whatwg.org)-compatible alias.
       */
      get: function() {
        return this.name;
      },
      set: function(n) {
        this.name = n;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "attributes", {
      get: function() {
        var n = this;
        return Object.keys(this.attribs).map(function(r) {
          var i, o;
          return {
            name: r,
            value: n.attribs[r],
            namespace: (i = n["x-attribsNamespace"]) === null || i === void 0 ? void 0 : i[r],
            prefix: (o = n["x-attribsPrefix"]) === null || o === void 0 ? void 0 : o[r]
          };
        });
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }(Bt)
);
N.Element = di;
function pi(e) {
  return (0, ae.isTag)(e);
}
N.isTag = pi;
function gi(e) {
  return e.type === ae.ElementType.CDATA;
}
N.isCDATA = gi;
function mi(e) {
  return e.type === ae.ElementType.Text;
}
N.isText = mi;
function vi(e) {
  return e.type === ae.ElementType.Comment;
}
N.isComment = vi;
function yi(e) {
  return e.type === ae.ElementType.Directive;
}
N.isDirective = yi;
function Si(e) {
  return e.type === ae.ElementType.Root;
}
N.isDocument = Si;
function ns(e) {
  return Object.prototype.hasOwnProperty.call(e, "children");
}
N.hasChildren = ns;
function qn(e, t) {
  t === void 0 && (t = !1);
  var n;
  if (mi(e))
    n = new ci(e.data);
  else if (vi(e))
    n = new ui(e.data);
  else if (pi(e)) {
    var r = t ? en(e.children) : [], i = new di(e.name, ht({}, e.attribs), r);
    r.forEach(function(l) {
      return l.parent = i;
    }), e.namespace != null && (i.namespace = e.namespace), e["x-attribsNamespace"] && (i["x-attribsNamespace"] = ht({}, e["x-attribsNamespace"])), e["x-attribsPrefix"] && (i["x-attribsPrefix"] = ht({}, e["x-attribsPrefix"])), n = i;
  } else if (gi(e)) {
    var r = t ? en(e.children) : [], o = new fi(r);
    r.forEach(function(f) {
      return f.parent = o;
    }), n = o;
  } else if (Si(e)) {
    var r = t ? en(e.children) : [], s = new hi(r);
    r.forEach(function(f) {
      return f.parent = s;
    }), e["x-mode"] && (s["x-mode"] = e["x-mode"]), n = s;
  } else if (yi(e)) {
    var a = new li(e.name, e.data);
    e["x-name"] != null && (a["x-name"] = e["x-name"], a["x-publicId"] = e["x-publicId"], a["x-systemId"] = e["x-systemId"]), n = a;
  } else
    throw new Error("Not implemented yet: ".concat(e.type));
  return n.startIndex = e.startIndex, n.endIndex = e.endIndex, e.sourceCodeLocation != null && (n.sourceCodeLocation = e.sourceCodeLocation), n;
}
N.cloneNode = qn;
function en(e) {
  for (var t = e.map(function(r) {
    return qn(r, !0);
  }), n = 1; n < t.length; n++)
    t[n].prev = t[n - 1], t[n - 1].next = t[n];
  return t;
}
(function(e) {
  var t = j && j.__createBinding || (Object.create ? function(a, l, f, g) {
    g === void 0 && (g = f);
    var p = Object.getOwnPropertyDescriptor(l, f);
    (!p || ("get" in p ? !l.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return l[f];
    } }), Object.defineProperty(a, g, p);
  } : function(a, l, f, g) {
    g === void 0 && (g = f), a[g] = l[f];
  }), n = j && j.__exportStar || function(a, l) {
    for (var f in a) f !== "default" && !Object.prototype.hasOwnProperty.call(l, f) && t(l, a, f);
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.DomHandler = void 0;
  var r = Kn, i = N;
  n(N, e);
  var o = {
    withStartIndices: !1,
    withEndIndices: !1,
    xmlMode: !1
  }, s = (
    /** @class */
    function() {
      function a(l, f, g) {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null, typeof f == "function" && (g = f, f = o), typeof l == "object" && (f = l, l = void 0), this.callback = l ?? null, this.options = f ?? o, this.elementCB = g ?? null;
      }
      return a.prototype.onparserinit = function(l) {
        this.parser = l;
      }, a.prototype.onreset = function() {
        this.dom = [], this.root = new i.Document(this.dom), this.done = !1, this.tagStack = [this.root], this.lastNode = null, this.parser = null;
      }, a.prototype.onend = function() {
        this.done || (this.done = !0, this.parser = null, this.handleCallback(null));
      }, a.prototype.onerror = function(l) {
        this.handleCallback(l);
      }, a.prototype.onclosetag = function() {
        this.lastNode = null;
        var l = this.tagStack.pop();
        this.options.withEndIndices && (l.endIndex = this.parser.endIndex), this.elementCB && this.elementCB(l);
      }, a.prototype.onopentag = function(l, f) {
        var g = this.options.xmlMode ? r.ElementType.Tag : void 0, p = new i.Element(l, f, void 0, g);
        this.addNode(p), this.tagStack.push(p);
      }, a.prototype.ontext = function(l) {
        var f = this.lastNode;
        if (f && f.type === r.ElementType.Text)
          f.data += l, this.options.withEndIndices && (f.endIndex = this.parser.endIndex);
        else {
          var g = new i.Text(l);
          this.addNode(g), this.lastNode = g;
        }
      }, a.prototype.oncomment = function(l) {
        if (this.lastNode && this.lastNode.type === r.ElementType.Comment) {
          this.lastNode.data += l;
          return;
        }
        var f = new i.Comment(l);
        this.addNode(f), this.lastNode = f;
      }, a.prototype.oncommentend = function() {
        this.lastNode = null;
      }, a.prototype.oncdatastart = function() {
        var l = new i.Text(""), f = new i.CDATA([l]);
        this.addNode(f), l.parent = f, this.lastNode = l;
      }, a.prototype.oncdataend = function() {
        this.lastNode = null;
      }, a.prototype.onprocessinginstruction = function(l, f) {
        var g = new i.ProcessingInstruction(l, f);
        this.addNode(g);
      }, a.prototype.handleCallback = function(l) {
        if (typeof this.callback == "function")
          this.callback(l, this.dom);
        else if (l)
          throw l;
      }, a.prototype.addNode = function(l) {
        var f = this.tagStack[this.tagStack.length - 1], g = f.children[f.children.length - 1];
        this.options.withStartIndices && (l.startIndex = this.parser.startIndex), this.options.withEndIndices && (l.endIndex = this.parser.endIndex), f.children.push(l), g && (l.prev = g, g.next = l), l.parent = f, this.lastNode = null;
      }, a;
    }()
  );
  e.DomHandler = s, e.default = s;
})(jn);
var Ei = {};
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.CARRIAGE_RETURN_PLACEHOLDER_REGEX = e.CARRIAGE_RETURN_PLACEHOLDER = e.CARRIAGE_RETURN_REGEX = e.CARRIAGE_RETURN = e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES = void 0, e.CASE_SENSITIVE_TAG_NAMES = [
    "animateMotion",
    "animateTransform",
    "clipPath",
    "feBlend",
    "feColorMatrix",
    "feComponentTransfer",
    "feComposite",
    "feConvolveMatrix",
    "feDiffuseLighting",
    "feDisplacementMap",
    "feDropShadow",
    "feFlood",
    "feFuncA",
    "feFuncB",
    "feFuncG",
    "feFuncR",
    "feGaussianBlur",
    "feImage",
    "feMerge",
    "feMergeNode",
    "feMorphology",
    "feOffset",
    "fePointLight",
    "feSpecularLighting",
    "feSpotLight",
    "feTile",
    "feTurbulence",
    "foreignObject",
    "linearGradient",
    "radialGradient",
    "textPath"
  ], e.CASE_SENSITIVE_TAG_NAMES_MAP = e.CASE_SENSITIVE_TAG_NAMES.reduce(function(t, n) {
    return t[n.toLowerCase()] = n, t;
  }, {}), e.CARRIAGE_RETURN = "\r", e.CARRIAGE_RETURN_REGEX = new RegExp(e.CARRIAGE_RETURN, "g"), e.CARRIAGE_RETURN_PLACEHOLDER = "__HTML_DOM_PARSER_CARRIAGE_RETURN_PLACEHOLDER_".concat(Date.now(), "__"), e.CARRIAGE_RETURN_PLACEHOLDER_REGEX = new RegExp(e.CARRIAGE_RETURN_PLACEHOLDER, "g");
})(Ei);
Object.defineProperty($e, "__esModule", { value: !0 });
$e.formatAttributes = _i;
$e.escapeSpecialCharacters = os;
$e.revertEscapedCharacters = wi;
$e.formatDOM = Ai;
var It = jn, vt = Ei;
function rs(e) {
  return vt.CASE_SENSITIVE_TAG_NAMES_MAP[e];
}
function _i(e) {
  for (var t = {}, n = 0, r = e.length; n < r; n++) {
    var i = e[n];
    t[i.name] = i.value;
  }
  return t;
}
function is(e) {
  e = e.toLowerCase();
  var t = rs(e);
  return t || e;
}
function os(e) {
  return e.replace(vt.CARRIAGE_RETURN_REGEX, vt.CARRIAGE_RETURN_PLACEHOLDER);
}
function wi(e) {
  return e.replace(vt.CARRIAGE_RETURN_PLACEHOLDER_REGEX, vt.CARRIAGE_RETURN);
}
function Ai(e, t, n) {
  t === void 0 && (t = null);
  for (var r = [], i, o = 0, s = e.length; o < s; o++) {
    var a = e[o];
    switch (a.nodeType) {
      case 1: {
        var l = is(a.nodeName);
        i = new It.Element(l, _i(a.attributes)), i.children = Ai(
          // template children are on content
          l === "template" ? a.content.childNodes : a.childNodes,
          i
        );
        break;
      }
      case 3:
        i = new It.Text(wi(a.nodeValue));
        break;
      case 8:
        i = new It.Comment(a.nodeValue);
        break;
      default:
        continue;
    }
    var f = r[o - 1] || null;
    f && (f.next = i), i.parent = t, i.prev = f, i.next = null, r.push(i);
  }
  return n && (i = new It.ProcessingInstruction(n.substring(0, n.indexOf(" ")).toLowerCase(), n), i.next = r[0] || null, i.parent = t, r.unshift(i), r[1] && (r[1].prev = r[0])), r;
}
Object.defineProperty($n, "__esModule", { value: !0 });
$n.default = ls;
var ss = $e, fr = "html", hr = "head", Dt = "body", as = /<([a-zA-Z]+[0-9]?)/, dr = /<head[^]*>/i, pr = /<body[^]*>/i, Ut = function(e, t) {
  throw new Error("This browser does not support `document.implementation.createHTMLDocument`");
}, pn = function(e, t) {
  throw new Error("This browser does not support `DOMParser.prototype.parseFromString`");
}, gr = typeof window == "object" && window.DOMParser;
if (typeof gr == "function") {
  var cs = new gr(), us = "text/html";
  pn = function(e, t) {
    return t && (e = "<".concat(t, ">").concat(e, "</").concat(t, ">")), cs.parseFromString(e, us);
  }, Ut = pn;
}
if (typeof document == "object" && document.implementation) {
  var Rt = document.implementation.createHTMLDocument();
  Ut = function(e, t) {
    if (t) {
      var n = Rt.documentElement.querySelector(t);
      return n && (n.innerHTML = e), Rt;
    }
    return Rt.documentElement.innerHTML = e, Rt;
  };
}
var xt = typeof document == "object" && document.createElement("template"), gn;
xt && xt.content && (gn = function(e) {
  return xt.innerHTML = e, xt.content.childNodes;
});
function ls(e) {
  var t, n;
  e = (0, ss.escapeSpecialCharacters)(e);
  var r = e.match(as), i = r && r[1] ? r[1].toLowerCase() : "";
  switch (i) {
    case fr: {
      var o = pn(e);
      if (!dr.test(e)) {
        var s = o.querySelector(hr);
        (t = s == null ? void 0 : s.parentNode) === null || t === void 0 || t.removeChild(s);
      }
      if (!pr.test(e)) {
        var s = o.querySelector(Dt);
        (n = s == null ? void 0 : s.parentNode) === null || n === void 0 || n.removeChild(s);
      }
      return o.querySelectorAll(fr);
    }
    case hr:
    case Dt: {
      var a = Ut(e).querySelectorAll(i);
      return pr.test(e) && dr.test(e) ? a[0].parentNode.childNodes : a;
    }
    default: {
      if (gn)
        return gn(e);
      var s = Ut(e, Dt).querySelector(Dt);
      return s.childNodes;
    }
  }
}
var fs = j && j.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Vn, "__esModule", { value: !0 });
Vn.default = gs;
var hs = fs($n), ds = $e, ps = /<(![a-zA-Z\s]+)>/;
function gs(e) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  var t = e.match(ps), n = t ? t[1] : void 0;
  return (0, ds.formatDOM)((0, hs.default)(e), null, n);
}
var Mt = {}, ye = {}, Ht = {}, ms = 0;
Ht.SAME = ms;
var vs = 1;
Ht.CAMELCASE = vs;
Ht.possibleStandardNames = {
  accept: 0,
  acceptCharset: 1,
  "accept-charset": "acceptCharset",
  accessKey: 1,
  action: 0,
  allowFullScreen: 1,
  alt: 0,
  as: 0,
  async: 0,
  autoCapitalize: 1,
  autoComplete: 1,
  autoCorrect: 1,
  autoFocus: 1,
  autoPlay: 1,
  autoSave: 1,
  capture: 0,
  cellPadding: 1,
  cellSpacing: 1,
  challenge: 0,
  charSet: 1,
  checked: 0,
  children: 0,
  cite: 0,
  class: "className",
  classID: 1,
  className: 1,
  cols: 0,
  colSpan: 1,
  content: 0,
  contentEditable: 1,
  contextMenu: 1,
  controls: 0,
  controlsList: 1,
  coords: 0,
  crossOrigin: 1,
  dangerouslySetInnerHTML: 1,
  data: 0,
  dateTime: 1,
  default: 0,
  defaultChecked: 1,
  defaultValue: 1,
  defer: 0,
  dir: 0,
  disabled: 0,
  disablePictureInPicture: 1,
  disableRemotePlayback: 1,
  download: 0,
  draggable: 0,
  encType: 1,
  enterKeyHint: 1,
  for: "htmlFor",
  form: 0,
  formMethod: 1,
  formAction: 1,
  formEncType: 1,
  formNoValidate: 1,
  formTarget: 1,
  frameBorder: 1,
  headers: 0,
  height: 0,
  hidden: 0,
  high: 0,
  href: 0,
  hrefLang: 1,
  htmlFor: 1,
  httpEquiv: 1,
  "http-equiv": "httpEquiv",
  icon: 0,
  id: 0,
  innerHTML: 1,
  inputMode: 1,
  integrity: 0,
  is: 0,
  itemID: 1,
  itemProp: 1,
  itemRef: 1,
  itemScope: 1,
  itemType: 1,
  keyParams: 1,
  keyType: 1,
  kind: 0,
  label: 0,
  lang: 0,
  list: 0,
  loop: 0,
  low: 0,
  manifest: 0,
  marginWidth: 1,
  marginHeight: 1,
  max: 0,
  maxLength: 1,
  media: 0,
  mediaGroup: 1,
  method: 0,
  min: 0,
  minLength: 1,
  multiple: 0,
  muted: 0,
  name: 0,
  noModule: 1,
  nonce: 0,
  noValidate: 1,
  open: 0,
  optimum: 0,
  pattern: 0,
  placeholder: 0,
  playsInline: 1,
  poster: 0,
  preload: 0,
  profile: 0,
  radioGroup: 1,
  readOnly: 1,
  referrerPolicy: 1,
  rel: 0,
  required: 0,
  reversed: 0,
  role: 0,
  rows: 0,
  rowSpan: 1,
  sandbox: 0,
  scope: 0,
  scoped: 0,
  scrolling: 0,
  seamless: 0,
  selected: 0,
  shape: 0,
  size: 0,
  sizes: 0,
  span: 0,
  spellCheck: 1,
  src: 0,
  srcDoc: 1,
  srcLang: 1,
  srcSet: 1,
  start: 0,
  step: 0,
  style: 0,
  summary: 0,
  tabIndex: 1,
  target: 0,
  title: 0,
  type: 0,
  useMap: 1,
  value: 0,
  width: 0,
  wmode: 0,
  wrap: 0,
  about: 0,
  accentHeight: 1,
  "accent-height": "accentHeight",
  accumulate: 0,
  additive: 0,
  alignmentBaseline: 1,
  "alignment-baseline": "alignmentBaseline",
  allowReorder: 1,
  alphabetic: 0,
  amplitude: 0,
  arabicForm: 1,
  "arabic-form": "arabicForm",
  ascent: 0,
  attributeName: 1,
  attributeType: 1,
  autoReverse: 1,
  azimuth: 0,
  baseFrequency: 1,
  baselineShift: 1,
  "baseline-shift": "baselineShift",
  baseProfile: 1,
  bbox: 0,
  begin: 0,
  bias: 0,
  by: 0,
  calcMode: 1,
  capHeight: 1,
  "cap-height": "capHeight",
  clip: 0,
  clipPath: 1,
  "clip-path": "clipPath",
  clipPathUnits: 1,
  clipRule: 1,
  "clip-rule": "clipRule",
  color: 0,
  colorInterpolation: 1,
  "color-interpolation": "colorInterpolation",
  colorInterpolationFilters: 1,
  "color-interpolation-filters": "colorInterpolationFilters",
  colorProfile: 1,
  "color-profile": "colorProfile",
  colorRendering: 1,
  "color-rendering": "colorRendering",
  contentScriptType: 1,
  contentStyleType: 1,
  cursor: 0,
  cx: 0,
  cy: 0,
  d: 0,
  datatype: 0,
  decelerate: 0,
  descent: 0,
  diffuseConstant: 1,
  direction: 0,
  display: 0,
  divisor: 0,
  dominantBaseline: 1,
  "dominant-baseline": "dominantBaseline",
  dur: 0,
  dx: 0,
  dy: 0,
  edgeMode: 1,
  elevation: 0,
  enableBackground: 1,
  "enable-background": "enableBackground",
  end: 0,
  exponent: 0,
  externalResourcesRequired: 1,
  fill: 0,
  fillOpacity: 1,
  "fill-opacity": "fillOpacity",
  fillRule: 1,
  "fill-rule": "fillRule",
  filter: 0,
  filterRes: 1,
  filterUnits: 1,
  floodOpacity: 1,
  "flood-opacity": "floodOpacity",
  floodColor: 1,
  "flood-color": "floodColor",
  focusable: 0,
  fontFamily: 1,
  "font-family": "fontFamily",
  fontSize: 1,
  "font-size": "fontSize",
  fontSizeAdjust: 1,
  "font-size-adjust": "fontSizeAdjust",
  fontStretch: 1,
  "font-stretch": "fontStretch",
  fontStyle: 1,
  "font-style": "fontStyle",
  fontVariant: 1,
  "font-variant": "fontVariant",
  fontWeight: 1,
  "font-weight": "fontWeight",
  format: 0,
  from: 0,
  fx: 0,
  fy: 0,
  g1: 0,
  g2: 0,
  glyphName: 1,
  "glyph-name": "glyphName",
  glyphOrientationHorizontal: 1,
  "glyph-orientation-horizontal": "glyphOrientationHorizontal",
  glyphOrientationVertical: 1,
  "glyph-orientation-vertical": "glyphOrientationVertical",
  glyphRef: 1,
  gradientTransform: 1,
  gradientUnits: 1,
  hanging: 0,
  horizAdvX: 1,
  "horiz-adv-x": "horizAdvX",
  horizOriginX: 1,
  "horiz-origin-x": "horizOriginX",
  ideographic: 0,
  imageRendering: 1,
  "image-rendering": "imageRendering",
  in2: 0,
  in: 0,
  inlist: 0,
  intercept: 0,
  k1: 0,
  k2: 0,
  k3: 0,
  k4: 0,
  k: 0,
  kernelMatrix: 1,
  kernelUnitLength: 1,
  kerning: 0,
  keyPoints: 1,
  keySplines: 1,
  keyTimes: 1,
  lengthAdjust: 1,
  letterSpacing: 1,
  "letter-spacing": "letterSpacing",
  lightingColor: 1,
  "lighting-color": "lightingColor",
  limitingConeAngle: 1,
  local: 0,
  markerEnd: 1,
  "marker-end": "markerEnd",
  markerHeight: 1,
  markerMid: 1,
  "marker-mid": "markerMid",
  markerStart: 1,
  "marker-start": "markerStart",
  markerUnits: 1,
  markerWidth: 1,
  mask: 0,
  maskContentUnits: 1,
  maskUnits: 1,
  mathematical: 0,
  mode: 0,
  numOctaves: 1,
  offset: 0,
  opacity: 0,
  operator: 0,
  order: 0,
  orient: 0,
  orientation: 0,
  origin: 0,
  overflow: 0,
  overlinePosition: 1,
  "overline-position": "overlinePosition",
  overlineThickness: 1,
  "overline-thickness": "overlineThickness",
  paintOrder: 1,
  "paint-order": "paintOrder",
  panose1: 0,
  "panose-1": "panose1",
  pathLength: 1,
  patternContentUnits: 1,
  patternTransform: 1,
  patternUnits: 1,
  pointerEvents: 1,
  "pointer-events": "pointerEvents",
  points: 0,
  pointsAtX: 1,
  pointsAtY: 1,
  pointsAtZ: 1,
  prefix: 0,
  preserveAlpha: 1,
  preserveAspectRatio: 1,
  primitiveUnits: 1,
  property: 0,
  r: 0,
  radius: 0,
  refX: 1,
  refY: 1,
  renderingIntent: 1,
  "rendering-intent": "renderingIntent",
  repeatCount: 1,
  repeatDur: 1,
  requiredExtensions: 1,
  requiredFeatures: 1,
  resource: 0,
  restart: 0,
  result: 0,
  results: 0,
  rotate: 0,
  rx: 0,
  ry: 0,
  scale: 0,
  security: 0,
  seed: 0,
  shapeRendering: 1,
  "shape-rendering": "shapeRendering",
  slope: 0,
  spacing: 0,
  specularConstant: 1,
  specularExponent: 1,
  speed: 0,
  spreadMethod: 1,
  startOffset: 1,
  stdDeviation: 1,
  stemh: 0,
  stemv: 0,
  stitchTiles: 1,
  stopColor: 1,
  "stop-color": "stopColor",
  stopOpacity: 1,
  "stop-opacity": "stopOpacity",
  strikethroughPosition: 1,
  "strikethrough-position": "strikethroughPosition",
  strikethroughThickness: 1,
  "strikethrough-thickness": "strikethroughThickness",
  string: 0,
  stroke: 0,
  strokeDasharray: 1,
  "stroke-dasharray": "strokeDasharray",
  strokeDashoffset: 1,
  "stroke-dashoffset": "strokeDashoffset",
  strokeLinecap: 1,
  "stroke-linecap": "strokeLinecap",
  strokeLinejoin: 1,
  "stroke-linejoin": "strokeLinejoin",
  strokeMiterlimit: 1,
  "stroke-miterlimit": "strokeMiterlimit",
  strokeWidth: 1,
  "stroke-width": "strokeWidth",
  strokeOpacity: 1,
  "stroke-opacity": "strokeOpacity",
  suppressContentEditableWarning: 1,
  suppressHydrationWarning: 1,
  surfaceScale: 1,
  systemLanguage: 1,
  tableValues: 1,
  targetX: 1,
  targetY: 1,
  textAnchor: 1,
  "text-anchor": "textAnchor",
  textDecoration: 1,
  "text-decoration": "textDecoration",
  textLength: 1,
  textRendering: 1,
  "text-rendering": "textRendering",
  to: 0,
  transform: 0,
  typeof: 0,
  u1: 0,
  u2: 0,
  underlinePosition: 1,
  "underline-position": "underlinePosition",
  underlineThickness: 1,
  "underline-thickness": "underlineThickness",
  unicode: 0,
  unicodeBidi: 1,
  "unicode-bidi": "unicodeBidi",
  unicodeRange: 1,
  "unicode-range": "unicodeRange",
  unitsPerEm: 1,
  "units-per-em": "unitsPerEm",
  unselectable: 0,
  vAlphabetic: 1,
  "v-alphabetic": "vAlphabetic",
  values: 0,
  vectorEffect: 1,
  "vector-effect": "vectorEffect",
  version: 0,
  vertAdvY: 1,
  "vert-adv-y": "vertAdvY",
  vertOriginX: 1,
  "vert-origin-x": "vertOriginX",
  vertOriginY: 1,
  "vert-origin-y": "vertOriginY",
  vHanging: 1,
  "v-hanging": "vHanging",
  vIdeographic: 1,
  "v-ideographic": "vIdeographic",
  viewBox: 1,
  viewTarget: 1,
  visibility: 0,
  vMathematical: 1,
  "v-mathematical": "vMathematical",
  vocab: 0,
  widths: 0,
  wordSpacing: 1,
  "word-spacing": "wordSpacing",
  writingMode: 1,
  "writing-mode": "writingMode",
  x1: 0,
  x2: 0,
  x: 0,
  xChannelSelector: 1,
  xHeight: 1,
  "x-height": "xHeight",
  xlinkActuate: 1,
  "xlink:actuate": "xlinkActuate",
  xlinkArcrole: 1,
  "xlink:arcrole": "xlinkArcrole",
  xlinkHref: 1,
  "xlink:href": "xlinkHref",
  xlinkRole: 1,
  "xlink:role": "xlinkRole",
  xlinkShow: 1,
  "xlink:show": "xlinkShow",
  xlinkTitle: 1,
  "xlink:title": "xlinkTitle",
  xlinkType: 1,
  "xlink:type": "xlinkType",
  xmlBase: 1,
  "xml:base": "xmlBase",
  xmlLang: 1,
  "xml:lang": "xmlLang",
  xmlns: 0,
  "xml:space": "xmlSpace",
  xmlnsXlink: 1,
  "xmlns:xlink": "xmlnsXlink",
  xmlSpace: 1,
  y1: 0,
  y2: 0,
  y: 0,
  yChannelSelector: 1,
  z: 0,
  zoomAndPan: 1
};
const Ci = 0, Ne = 1, Gt = 2, Wt = 3, Yn = 4, Ti = 5, bi = 6;
function ys(e) {
  return ee.hasOwnProperty(e) ? ee[e] : null;
}
function oe(e, t, n, r, i, o, s) {
  this.acceptsBooleans = t === Gt || t === Wt || t === Yn, this.attributeName = r, this.attributeNamespace = i, this.mustUseProperty = n, this.propertyName = e, this.type = t, this.sanitizeURL = o, this.removeEmptyString = s;
}
const ee = {}, Ss = [
  "children",
  "dangerouslySetInnerHTML",
  // TODO: This prevents the assignment of defaultValue to regular
  // elements (not just inputs). Now that ReactDOMInput assigns to the
  // defaultValue property -- do we need this?
  "defaultValue",
  "defaultChecked",
  "innerHTML",
  "suppressContentEditableWarning",
  "suppressHydrationWarning",
  "style"
];
Ss.forEach((e) => {
  ee[e] = new oe(
    e,
    Ci,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  ["acceptCharset", "accept-charset"],
  ["className", "class"],
  ["htmlFor", "for"],
  ["httpEquiv", "http-equiv"]
].forEach(([e, t]) => {
  ee[e] = new oe(
    e,
    Ne,
    !1,
    // mustUseProperty
    t,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["contentEditable", "draggable", "spellCheck", "value"].forEach((e) => {
  ee[e] = new oe(
    e,
    Gt,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "autoReverse",
  "externalResourcesRequired",
  "focusable",
  "preserveAlpha"
].forEach((e) => {
  ee[e] = new oe(
    e,
    Gt,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "allowFullScreen",
  "async",
  // Note: there is a special case that prevents it from being written to the DOM
  // on the client side because the browsers are inconsistent. Instead we call focus().
  "autoFocus",
  "autoPlay",
  "controls",
  "default",
  "defer",
  "disabled",
  "disablePictureInPicture",
  "disableRemotePlayback",
  "formNoValidate",
  "hidden",
  "loop",
  "noModule",
  "noValidate",
  "open",
  "playsInline",
  "readOnly",
  "required",
  "reversed",
  "scoped",
  "seamless",
  // Microdata
  "itemScope"
].forEach((e) => {
  ee[e] = new oe(
    e,
    Wt,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "checked",
  // Note: `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`. We have special logic for handling this.
  "multiple",
  "muted",
  "selected"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  ee[e] = new oe(
    e,
    Wt,
    !0,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "capture",
  "download"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  ee[e] = new oe(
    e,
    Yn,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "cols",
  "rows",
  "size",
  "span"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  ee[e] = new oe(
    e,
    bi,
    !1,
    // mustUseProperty
    e,
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["rowSpan", "start"].forEach((e) => {
  ee[e] = new oe(
    e,
    Ti,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
const Xn = /[\-\:]([a-z])/g, Jn = (e) => e[1].toUpperCase();
[
  "accent-height",
  "alignment-baseline",
  "arabic-form",
  "baseline-shift",
  "cap-height",
  "clip-path",
  "clip-rule",
  "color-interpolation",
  "color-interpolation-filters",
  "color-profile",
  "color-rendering",
  "dominant-baseline",
  "enable-background",
  "fill-opacity",
  "fill-rule",
  "flood-color",
  "flood-opacity",
  "font-family",
  "font-size",
  "font-size-adjust",
  "font-stretch",
  "font-style",
  "font-variant",
  "font-weight",
  "glyph-name",
  "glyph-orientation-horizontal",
  "glyph-orientation-vertical",
  "horiz-adv-x",
  "horiz-origin-x",
  "image-rendering",
  "letter-spacing",
  "lighting-color",
  "marker-end",
  "marker-mid",
  "marker-start",
  "overline-position",
  "overline-thickness",
  "paint-order",
  "panose-1",
  "pointer-events",
  "rendering-intent",
  "shape-rendering",
  "stop-color",
  "stop-opacity",
  "strikethrough-position",
  "strikethrough-thickness",
  "stroke-dasharray",
  "stroke-dashoffset",
  "stroke-linecap",
  "stroke-linejoin",
  "stroke-miterlimit",
  "stroke-opacity",
  "stroke-width",
  "text-anchor",
  "text-decoration",
  "text-rendering",
  "underline-position",
  "underline-thickness",
  "unicode-bidi",
  "unicode-range",
  "units-per-em",
  "v-alphabetic",
  "v-hanging",
  "v-ideographic",
  "v-mathematical",
  "vector-effect",
  "vert-adv-y",
  "vert-origin-x",
  "vert-origin-y",
  "word-spacing",
  "writing-mode",
  "xmlns:xlink",
  "x-height"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(Xn, Jn);
  ee[t] = new oe(
    t,
    Ne,
    !1,
    // mustUseProperty
    e,
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "xlink:actuate",
  "xlink:arcrole",
  "xlink:role",
  "xlink:show",
  "xlink:title",
  "xlink:type"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(Xn, Jn);
  ee[t] = new oe(
    t,
    Ne,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/1999/xlink",
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
[
  "xml:base",
  "xml:lang",
  "xml:space"
  // NOTE: if you add a camelCased prop to this list,
  // you'll need to set attributeName to name.toLowerCase()
  // instead in the assignment below.
].forEach((e) => {
  const t = e.replace(Xn, Jn);
  ee[t] = new oe(
    t,
    Ne,
    !1,
    // mustUseProperty
    e,
    "http://www.w3.org/XML/1998/namespace",
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
["tabIndex", "crossOrigin"].forEach((e) => {
  ee[e] = new oe(
    e,
    Ne,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !1,
    // sanitizeURL
    !1
    // removeEmptyString
  );
});
const Es = "xlinkHref";
ee[Es] = new oe(
  "xlinkHref",
  Ne,
  !1,
  // mustUseProperty
  "xlink:href",
  "http://www.w3.org/1999/xlink",
  !0,
  // sanitizeURL
  !1
  // removeEmptyString
);
["src", "href", "action", "formAction"].forEach((e) => {
  ee[e] = new oe(
    e,
    Ne,
    !1,
    // mustUseProperty
    e.toLowerCase(),
    // attributeName
    null,
    // attributeNamespace
    !0,
    // sanitizeURL
    !0
    // removeEmptyString
  );
});
const {
  CAMELCASE: _s,
  SAME: ws,
  possibleStandardNames: mr
} = Ht, As = ":A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD", Cs = As + "\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040", Ts = RegExp.prototype.test.bind(
  // eslint-disable-next-line no-misleading-character-class
  new RegExp("^(data|aria)-[" + Cs + "]*$")
), bs = Object.keys(
  mr
).reduce((e, t) => {
  const n = mr[t];
  return n === ws ? e[t] = t : n === _s ? e[t.toLowerCase()] = t : e[t] = n, e;
}, {});
ye.BOOLEAN = Wt;
ye.BOOLEANISH_STRING = Gt;
ye.NUMERIC = Ti;
ye.OVERLOADED_BOOLEAN = Yn;
ye.POSITIVE_NUMERIC = bi;
ye.RESERVED = Ci;
ye.STRING = Ne;
ye.getPropertyInfo = ys;
ye.isCustomAttribute = Ts;
ye.possibleStandardNames = bs;
var Zn = {}, Qn = {}, vr = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, Is = /\n/g, Ds = /^\s*/, Rs = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, xs = /^:\s*/, Os = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, Ps = /^[;\s]*/, Us = /^\s+|\s+$/g, Ns = `
`, yr = "/", Sr = "*", Ge = "", Ls = "comment", Fs = "declaration", ks = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e) return [];
  t = t || {};
  var n = 1, r = 1;
  function i(_) {
    var S = _.match(Is);
    S && (n += S.length);
    var b = _.lastIndexOf(Ns);
    r = ~b ? _.length - b : r + _.length;
  }
  function o() {
    var _ = { line: n, column: r };
    return function(S) {
      return S.position = new s(_), f(), S;
    };
  }
  function s(_) {
    this.start = _, this.end = { line: n, column: r }, this.source = t.source;
  }
  s.prototype.content = e;
  function a(_) {
    var S = new Error(
      t.source + ":" + n + ":" + r + ": " + _
    );
    if (S.reason = _, S.filename = t.source, S.line = n, S.column = r, S.source = e, !t.silent) throw S;
  }
  function l(_) {
    var S = _.exec(e);
    if (S) {
      var b = S[0];
      return i(b), e = e.slice(b.length), S;
    }
  }
  function f() {
    l(Ds);
  }
  function g(_) {
    var S;
    for (_ = _ || []; S = p(); )
      S !== !1 && _.push(S);
    return _;
  }
  function p() {
    var _ = o();
    if (!(yr != e.charAt(0) || Sr != e.charAt(1))) {
      for (var S = 2; Ge != e.charAt(S) && (Sr != e.charAt(S) || yr != e.charAt(S + 1)); )
        ++S;
      if (S += 2, Ge === e.charAt(S - 1))
        return a("End of comment missing");
      var b = e.slice(2, S - 2);
      return r += 2, i(b), e = e.slice(S), r += 2, _({
        type: Ls,
        comment: b
      });
    }
  }
  function m() {
    var _ = o(), S = l(Rs);
    if (S) {
      if (p(), !l(xs)) return a("property missing ':'");
      var b = l(Os), R = _({
        type: Fs,
        property: Er(S[0].replace(vr, Ge)),
        value: b ? Er(b[0].replace(vr, Ge)) : Ge
      });
      return l(Ps), R;
    }
  }
  function E() {
    var _ = [];
    g(_);
    for (var S; S = m(); )
      S !== !1 && (_.push(S), g(_));
    return _;
  }
  return f(), E();
};
function Er(e) {
  return e ? e.replace(Us, Ge) : Ge;
}
var Bs = j && j.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(Qn, "__esModule", { value: !0 });
Qn.default = Hs;
var Ms = Bs(ks);
function Hs(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  var r = (0, Ms.default)(e), i = typeof t == "function";
  return r.forEach(function(o) {
    if (o.type === "declaration") {
      var s = o.property, a = o.value;
      i ? t(s, a, o) : a && (n = n || {}, n[s] = a);
    }
  }), n;
}
var Vt = {};
Object.defineProperty(Vt, "__esModule", { value: !0 });
Vt.camelCase = void 0;
var Gs = /^--[a-zA-Z0-9_-]+$/, Ws = /-([a-z])/g, Vs = /^[^-]+$/, $s = /^-(webkit|moz|ms|o|khtml)-/, js = /^-(ms)-/, Ks = function(e) {
  return !e || Vs.test(e) || Gs.test(e);
}, zs = function(e, t) {
  return t.toUpperCase();
}, _r = function(e, t) {
  return "".concat(t, "-");
}, qs = function(e, t) {
  return t === void 0 && (t = {}), Ks(e) ? e : (e = e.toLowerCase(), t.reactCompat ? e = e.replace(js, _r) : e = e.replace($s, _r), e.replace(Ws, zs));
};
Vt.camelCase = qs;
var Ys = j && j.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
}, Xs = Ys(Qn), Js = Vt;
function mn(e, t) {
  var n = {};
  return !e || typeof e != "string" || (0, Xs.default)(e, function(r, i) {
    r && i && (n[(0, Js.camelCase)(r, t)] = i);
  }), n;
}
mn.default = mn;
var Zs = mn;
(function(e) {
  var t = j && j.__importDefault || function(g) {
    return g && g.__esModule ? g : { default: g };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.returnFirstArg = e.canTextBeChildOfNode = e.ELEMENTS_WITH_NO_TEXT_CHILDREN = e.PRESERVE_CUSTOM_ATTRIBUTES = void 0, e.isCustomComponent = o, e.setStyleProp = a;
  var n = zr, r = t(Zs), i = /* @__PURE__ */ new Set([
    "annotation-xml",
    "color-profile",
    "font-face",
    "font-face-src",
    "font-face-uri",
    "font-face-format",
    "font-face-name",
    "missing-glyph"
  ]);
  function o(g, p) {
    return g.includes("-") ? !i.has(g) : !!(p && typeof p.is == "string");
  }
  var s = {
    reactCompat: !0
  };
  function a(g, p) {
    if (typeof g == "string") {
      if (!g.trim()) {
        p.style = {};
        return;
      }
      try {
        p.style = (0, r.default)(g, s);
      } catch {
        p.style = {};
      }
    }
  }
  e.PRESERVE_CUSTOM_ATTRIBUTES = Number(n.version.split(".")[0]) >= 16, e.ELEMENTS_WITH_NO_TEXT_CHILDREN = /* @__PURE__ */ new Set([
    "tr",
    "tbody",
    "thead",
    "tfoot",
    "colgroup",
    "table",
    "head",
    "html",
    "frameset"
  ]);
  var l = function(g) {
    return !e.ELEMENTS_WITH_NO_TEXT_CHILDREN.has(g.name);
  };
  e.canTextBeChildOfNode = l;
  var f = function(g) {
    return g;
  };
  e.returnFirstArg = f;
})(Zn);
Object.defineProperty(Mt, "__esModule", { value: !0 });
Mt.default = na;
var ct = ye, wr = Zn, Qs = ["checked", "value"], ea = ["input", "select", "textarea"], ta = {
  reset: !0,
  submit: !0
};
function na(e, t) {
  e === void 0 && (e = {});
  var n = {}, r = !!(e.type && ta[e.type]);
  for (var i in e) {
    var o = e[i];
    if ((0, ct.isCustomAttribute)(i)) {
      n[i] = o;
      continue;
    }
    var s = i.toLowerCase(), a = Ar(s);
    if (a) {
      var l = (0, ct.getPropertyInfo)(a);
      switch (Qs.includes(a) && ea.includes(t) && !r && (a = Ar("default" + s)), n[a] = o, l && l.type) {
        case ct.BOOLEAN:
          n[a] = !0;
          break;
        case ct.OVERLOADED_BOOLEAN:
          o === "" && (n[a] = !0);
          break;
      }
      continue;
    }
    wr.PRESERVE_CUSTOM_ATTRIBUTES && (n[i] = o);
  }
  return (0, wr.setStyleProp)(e.style, n), n;
}
function Ar(e) {
  return ct.possibleStandardNames[e];
}
var er = {}, ra = j && j.__importDefault || function(e) {
  return e && e.__esModule ? e : { default: e };
};
Object.defineProperty(er, "__esModule", { value: !0 });
er.default = Ii;
var tn = zr, ia = ra(Mt), dt = Zn, oa = {
  cloneElement: tn.cloneElement,
  createElement: tn.createElement,
  isValidElement: tn.isValidElement
};
function Ii(e, t) {
  t === void 0 && (t = {});
  for (var n = [], r = typeof t.replace == "function", i = t.transform || dt.returnFirstArg, o = t.library || oa, s = o.cloneElement, a = o.createElement, l = o.isValidElement, f = e.length, g = 0; g < f; g++) {
    var p = e[g];
    if (r) {
      var m = t.replace(p, g);
      if (l(m)) {
        f > 1 && (m = s(m, {
          key: m.key || g
        })), n.push(i(m, p, g));
        continue;
      }
    }
    if (p.type === "text") {
      var E = !p.data.trim().length;
      if (E && p.parent && !(0, dt.canTextBeChildOfNode)(p.parent) || t.trim && E)
        continue;
      n.push(i(p.data, p, g));
      continue;
    }
    var _ = p, S = {};
    sa(_) ? ((0, dt.setStyleProp)(_.attribs.style, _.attribs), S = _.attribs) : _.attribs && (S = (0, ia.default)(_.attribs, _.name));
    var b = void 0;
    switch (p.type) {
      case "script":
      case "style":
        p.children[0] && (S.dangerouslySetInnerHTML = {
          __html: p.children[0].data
        });
        break;
      case "tag":
        p.name === "textarea" && p.children[0] ? S.defaultValue = p.children[0].data : p.children && p.children.length && (b = Ii(p.children, t));
        break;
      default:
        continue;
    }
    f > 1 && (S.key = g), n.push(i(a(p.name, S, b), p, g));
  }
  return n.length === 1 ? n[0] : n;
}
function sa(e) {
  return dt.PRESERVE_CUSTOM_ATTRIBUTES && e.type === "tag" && (0, dt.isCustomComponent)(e.name, e.attribs);
}
(function(e) {
  var t = j && j.__importDefault || function(l) {
    return l && l.__esModule ? l : { default: l };
  };
  Object.defineProperty(e, "__esModule", { value: !0 }), e.htmlToDOM = e.domToReact = e.attributesToProps = e.Text = e.ProcessingInstruction = e.Element = e.Comment = void 0, e.default = a;
  var n = t(Vn);
  e.htmlToDOM = n.default;
  var r = t(Mt);
  e.attributesToProps = r.default;
  var i = t(er);
  e.domToReact = i.default;
  var o = jn;
  Object.defineProperty(e, "Comment", { enumerable: !0, get: function() {
    return o.Comment;
  } }), Object.defineProperty(e, "Element", { enumerable: !0, get: function() {
    return o.Element;
  } }), Object.defineProperty(e, "ProcessingInstruction", { enumerable: !0, get: function() {
    return o.ProcessingInstruction;
  } }), Object.defineProperty(e, "Text", { enumerable: !0, get: function() {
    return o.Text;
  } });
  var s = { lowerCaseAttributeNames: !1 };
  function a(l, f) {
    if (typeof l != "string")
      throw new TypeError("First argument must be a string");
    return l ? (0, i.default)((0, n.default)(l, (f == null ? void 0 : f.htmlparser2) || s), f) : [];
  }
})(ai);
const Cr = /* @__PURE__ */ Hn(ai), aa = Cr.default || Cr, ot = {
  tooltip: {
    "--min-width": "300px",
    "--max-width": "335px",
    "--width": "auto"
  },
  tooltipBody: {
    border: "solid 1px",
    padding: 16,
    display: "flex",
    gap: 12,
    borderRadius: 12
  },
  tooltipContent: {
    margin: 0
  },
  tooltipTitle: {
    padding: "0 0 12px 0",
    margin: 0,
    overflowWrap: "break-word",
    wordBreak: "break-all"
  },
  tooltipTheme: {
    color: C.black,
    background: C.purple200,
    borderColor: C.purple500
  },
  dangerTheme: {
    borderColor: C.red500,
    backgroundColor: C.pink,
    color: C.red500
  },
  successTheme: {
    color: C.green500,
    borderColor: C.green500,
    backgroundColor: C.green200
  },
  infoTheme: {
    color: C.white200,
    borderColor: C.blue600,
    backgroundColor: C.blue600
  }
}, ca = {
  tooltip: "purple500",
  info: "white200",
  danger: "red500",
  success: "green500"
};
function rh(e) {
  const {
    trigger: t,
    header: n,
    content: r,
    theme: i = "tooltip",
    disableIcon: o = !1,
    positionAlign: s
  } = e;
  return /* @__PURE__ */ y(to, {
    trigger: t,
    mode: "md",
    style: ot.tooltip,
    className: s === "page-center" ? "placement-page-center" : "",
    alignment: s === "page-center" ? void 0 : s,
    animated: s !== "page-center",
    children: /* @__PURE__ */ x("div", {
      style: {
        ...ot.tooltipBody,
        ...ot[`${i}Theme`]
      },
      children: [!o && /* @__PURE__ */ y(ne, {
        name: "Info",
        color: C[ca[i]] ?? C.black
      }), /* @__PURE__ */ x("div", {
        children: [n && /* @__PURE__ */ y("h3", {
          style: ot.tooltipTitle,
          children: n
        }), /* @__PURE__ */ y("p", {
          style: ot.tooltipContent,
          children: typeof r == "string" ? aa(r) : r
        })]
      })]
    })
  });
}
function ua(e) {
  return typeof e == "object" && e !== null && "message" in e && typeof e.message == "string";
}
function la(e) {
  if (ua(e)) return e;
  try {
    return new Error(JSON.stringify(e));
  } catch {
    return new Error(String(e));
  }
}
function ke(e) {
  return la(e).message;
}
function ih(e) {
  const {
    phoneNumber: t
  } = e;
  return (t.startsWith("+1") ? t.slice(2) : t).replace(/\D/g, "");
}
function oh(e) {
  const {
    phoneNumber: t
  } = e;
  return t.length >= 11 ? {
    isFormatted: !1,
    value: ""
  } : t.length === 0 ? {
    isFormatted: !0,
    value: ""
  } : t.length < 3 ? {
    isFormatted: !0,
    value: `(${t}`
  } : t.length === 3 ? {
    isFormatted: !0,
    value: `(${t})`
  } : t.length <= 6 ? {
    isFormatted: !0,
    value: `(${t.slice(0, 3)}) ${t.slice(3)}`
  } : {
    isFormatted: !0,
    value: `(${t.slice(0, 3)}) ${t.slice(3, 6)}-${t.slice(6, 10)}`
  };
}
const je = "swingeducation.com", fa = `support.${je}`, ha = `start.${je}`, da = `swingsubs.${je}`, pa = `swingsubs.aws.${je}`, ga = "localhost:3001", ma = "https://apps.apple.com/us/app/swing-subs/id6480072147", va = "https://play.google.com/store/apps/details?id=com.swingeducation.swingsubs", ya = `admins.${je}`, Sa = `admins.aws.${je}`, Ea = "localhost:3000", _a = "https://apps.apple.com/us/app/swing-schools/id6477969868", wa = "https://play.google.com/store/apps/details?id=com.swingeducation.adminapp", Ie = ({
  host: e,
  scheme: t = "https",
  path: n
}) => `${t}://${e}${n}`, Aa = (e = "") => Ie({
  host: je,
  path: e
}), Ca = (e = "") => Ie({
  host: da,
  path: e
}), Ta = (e = "") => Ie({
  host: pa,
  path: e
}), ba = (e = "") => Ie({
  host: ga,
  path: e,
  scheme: "http"
}), Di = () => ma, Ri = () => va, Ia = (e = "") => Ie({
  host: ya,
  path: e
}), Da = (e = "") => Ie({
  host: Sa,
  path: e
}), Ra = (e = "") => Ie({
  host: Ea,
  path: e,
  scheme: "http"
}), xi = () => _a, Oi = () => wa, Pi = (e = "") => Ie({
  host: fa,
  path: e
}), xa = (e = "") => Ie({
  host: ha,
  path: e
});
function Oa(e) {
  var l;
  const {
    app: t,
    buildProfile: n,
    error: r,
    platform: i,
    provider: o
  } = e, s = (l = r.response) == null ? void 0 : l.data.message, a = Pa(t, i, n);
  return /* @__PURE__ */ y(Wn, {
    customStyles: {
      fontSize: 14
    },
    children: t === "swing-subs" && (s != null && s.toLowerCase().includes("unmatched user type") || s != null && s.toLowerCase().includes("missing both :sub/id and :pending-sub/id on sub")) ? /* @__PURE__ */ x("span", {
      children: [se("LOGIN_INCORRECT_USER_TYPE_SWING_SUBS"), " ", /* @__PURE__ */ y("a", {
        style: {
          textDecoration: "none"
        },
        target: "_blank",
        rel: "noreferrer",
        href: a,
        children: i === "web" ? se("LOGIN_INCORRECT_USER_TYPE_LABEL_WEB_SWING_SUBS") : se("LOGIN_INCORRECT_USER_TYPE_LABEL_MOBILE_SWING_SUBS")
      }), "."]
    }) : (
      /*
        sub user attempting to sign into admin app:
          - Cognito - "Unmatched user type" -> user exists in Cognito pool but provided email and USER-TYPE combination is incorrect
          - Google - user exists but doesn't have required admin attributes needed for our Swing system
      */
      t === "swing-schools" && (s != null && s.toLowerCase().includes("unmatched user type") || s != null && s.toLowerCase().includes("missing :admin/id on admin")) ? /* @__PURE__ */ x("span", {
        children: [se("LOGIN_INCORRECT_USER_TYPE_SWING_SCHOOLS"), " ", /* @__PURE__ */ y("a", {
          style: {
            textDecoration: "none"
          },
          target: "_blank",
          rel: "noreferrer",
          href: a,
          children: i === "web" ? se("LOGIN_INCORRECT_USER_TYPE_LABEL_WEB_SWING_SCHOOLS") : se("LOGIN_INCORRECT_USER_TYPE_LABEL_MOBILE_SWING_SCHOOLS")
        }), "."]
      }) : (
        /**
         * Cognito - "User not found" -> user does not exist in Cognito pool
         * Google - "User not found" - un-recognized Google user
         */
        /* @__PURE__ */ x("span", {
          children: [o === "cognito" ? se("EMAIL_FIELD_LOGIN_UNRECOGNIZED_EMAIL") : se("GOOGLE_LOGIN_UNRECOGNIZED_EMAIL"), /* @__PURE__ */ y("a", {
            style: {
              textDecoration: "none"
            },
            target: "_blank",
            rel: "noreferrer",
            href: Pi("/hc/en-us/requests/new"),
            children: se("EMAIL_FIELD_LABEL_CONTACT_SUPPORT")
          }), "."]
        })
      )
    )
  });
}
function Pa(e, t, n) {
  if (e === "swing-subs") {
    if (t === "android")
      return Oi();
    if (t === "ios")
      return xi();
    if (t === "web")
      return n === "prod" ? Ia() : n === "staging" ? Da() : Ra();
  }
  if (e === "swing-schools") {
    if (t === "android")
      return Ri();
    if (t === "ios")
      return Di();
    if (t === "web")
      return n === "prod" ? Ca() : n === "staging" ? Ta() : ba();
  }
  throw new Error(`generateErrorLoginHref error: provided platform '${t}' is not recognized!`);
}
const Ua = "_form_6mt1j_1", Na = "_backgroundGray_6mt1j_5", La = "_resetPasswordButton_6mt1j_10", vn = {
  form: Ua,
  backgroundGray: Na,
  resetPasswordButton: La
};
function sh(e) {
  const {
    app: t,
    history: n,
    location: r,
    loginWithPasswordPath: i
  } = e, o = r.state;
  qr(() => {
    if (!o || !o.email)
      return n.push("/");
  }, [n, o]);
  const {
    forgotPasswordSubmit: s
  } = ar(), [a, l] = de({
    email: o && o.email ? o.email : "",
    newPassword: "",
    validationCode: ""
  }), [f, g] = de({
    hasError: !1,
    errorType: ""
  }), [p, m] = de(Ha);
  function E(b) {
    l((R) => ({
      ...R,
      newPassword: b
    })), m(Ba(b, p));
  }
  function _(b) {
    n.push({
      pathname: i,
      state: {
        email: a.email,
        isPasswordReset: b
      }
    });
  }
  async function S(b) {
    b.preventDefault(), await s(a.email, a.validationCode, a.newPassword).then(() => {
      g({
        hasError: !1
      }), _(!0), console.info("Password reset.");
    }).catch((R) => {
      g({
        hasError: !0,
        errorType: R.name
      }), console.error("UI - forgotPasswordSubmit error: ", R);
    });
  }
  return /* @__PURE__ */ x(Ni, {
    app: t,
    title: P("FORGOT_PASSWORD_RESET_PASSWORD_HEADER_LABEL"),
    onBackNav: () => _(!1),
    children: [f.hasError ? /* @__PURE__ */ y(Wa, {
      codeValidationError: f
    }) : /* @__PURE__ */ y(mt, {
      color: "info",
      children: P("FORGOT_PASSWORD_RESET_PASSWORD_BANNER_MESSAGE", {
        email: ka(a.email) || ""
      })
    }), /* @__PURE__ */ x("form", {
      className: vn.form,
      onSubmit: async (b) => S(b),
      children: [/* @__PURE__ */ y(Ga, {
        code: a.validationCode,
        onVerificationCodeChange: (b) => {
          l((R) => ({
            ...R,
            validationCode: b
          }));
        }
      }), /* @__PURE__ */ y(si, {
        passwordLabel: P("FORGOT_PASSWORD_RESET_PASSWORD_FIELD_LABEL"),
        onPasswordInput: (b) => E(b),
        password: a.newPassword
      }), /* @__PURE__ */ y(es, {
        validationObject: p
      }), /* @__PURE__ */ y(ei, {
        "data-testid": "forget-password-submit-button",
        type: "submit",
        size: "default",
        expand: "block",
        className: vn.resetPasswordButton,
        disabled: !Fa(a, p),
        children: P("FORGOT_PASSWORD_RESET_PASSWORD_SUBMIT_LABEL")
      })]
    })]
  });
}
function Fa(e, t) {
  const {
    validationCode: n
  } = e;
  return Ma(t) && n.length !== 0;
}
const ka = (e) => {
  if (!e) return;
  const [t, n] = e.split("@"), r = "***";
  return `${t[0]}${r}@${n[0]}${r}`;
}, Ba = (e, t) => {
  const n = [...t];
  return n.forEach((r) => {
    const o = new RegExp(r.validationType).test(e);
    r.isValid = o;
  }), n;
}, Ma = (e) => e.every((t) => t.isValid), Ha = [{
  validationType: bt.RESET_VALIDATION_UPPERCASE,
  message: P("FORGOT_PASSWORD_RESET_VALIDATION_UPPERCASE"),
  isValid: !1
}, {
  validationType: bt.RESET_VALIDATION_LOWERCASE,
  message: P("FORGOT_PASSWORD_RESET_VALIDATION_LOWERCASE"),
  isValid: !1
}, {
  validationType: bt.RESET_VALIDATION_NUMBER,
  message: P("FORGOT_PASSWORD_RESET_VALIDATION_NUMBER"),
  isValid: !1
}, {
  validationType: bt.RESET_VALIDATION_MIN_CHARACTERS,
  message: P("FORGOT_PASSWORD_RESET_VALIDATION_MIN_CHARACTERS"),
  isValid: !1
}];
function Ga(e) {
  const {
    code: t,
    onVerificationCodeChange: n
  } = e;
  return /* @__PURE__ */ x("div", {
    style: {
      width: "inherit"
    },
    children: [/* @__PURE__ */ y(Qr, {
      style: {
        paddingLeft: 16,
        boxShadow: "none"
      },
      children: /* @__PURE__ */ y(Mn, {
        style: {
          fontWeight: "var(--swing-font-medium)"
        },
        children: P("FORGOT_PASSWORD_RESET_PASSWORD_VERIFICATION_LABEL")
      })
    }), /* @__PURE__ */ y(Zr, {
      lines: "full",
      className: `${vn.backgroundGray} ion-margin-bottom`,
      css: {
        width: "100%",
        "--border-color": C.slate400,
        "--min-height": "auto"
      },
      children: /* @__PURE__ */ y(Bn, {
        "data-testid": "verification-code-input",
        type: "text",
        value: t,
        onIonInput: (r) => {
          n(r.detail.value);
        },
        spellCheck: "false"
      })
    })]
  });
}
function Wa(e) {
  const {
    codeValidationError: t
  } = e;
  switch (t.errorType) {
    case "CodeMismatchException":
      return /* @__PURE__ */ x(mt, {
        showIcon: !0,
        title: P("FORGOT_PASSWORD_LOGIN_ERROR_TITLE"),
        color: "danger",
        children: [P("FORGOT_PASSWORD_RESET_PASSWORD_INVALID_CODE_MESSAGE"), "."]
      });
    case "ExpiredCodeException":
      return /* @__PURE__ */ x(mt, {
        showIcon: !0,
        title: P("FORGOT_PASSWORD_RESET_VERIFICATION_CODE_EXPIRED_TITLE"),
        color: "danger",
        children: [P("FORGOT_PASSWORD_RESET_VERIFICATION_CODE_EXPIRED_MESSAGE"), "."]
      });
    default:
      return /* @__PURE__ */ y(Ui, {});
  }
}
const Va = "_form_xt5zm_1", $a = "_spacing_xt5zm_5", ja = "_loginButton_xt5zm_9", st = {
  form: Va,
  spacing: $a,
  loginButton: ja
};
function ah(e) {
  const {
    app: t,
    buildProfile: n,
    forgotPasswordPath: r,
    history: i,
    isWeb: o,
    location: s,
    onEmailEdit: a,
    platform: l
  } = e, {
    forgotPasswordRequest: f,
    signIn: g
  } = ar(), p = s.state;
  qr(() => {
    if (!p || !p.email)
      return i.push("/");
  }, [i, p]);
  const [m, E] = de({
    email: p && p.email ? p.email : "",
    password: ""
  }), [_, S] = de(!1), [b, R] = de(""), L = p && p.isPasswordReset || !1, [ge, q] = de(!1);
  We(() => {
    R(""), E((V) => ({
      email: V.email,
      password: ""
    }));
  }, [L, p == null ? void 0 : p.email]);
  const me = async (V) => {
    V.preventDefault(), q(!0);
    const Y = {
      email: m.email.toLowerCase().trim(),
      password: m.password
    };
    await g({
      provider: "cognito",
      user: Y
    }).catch((J) => {
      switch (J.message) {
        case "Password attempts exceeded":
          R(P("LOGIN_WITH_PASSWORD_LOGIN_ATTEMPTS_EXCEEDED"));
          break;
        default:
          R(P("LOGIN_WITH_PASSWORD_LOGIN_INCORRECT_PASSWORD"));
          break;
      }
    }), q(!1);
  }, ue = () => {
    i.push({
      pathname: r,
      state: {
        email: m.email
      }
    });
  }, Se = () => {
    f(m.email).then(() => {
      ue(), console.info("Email sent.");
    }).catch((V) => {
      console.error("UI - forgotPasswordRequest error: ", V), S(!0);
    });
  };
  return /* @__PURE__ */ x(Ni, {
    app: t,
    isWeb: o,
    title: `${P("LOGIN_WITH_PASSWORD_LOGIN_WELCOME_BACK_MESSAGE")}!`,
    children: [/* @__PURE__ */ x("form", {
      className: st.form,
      onSubmit: (V) => me(V),
      children: [/* @__PURE__ */ x("div", {
        className: _ || L && !_ ? st.spacing : "",
        children: [_ && /* @__PURE__ */ y(Ui, {}), L && !_ && /* @__PURE__ */ x(mt, {
          color: "success",
          children: [P("LOGIN_WITH_PASSWORD_RESET_PASSWORD_SUCCESS_MESSAGE"), "."]
        })]
      }), /* @__PURE__ */ y("div", {
        className: st.spacing,
        children: /* @__PURE__ */ y(Go, {
          app: t,
          buildProfile: n,
          email: m.email,
          onEmailEdit: a,
          platform: l,
          readOnly: !0
        })
      }), /* @__PURE__ */ y("div", {
        className: st.spacing,
        children: /* @__PURE__ */ y(si, {
          passwordLabel: P("LOGIN_WITH_PASSWORD_LOGIN_PASSWORD_LABEL"),
          onPasswordInput: (V) => E((Y) => ({
            ...Y,
            password: V
          })),
          error: b,
          password: m.password
        })
      }), /* @__PURE__ */ y(ei, {
        "data-testid": "cognito-submit-button",
        type: "submit",
        size: "default",
        expand: "block",
        className: st.loginButton,
        disabled: !Ka(m) || ge,
        children: P("LOGIN_WITH_PASSWORD_LOGIN_BUTTON_LABEL")
      })]
    }), /* @__PURE__ */ x("button", {
      css: {
        background: "none",
        fontWeight: "var(--swing-font-medium)",
        fontSize: 12,
        cursor: "pointer",
        color: "var(--ion-color-primary)",
        textAlign: "center"
      },
      onClick: Se,
      "data-testid": "forgot-password-button",
      name: "button-password",
      children: [P("LOGIN_WITH_PASSWORD_LOGIN_FORGOT_PASSWORD_LABEL"), "?"]
    })]
  });
}
function Ui() {
  const e = Pi("/hc/en-us/requests/new");
  return /* @__PURE__ */ y(mt, {
    color: "danger",
    showIcon: !0,
    title: P("LOGIN_WITH_PASSWORD_LOGIN_ERROR_TITLE"),
    children: /* @__PURE__ */ y("p", {
      style: {
        margin: 0
      },
      dangerouslySetInnerHTML: {
        __html: P("LOGIN_WITH_PASSWORD_LOGIN_ERROR_MESSAGE", {
          contactSupportLink: e
        })
      }
    })
  });
}
function Ka(e) {
  const {
    password: t
  } = e;
  return t.length !== 0;
}
function Ni(e) {
  const {
    app: t,
    build: n,
    children: r,
    isWeb: i,
    onBackNav: o,
    title: s,
    version: a
  } = e, l = t === "swing-subs";
  return /* @__PURE__ */ y(Ze, {
    children: /* @__PURE__ */ x("div", {
      css: {
        display: "flex",
        height: "100%"
      },
      children: [/* @__PURE__ */ y("div", {
        title: P("LOGIN_LAYOUT_SPLASH_IMAGE_ALT_TEXT"),
        css: {
          display: "none",
          backgroundImage: `url(${l ? io : oo})`,
          backgroundSize: "cover",
          backgroundPosition: "top",
          "@media (min-width: 900px)": {
            display: "flex",
            width: "50%"
          }
        }
      }), /* @__PURE__ */ y("div", {
        css: {
          display: "flex",
          width: "100%",
          padding: "var(--ion-safe-area-top, 0) 0 0 0",
          color: C.black,
          background: l ? C.white200 : C.blue500,
          "@media (min-width: 900px)": {
            display: "block",
            width: "50%"
          }
        },
        children: /* @__PURE__ */ x("div", {
          css: {
            display: "flex",
            flexDirection: "column",
            height: "100%",
            width: "100%",
            alignItems: "center",
            background: C.white300
          },
          children: [/* @__PURE__ */ y("div", {
            css: {
              width: "100%"
            },
            children: /* @__PURE__ */ x("div", {
              css: {
                display: "flex",
                flexDirection: "column",
                width: "100%",
                position: "relative",
                paddingLeft: 16,
                paddingRight: 16,
                paddingBottom: 80,
                background: l ? C.white200 : C.blue500,
                overflow: "hidden",
                "&:before": {
                  // used to carve out the bottom of the blue (admin-app) or white (sub-app) background
                  content: '""',
                  position: "absolute",
                  bottom: -110,
                  left: "-10%",
                  width: "120%",
                  height: 190,
                  background: C.white300,
                  borderRadius: "50%",
                  boxShadow: l ? "0px 0px 16px 4px rgba(40, 60, 93, 0.16)" : void 0
                }
              },
              children: [o && /* @__PURE__ */ y("div", {
                css: {
                  position: "absolute",
                  top: 16,
                  right: 16,
                  maxWidth: 360,
                  "@media (min-width: 900px)": {
                    maxWidth: "none",
                    right: "auto",
                    // position back nav on left
                    left: 16
                  }
                },
                children: /* @__PURE__ */ y(Xa, {
                  isSubsApp: l,
                  onBack: o
                })
              }), /* @__PURE__ */ x("div", {
                css: {
                  width: "100%",
                  maxWidth: 360,
                  padding: "64px 16px 0px",
                  paddingTop: 40,
                  paddingBottom: 40,
                  marginLeft: "auto",
                  marginRight: "auto",
                  "@media (min-width: 900px)": {
                    paddingTop: 80
                  }
                },
                children: [/* @__PURE__ */ y("img", {
                  src: l ? so : ao,
                  alt: P("LOGIN_FORM_CONTAINER_SWING_LOGO_ALT_TEXT"),
                  css: {
                    width: 32,
                    height: 32,
                    marginRight: "auto",
                    marginBottom: 16
                  }
                }), /* @__PURE__ */ x("h2", {
                  css: {
                    minHeight: 60,
                    // attempt to keep header size consistent between screens
                    fontFamily: "var(--swing-font-family-headers)",
                    fontSize: 24,
                    fontWeight: 400,
                    margin: 0,
                    marginRight: "auto",
                    padding: 0,
                    ...!l && {
                      color: C.white200
                    }
                  },
                  children: [!s && /* @__PURE__ */ y("div", {
                    css: {
                      fontSize: 12
                    },
                    children: l ? P("LOGIN_TITLE_SWING_SUBS_HEADER") : P("LOGIN_TITLE_SWING_SCHOOLS_HEADER")
                  }), /* @__PURE__ */ y("span", {
                    children: s || (l ? P("LOGIN_TITLE_SWING_SUBS") : t === "swing-schools" ? P("LOGIN_TITLE_SWING_SCHOOLS") : P("LOGIN_EMAIL_ENTRY_LOGIN_MESSAGE"))
                  })]
                })]
              })]
            })
          }), /* @__PURE__ */ y("div", {
            css: {
              width: "100%",
              height: "100%",
              display: "flex",
              position: "relative",
              zIndex: 3,
              flexDirection: "column",
              marginBottom: "auto",
              gap: 32,
              paddingLeft: 16,
              paddingRight: 16,
              marginTop: -16,
              "@media (min-width: 900px)": {
                maxWidth: 360,
                marginTop: -32
              }
            },
            children: r
          }), /* @__PURE__ */ y("div", {
            children: /* @__PURE__ */ y(Ya, {
              app: t,
              build: n,
              isWeb: i,
              version: a
            })
          })]
        })
      })]
    })
  });
}
const za = Aa("/terms"), qa = xa("/tips-to-log-into-swing");
function Ya(e) {
  const {
    app: t,
    build: n,
    isWeb: r,
    version: i
  } = e;
  return /* @__PURE__ */ x("footer", {
    css: {
      padding: "16px 16px calc(16px + var(--ion-safe-area-bottom, 0))",
      fontSize: 16,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      gap: 8,
      "@media (min-width: 900px)": {
        fontSize: 12
      }
    },
    children: [r && /* @__PURE__ */ y(Ja, {
      app: t
    }), /* @__PURE__ */ x("div", {
      children: [/* @__PURE__ */ y("a", {
        href: za,
        target: "_blank",
        rel: "noreferrer",
        children: P("LOGIN_FOOTER_TERMS_OF_SERVICE")
      }), /* @__PURE__ */ y("span", {
        css: {
          color: C.slate400,
          margin: "0 6px",
          fontSize: "1.5em",
          lineHeight: "normal",
          display: "inline-block"
        },
        children: "•"
      }), /* @__PURE__ */ y("a", {
        href: qa,
        target: "_blank",
        rel: "noreferrer",
        children: P("LOGIN_FOOTER_SUPPORT")
      })]
    }), /* @__PURE__ */ y(Za, {
      version: i,
      build: n,
      margin: "8px 0 0 0"
    })]
  });
}
function Xa(e) {
  const {
    isSubsApp: t,
    onBack: n
  } = e;
  return /* @__PURE__ */ y("div", {
    children: /* @__PURE__ */ x("button", {
      css: {
        display: "flex",
        alignItems: "center",
        background: "none"
      },
      onClick: n,
      "aria-label": P("FORGOT_PASSWORD_RESET_BACK_TO_LOGIN_ARIA_MESSAGE"),
      children: [/* @__PURE__ */ y(ne, {
        name: "Arrow Left",
        color: t ? C.blue500 : C.white200
      }), /* @__PURE__ */ y("span", {
        css: {
          cursor: "pointer",
          fontWeight: "var(--swing-font-medium)",
          color: t ? "var(--ion-color-primary)" : C.white200
        },
        children: P("FORGOT_PASSWORD_LABEL_BACK")
      })]
    })
  });
}
function Ja(e) {
  const {
    app: t
  } = e, n = t === "swing-subs", r = Di(), i = Ri(), o = xi(), s = Oi();
  return /* @__PURE__ */ x("div", {
    css: {
      display: "flex",
      gap: 16
    },
    children: [/* @__PURE__ */ y("a", {
      href: n ? r : o,
      target: "_blank",
      rel: "noreferrer",
      children: /* @__PURE__ */ y("img", {
        src: co,
        alt: P("APP_STORE_ALT_TEXT")
      })
    }), /* @__PURE__ */ y("a", {
      href: n ? i : s,
      target: "_blank",
      rel: "noreferrer",
      children: /* @__PURE__ */ y("img", {
        src: uo,
        alt: P("GOOGLE_PLAY_ALT_TEXT")
      })
    })]
  });
}
function Za(e) {
  const {
    version: t,
    build: n,
    margin: r
  } = e;
  return !t && !n ? null : /* @__PURE__ */ x("div", {
    css: {
      margin: r,
      fontSize: 12,
      color: C.slate400
    },
    children: [/* @__PURE__ */ x("span", {
      children: ["Version ", t]
    }), /* @__PURE__ */ y("span", {
      children: " • "
    }), /* @__PURE__ */ x("span", {
      children: ["Build ", n]
    })]
  });
}
var Tr;
(function(e) {
  e.IndexedDbLocal = "INDEXED_DB_LOCAL", e.InMemory = "IN_MEMORY", e.BrowserLocal = "BROWSER_LOCAL", e.BrowserSession = "BROWSER_SESSION";
})(Tr || (Tr = {}));
var br;
(function(e) {
  e.APPLE = "apple.com", e.FACEBOOK = "facebook.com", e.GAME_CENTER = "gc.apple.com", e.GITHUB = "github.com", e.GOOGLE = "google.com", e.MICROSOFT = "microsoft.com", e.PLAY_GAMES = "playgames.google.com", e.TWITTER = "twitter.com", e.YAHOO = "yahoo.com", e.PASSWORD = "password", e.PHONE = "phone";
})(br || (br = {}));
const ze = ho("FirebaseAuthentication", {
  web: () => import("./web-zZ_O06YC.js").then((e) => new e.FirebaseAuthenticationWeb())
});
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Qa = /* @__PURE__ */ function() {
  function e(n) {
    var r = n || {}, i = r.ValidationData, o = r.Username, s = r.Password, a = r.AuthParameters, l = r.ClientMetadata;
    this.validationData = i || {}, this.authParameters = a || {}, this.clientMetadata = l || {}, this.username = o, this.password = s;
  }
  var t = e.prototype;
  return t.getUsername = function() {
    return this.username;
  }, t.getPassword = function() {
    return this.password;
  }, t.getValidationData = function() {
    return this.validationData;
  }, t.getAuthParameters = function() {
    return this.authParameters;
  }, t.getClientMetadata = function() {
    return this.clientMetadata;
  }, e;
}(), M = {}, $t = {};
$t.byteLength = nc;
$t.toByteArray = ic;
$t.fromByteArray = ac;
var _e = [], fe = [], ec = typeof Uint8Array < "u" ? Uint8Array : Array, nn = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var qe = 0, tc = nn.length; qe < tc; ++qe)
  _e[qe] = nn[qe], fe[nn.charCodeAt(qe)] = qe;
fe[45] = 62;
fe[95] = 63;
function Li(e) {
  var t = e.length;
  if (t % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var n = e.indexOf("=");
  n === -1 && (n = t);
  var r = n === t ? 0 : 4 - n % 4;
  return [n, r];
}
function nc(e) {
  var t = Li(e), n = t[0], r = t[1];
  return (n + r) * 3 / 4 - r;
}
function rc(e, t, n) {
  return (t + n) * 3 / 4 - n;
}
function ic(e) {
  var t, n = Li(e), r = n[0], i = n[1], o = new ec(rc(e, r, i)), s = 0, a = i > 0 ? r - 4 : r, l;
  for (l = 0; l < a; l += 4)
    t = fe[e.charCodeAt(l)] << 18 | fe[e.charCodeAt(l + 1)] << 12 | fe[e.charCodeAt(l + 2)] << 6 | fe[e.charCodeAt(l + 3)], o[s++] = t >> 16 & 255, o[s++] = t >> 8 & 255, o[s++] = t & 255;
  return i === 2 && (t = fe[e.charCodeAt(l)] << 2 | fe[e.charCodeAt(l + 1)] >> 4, o[s++] = t & 255), i === 1 && (t = fe[e.charCodeAt(l)] << 10 | fe[e.charCodeAt(l + 1)] << 4 | fe[e.charCodeAt(l + 2)] >> 2, o[s++] = t >> 8 & 255, o[s++] = t & 255), o;
}
function oc(e) {
  return _e[e >> 18 & 63] + _e[e >> 12 & 63] + _e[e >> 6 & 63] + _e[e & 63];
}
function sc(e, t, n) {
  for (var r, i = [], o = t; o < n; o += 3)
    r = (e[o] << 16 & 16711680) + (e[o + 1] << 8 & 65280) + (e[o + 2] & 255), i.push(oc(r));
  return i.join("");
}
function ac(e) {
  for (var t, n = e.length, r = n % 3, i = [], o = 16383, s = 0, a = n - r; s < a; s += o)
    i.push(sc(e, s, s + o > a ? a : s + o));
  return r === 1 ? (t = e[n - 1], i.push(
    _e[t >> 2] + _e[t << 4 & 63] + "=="
  )) : r === 2 && (t = (e[n - 2] << 8) + e[n - 1], i.push(
    _e[t >> 10] + _e[t >> 4 & 63] + _e[t << 2 & 63] + "="
  )), i.join("");
}
var tr = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
tr.read = function(e, t, n, r, i) {
  var o, s, a = i * 8 - r - 1, l = (1 << a) - 1, f = l >> 1, g = -7, p = n ? i - 1 : 0, m = n ? -1 : 1, E = e[t + p];
  for (p += m, o = E & (1 << -g) - 1, E >>= -g, g += a; g > 0; o = o * 256 + e[t + p], p += m, g -= 8)
    ;
  for (s = o & (1 << -g) - 1, o >>= -g, g += r; g > 0; s = s * 256 + e[t + p], p += m, g -= 8)
    ;
  if (o === 0)
    o = 1 - f;
  else {
    if (o === l)
      return s ? NaN : (E ? -1 : 1) * (1 / 0);
    s = s + Math.pow(2, r), o = o - f;
  }
  return (E ? -1 : 1) * s * Math.pow(2, o - r);
};
tr.write = function(e, t, n, r, i, o) {
  var s, a, l, f = o * 8 - i - 1, g = (1 << f) - 1, p = g >> 1, m = i === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, E = r ? 0 : o - 1, _ = r ? 1 : -1, S = t < 0 || t === 0 && 1 / t < 0 ? 1 : 0;
  for (t = Math.abs(t), isNaN(t) || t === 1 / 0 ? (a = isNaN(t) ? 1 : 0, s = g) : (s = Math.floor(Math.log(t) / Math.LN2), t * (l = Math.pow(2, -s)) < 1 && (s--, l *= 2), s + p >= 1 ? t += m / l : t += m * Math.pow(2, 1 - p), t * l >= 2 && (s++, l /= 2), s + p >= g ? (a = 0, s = g) : s + p >= 1 ? (a = (t * l - 1) * Math.pow(2, i), s = s + p) : (a = t * Math.pow(2, p - 1) * Math.pow(2, i), s = 0)); i >= 8; e[n + E] = a & 255, E += _, a /= 256, i -= 8)
    ;
  for (s = s << i | a, f += i; f > 0; e[n + E] = s & 255, E += _, s /= 256, f -= 8)
    ;
  e[n + E - _] |= S * 128;
};
var cc = {}.toString, uc = Array.isArray || function(e) {
  return cc.call(e) == "[object Array]";
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <http://feross.org>
 * @license  MIT
 */
(function(e) {
  var t = $t, n = tr, r = uc;
  e.Buffer = a, e.SlowBuffer = R, e.INSPECT_MAX_BYTES = 50, a.TYPED_ARRAY_SUPPORT = j.TYPED_ARRAY_SUPPORT !== void 0 ? j.TYPED_ARRAY_SUPPORT : i(), e.kMaxLength = o();
  function i() {
    try {
      var h = new Uint8Array(1);
      return h.__proto__ = { __proto__: Uint8Array.prototype, foo: function() {
        return 42;
      } }, h.foo() === 42 && // typed array instances can be augmented
      typeof h.subarray == "function" && // chrome 9-10 lack `subarray`
      h.subarray(1, 1).byteLength === 0;
    } catch {
      return !1;
    }
  }
  function o() {
    return a.TYPED_ARRAY_SUPPORT ? 2147483647 : 1073741823;
  }
  function s(h, c) {
    if (o() < c)
      throw new RangeError("Invalid typed array length");
    return a.TYPED_ARRAY_SUPPORT ? (h = new Uint8Array(c), h.__proto__ = a.prototype) : (h === null && (h = new a(c)), h.length = c), h;
  }
  function a(h, c, u) {
    if (!a.TYPED_ARRAY_SUPPORT && !(this instanceof a))
      return new a(h, c, u);
    if (typeof h == "number") {
      if (typeof c == "string")
        throw new Error(
          "If encoding is specified then the first argument must be a string"
        );
      return p(this, h);
    }
    return l(this, h, c, u);
  }
  a.poolSize = 8192, a._augment = function(h) {
    return h.__proto__ = a.prototype, h;
  };
  function l(h, c, u, d) {
    if (typeof c == "number")
      throw new TypeError('"value" argument must not be a number');
    return typeof ArrayBuffer < "u" && c instanceof ArrayBuffer ? _(h, c, u, d) : typeof c == "string" ? m(h, c, u) : S(h, c);
  }
  a.from = function(h, c, u) {
    return l(null, h, c, u);
  }, a.TYPED_ARRAY_SUPPORT && (a.prototype.__proto__ = Uint8Array.prototype, a.__proto__ = Uint8Array, typeof Symbol < "u" && Symbol.species && a[Symbol.species] === a && Object.defineProperty(a, Symbol.species, {
    value: null,
    configurable: !0
  }));
  function f(h) {
    if (typeof h != "number")
      throw new TypeError('"size" argument must be a number');
    if (h < 0)
      throw new RangeError('"size" argument must not be negative');
  }
  function g(h, c, u, d) {
    return f(c), c <= 0 ? s(h, c) : u !== void 0 ? typeof d == "string" ? s(h, c).fill(u, d) : s(h, c).fill(u) : s(h, c);
  }
  a.alloc = function(h, c, u) {
    return g(null, h, c, u);
  };
  function p(h, c) {
    if (f(c), h = s(h, c < 0 ? 0 : b(c) | 0), !a.TYPED_ARRAY_SUPPORT)
      for (var u = 0; u < c; ++u)
        h[u] = 0;
    return h;
  }
  a.allocUnsafe = function(h) {
    return p(null, h);
  }, a.allocUnsafeSlow = function(h) {
    return p(null, h);
  };
  function m(h, c, u) {
    if ((typeof u != "string" || u === "") && (u = "utf8"), !a.isEncoding(u))
      throw new TypeError('"encoding" must be a valid string encoding');
    var d = L(c, u) | 0;
    h = s(h, d);
    var v = h.write(c, u);
    return v !== d && (h = h.slice(0, v)), h;
  }
  function E(h, c) {
    var u = c.length < 0 ? 0 : b(c.length) | 0;
    h = s(h, u);
    for (var d = 0; d < u; d += 1)
      h[d] = c[d] & 255;
    return h;
  }
  function _(h, c, u, d) {
    if (c.byteLength, u < 0 || c.byteLength < u)
      throw new RangeError("'offset' is out of bounds");
    if (c.byteLength < u + (d || 0))
      throw new RangeError("'length' is out of bounds");
    return u === void 0 && d === void 0 ? c = new Uint8Array(c) : d === void 0 ? c = new Uint8Array(c, u) : c = new Uint8Array(c, u, d), a.TYPED_ARRAY_SUPPORT ? (h = c, h.__proto__ = a.prototype) : h = E(h, c), h;
  }
  function S(h, c) {
    if (a.isBuffer(c)) {
      var u = b(c.length) | 0;
      return h = s(h, u), h.length === 0 || c.copy(h, 0, 0, u), h;
    }
    if (c) {
      if (typeof ArrayBuffer < "u" && c.buffer instanceof ArrayBuffer || "length" in c)
        return typeof c.length != "number" || Qi(c.length) ? s(h, 0) : E(h, c);
      if (c.type === "Buffer" && r(c.data))
        return E(h, c.data);
    }
    throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.");
  }
  function b(h) {
    if (h >= o())
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + o().toString(16) + " bytes");
    return h | 0;
  }
  function R(h) {
    return +h != h && (h = 0), a.alloc(+h);
  }
  a.isBuffer = function(c) {
    return !!(c != null && c._isBuffer);
  }, a.compare = function(c, u) {
    if (!a.isBuffer(c) || !a.isBuffer(u))
      throw new TypeError("Arguments must be Buffers");
    if (c === u) return 0;
    for (var d = c.length, v = u.length, w = 0, A = Math.min(d, v); w < A; ++w)
      if (c[w] !== u[w]) {
        d = c[w], v = u[w];
        break;
      }
    return d < v ? -1 : v < d ? 1 : 0;
  }, a.isEncoding = function(c) {
    switch (String(c).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, a.concat = function(c, u) {
    if (!r(c))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (c.length === 0)
      return a.alloc(0);
    var d;
    if (u === void 0)
      for (u = 0, d = 0; d < c.length; ++d)
        u += c[d].length;
    var v = a.allocUnsafe(u), w = 0;
    for (d = 0; d < c.length; ++d) {
      var A = c[d];
      if (!a.isBuffer(A))
        throw new TypeError('"list" argument must be an Array of Buffers');
      A.copy(v, w), w += A.length;
    }
    return v;
  };
  function L(h, c) {
    if (a.isBuffer(h))
      return h.length;
    if (typeof ArrayBuffer < "u" && typeof ArrayBuffer.isView == "function" && (ArrayBuffer.isView(h) || h instanceof ArrayBuffer))
      return h.byteLength;
    typeof h != "string" && (h = "" + h);
    var u = h.length;
    if (u === 0) return 0;
    for (var d = !1; ; )
      switch (c) {
        case "ascii":
        case "latin1":
        case "binary":
          return u;
        case "utf8":
        case "utf-8":
        case void 0:
          return G(h).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return u * 2;
        case "hex":
          return u >>> 1;
        case "base64":
          return ve(h).length;
        default:
          if (d) return G(h).length;
          c = ("" + c).toLowerCase(), d = !0;
      }
  }
  a.byteLength = L;
  function ge(h, c, u) {
    var d = !1;
    if ((c === void 0 || c < 0) && (c = 0), c > this.length || ((u === void 0 || u > this.length) && (u = this.length), u <= 0) || (u >>>= 0, c >>>= 0, u <= c))
      return "";
    for (h || (h = "utf8"); ; )
      switch (h) {
        case "hex":
          return wt(this, c, u);
        case "utf8":
        case "utf-8":
          return De(this, c, u);
        case "ascii":
          return Ke(this, c, u);
        case "latin1":
        case "binary":
          return tt(this, c, u);
        case "base64":
          return X(this, c, u);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return At(this, c, u);
        default:
          if (d) throw new TypeError("Unknown encoding: " + h);
          h = (h + "").toLowerCase(), d = !0;
      }
  }
  a.prototype._isBuffer = !0;
  function q(h, c, u) {
    var d = h[c];
    h[c] = h[u], h[u] = d;
  }
  a.prototype.swap16 = function() {
    var c = this.length;
    if (c % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (var u = 0; u < c; u += 2)
      q(this, u, u + 1);
    return this;
  }, a.prototype.swap32 = function() {
    var c = this.length;
    if (c % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (var u = 0; u < c; u += 4)
      q(this, u, u + 3), q(this, u + 1, u + 2);
    return this;
  }, a.prototype.swap64 = function() {
    var c = this.length;
    if (c % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (var u = 0; u < c; u += 8)
      q(this, u, u + 7), q(this, u + 1, u + 6), q(this, u + 2, u + 5), q(this, u + 3, u + 4);
    return this;
  }, a.prototype.toString = function() {
    var c = this.length | 0;
    return c === 0 ? "" : arguments.length === 0 ? De(this, 0, c) : ge.apply(this, arguments);
  }, a.prototype.equals = function(c) {
    if (!a.isBuffer(c)) throw new TypeError("Argument must be a Buffer");
    return this === c ? !0 : a.compare(this, c) === 0;
  }, a.prototype.inspect = function() {
    var c = "", u = e.INSPECT_MAX_BYTES;
    return this.length > 0 && (c = this.toString("hex", 0, u).match(/.{2}/g).join(" "), this.length > u && (c += " ... ")), "<Buffer " + c + ">";
  }, a.prototype.compare = function(c, u, d, v, w) {
    if (!a.isBuffer(c))
      throw new TypeError("Argument must be a Buffer");
    if (u === void 0 && (u = 0), d === void 0 && (d = c ? c.length : 0), v === void 0 && (v = 0), w === void 0 && (w = this.length), u < 0 || d > c.length || v < 0 || w > this.length)
      throw new RangeError("out of range index");
    if (v >= w && u >= d)
      return 0;
    if (v >= w)
      return -1;
    if (u >= d)
      return 1;
    if (u >>>= 0, d >>>= 0, v >>>= 0, w >>>= 0, this === c) return 0;
    for (var A = w - v, F = d - u, B = Math.min(A, F), W = this.slice(v, w), te = c.slice(u, d), K = 0; K < B; ++K)
      if (W[K] !== te[K]) {
        A = W[K], F = te[K];
        break;
      }
    return A < F ? -1 : F < A ? 1 : 0;
  };
  function me(h, c, u, d, v) {
    if (h.length === 0) return -1;
    if (typeof u == "string" ? (d = u, u = 0) : u > 2147483647 ? u = 2147483647 : u < -2147483648 && (u = -2147483648), u = +u, isNaN(u) && (u = v ? 0 : h.length - 1), u < 0 && (u = h.length + u), u >= h.length) {
      if (v) return -1;
      u = h.length - 1;
    } else if (u < 0)
      if (v) u = 0;
      else return -1;
    if (typeof c == "string" && (c = a.from(c, d)), a.isBuffer(c))
      return c.length === 0 ? -1 : ue(h, c, u, d, v);
    if (typeof c == "number")
      return c = c & 255, a.TYPED_ARRAY_SUPPORT && typeof Uint8Array.prototype.indexOf == "function" ? v ? Uint8Array.prototype.indexOf.call(h, c, u) : Uint8Array.prototype.lastIndexOf.call(h, c, u) : ue(h, [c], u, d, v);
    throw new TypeError("val must be string, number or Buffer");
  }
  function ue(h, c, u, d, v) {
    var w = 1, A = h.length, F = c.length;
    if (d !== void 0 && (d = String(d).toLowerCase(), d === "ucs2" || d === "ucs-2" || d === "utf16le" || d === "utf-16le")) {
      if (h.length < 2 || c.length < 2)
        return -1;
      w = 2, A /= 2, F /= 2, u /= 2;
    }
    function B(cr, ur) {
      return w === 1 ? cr[ur] : cr.readUInt16BE(ur * w);
    }
    var W;
    if (v) {
      var te = -1;
      for (W = u; W < A; W++)
        if (B(h, W) === B(c, te === -1 ? 0 : W - te)) {
          if (te === -1 && (te = W), W - te + 1 === F) return te * w;
        } else
          te !== -1 && (W -= W - te), te = -1;
    } else
      for (u + F > A && (u = A - F), W = u; W >= 0; W--) {
        for (var K = !0, Ct = 0; Ct < F; Ct++)
          if (B(h, W + Ct) !== B(c, Ct)) {
            K = !1;
            break;
          }
        if (K) return W;
      }
    return -1;
  }
  a.prototype.includes = function(c, u, d) {
    return this.indexOf(c, u, d) !== -1;
  }, a.prototype.indexOf = function(c, u, d) {
    return me(this, c, u, d, !0);
  }, a.prototype.lastIndexOf = function(c, u, d) {
    return me(this, c, u, d, !1);
  };
  function Se(h, c, u, d) {
    u = Number(u) || 0;
    var v = h.length - u;
    d ? (d = Number(d), d > v && (d = v)) : d = v;
    var w = c.length;
    if (w % 2 !== 0) throw new TypeError("Invalid hex string");
    d > w / 2 && (d = w / 2);
    for (var A = 0; A < d; ++A) {
      var F = parseInt(c.substr(A * 2, 2), 16);
      if (isNaN(F)) return A;
      h[u + A] = F;
    }
    return A;
  }
  function V(h, c, u, d) {
    return Re(G(c, h.length - u), h, u, d);
  }
  function Y(h, c, u, d) {
    return Re(k(c), h, u, d);
  }
  function J(h, c, u, d) {
    return Y(h, c, u, d);
  }
  function we(h, c, u, d) {
    return Re(ve(c), h, u, d);
  }
  function Ae(h, c, u, d) {
    return Re(Te(c, h.length - u), h, u, d);
  }
  a.prototype.write = function(c, u, d, v) {
    if (u === void 0)
      v = "utf8", d = this.length, u = 0;
    else if (d === void 0 && typeof u == "string")
      v = u, d = this.length, u = 0;
    else if (isFinite(u))
      u = u | 0, isFinite(d) ? (d = d | 0, v === void 0 && (v = "utf8")) : (v = d, d = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    var w = this.length - u;
    if ((d === void 0 || d > w) && (d = w), c.length > 0 && (d < 0 || u < 0) || u > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    v || (v = "utf8");
    for (var A = !1; ; )
      switch (v) {
        case "hex":
          return Se(this, c, u, d);
        case "utf8":
        case "utf-8":
          return V(this, c, u, d);
        case "ascii":
          return Y(this, c, u, d);
        case "latin1":
        case "binary":
          return J(this, c, u, d);
        case "base64":
          return we(this, c, u, d);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return Ae(this, c, u, d);
        default:
          if (A) throw new TypeError("Unknown encoding: " + v);
          v = ("" + v).toLowerCase(), A = !0;
      }
  }, a.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function X(h, c, u) {
    return c === 0 && u === h.length ? t.fromByteArray(h) : t.fromByteArray(h.slice(c, u));
  }
  function De(h, c, u) {
    u = Math.min(h.length, u);
    for (var d = [], v = c; v < u; ) {
      var w = h[v], A = null, F = w > 239 ? 4 : w > 223 ? 3 : w > 191 ? 2 : 1;
      if (v + F <= u) {
        var B, W, te, K;
        switch (F) {
          case 1:
            w < 128 && (A = w);
            break;
          case 2:
            B = h[v + 1], (B & 192) === 128 && (K = (w & 31) << 6 | B & 63, K > 127 && (A = K));
            break;
          case 3:
            B = h[v + 1], W = h[v + 2], (B & 192) === 128 && (W & 192) === 128 && (K = (w & 15) << 12 | (B & 63) << 6 | W & 63, K > 2047 && (K < 55296 || K > 57343) && (A = K));
            break;
          case 4:
            B = h[v + 1], W = h[v + 2], te = h[v + 3], (B & 192) === 128 && (W & 192) === 128 && (te & 192) === 128 && (K = (w & 15) << 18 | (B & 63) << 12 | (W & 63) << 6 | te & 63, K > 65535 && K < 1114112 && (A = K));
        }
      }
      A === null ? (A = 65533, F = 1) : A > 65535 && (A -= 65536, d.push(A >>> 10 & 1023 | 55296), A = 56320 | A & 1023), d.push(A), v += F;
    }
    return Ce(d);
  }
  var Ee = 4096;
  function Ce(h) {
    var c = h.length;
    if (c <= Ee)
      return String.fromCharCode.apply(String, h);
    for (var u = "", d = 0; d < c; )
      u += String.fromCharCode.apply(
        String,
        h.slice(d, d += Ee)
      );
    return u;
  }
  function Ke(h, c, u) {
    var d = "";
    u = Math.min(h.length, u);
    for (var v = c; v < u; ++v)
      d += String.fromCharCode(h[v] & 127);
    return d;
  }
  function tt(h, c, u) {
    var d = "";
    u = Math.min(h.length, u);
    for (var v = c; v < u; ++v)
      d += String.fromCharCode(h[v]);
    return d;
  }
  function wt(h, c, u) {
    var d = h.length;
    (!c || c < 0) && (c = 0), (!u || u < 0 || u > d) && (u = d);
    for (var v = "", w = c; w < u; ++w)
      v += $(h[w]);
    return v;
  }
  function At(h, c, u) {
    for (var d = h.slice(c, u), v = "", w = 0; w < d.length; w += 2)
      v += String.fromCharCode(d[w] + d[w + 1] * 256);
    return v;
  }
  a.prototype.slice = function(c, u) {
    var d = this.length;
    c = ~~c, u = u === void 0 ? d : ~~u, c < 0 ? (c += d, c < 0 && (c = 0)) : c > d && (c = d), u < 0 ? (u += d, u < 0 && (u = 0)) : u > d && (u = d), u < c && (u = c);
    var v;
    if (a.TYPED_ARRAY_SUPPORT)
      v = this.subarray(c, u), v.__proto__ = a.prototype;
    else {
      var w = u - c;
      v = new a(w, void 0);
      for (var A = 0; A < w; ++A)
        v[A] = this[A + c];
    }
    return v;
  };
  function z(h, c, u) {
    if (h % 1 !== 0 || h < 0) throw new RangeError("offset is not uint");
    if (h + c > u) throw new RangeError("Trying to access beyond buffer length");
  }
  a.prototype.readUIntLE = function(c, u, d) {
    c = c | 0, u = u | 0, d || z(c, u, this.length);
    for (var v = this[c], w = 1, A = 0; ++A < u && (w *= 256); )
      v += this[c + A] * w;
    return v;
  }, a.prototype.readUIntBE = function(c, u, d) {
    c = c | 0, u = u | 0, d || z(c, u, this.length);
    for (var v = this[c + --u], w = 1; u > 0 && (w *= 256); )
      v += this[c + --u] * w;
    return v;
  }, a.prototype.readUInt8 = function(c, u) {
    return u || z(c, 1, this.length), this[c];
  }, a.prototype.readUInt16LE = function(c, u) {
    return u || z(c, 2, this.length), this[c] | this[c + 1] << 8;
  }, a.prototype.readUInt16BE = function(c, u) {
    return u || z(c, 2, this.length), this[c] << 8 | this[c + 1];
  }, a.prototype.readUInt32LE = function(c, u) {
    return u || z(c, 4, this.length), (this[c] | this[c + 1] << 8 | this[c + 2] << 16) + this[c + 3] * 16777216;
  }, a.prototype.readUInt32BE = function(c, u) {
    return u || z(c, 4, this.length), this[c] * 16777216 + (this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3]);
  }, a.prototype.readIntLE = function(c, u, d) {
    c = c | 0, u = u | 0, d || z(c, u, this.length);
    for (var v = this[c], w = 1, A = 0; ++A < u && (w *= 256); )
      v += this[c + A] * w;
    return w *= 128, v >= w && (v -= Math.pow(2, 8 * u)), v;
  }, a.prototype.readIntBE = function(c, u, d) {
    c = c | 0, u = u | 0, d || z(c, u, this.length);
    for (var v = u, w = 1, A = this[c + --v]; v > 0 && (w *= 256); )
      A += this[c + --v] * w;
    return w *= 128, A >= w && (A -= Math.pow(2, 8 * u)), A;
  }, a.prototype.readInt8 = function(c, u) {
    return u || z(c, 1, this.length), this[c] & 128 ? (255 - this[c] + 1) * -1 : this[c];
  }, a.prototype.readInt16LE = function(c, u) {
    u || z(c, 2, this.length);
    var d = this[c] | this[c + 1] << 8;
    return d & 32768 ? d | 4294901760 : d;
  }, a.prototype.readInt16BE = function(c, u) {
    u || z(c, 2, this.length);
    var d = this[c + 1] | this[c] << 8;
    return d & 32768 ? d | 4294901760 : d;
  }, a.prototype.readInt32LE = function(c, u) {
    return u || z(c, 4, this.length), this[c] | this[c + 1] << 8 | this[c + 2] << 16 | this[c + 3] << 24;
  }, a.prototype.readInt32BE = function(c, u) {
    return u || z(c, 4, this.length), this[c] << 24 | this[c + 1] << 16 | this[c + 2] << 8 | this[c + 3];
  }, a.prototype.readFloatLE = function(c, u) {
    return u || z(c, 4, this.length), n.read(this, c, !0, 23, 4);
  }, a.prototype.readFloatBE = function(c, u) {
    return u || z(c, 4, this.length), n.read(this, c, !1, 23, 4);
  }, a.prototype.readDoubleLE = function(c, u) {
    return u || z(c, 8, this.length), n.read(this, c, !0, 52, 8);
  }, a.prototype.readDoubleBE = function(c, u) {
    return u || z(c, 8, this.length), n.read(this, c, !1, 52, 8);
  };
  function Z(h, c, u, d, v, w) {
    if (!a.isBuffer(h)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (c > v || c < w) throw new RangeError('"value" argument is out of bounds');
    if (u + d > h.length) throw new RangeError("Index out of range");
  }
  a.prototype.writeUIntLE = function(c, u, d, v) {
    if (c = +c, u = u | 0, d = d | 0, !v) {
      var w = Math.pow(2, 8 * d) - 1;
      Z(this, c, u, d, w, 0);
    }
    var A = 1, F = 0;
    for (this[u] = c & 255; ++F < d && (A *= 256); )
      this[u + F] = c / A & 255;
    return u + d;
  }, a.prototype.writeUIntBE = function(c, u, d, v) {
    if (c = +c, u = u | 0, d = d | 0, !v) {
      var w = Math.pow(2, 8 * d) - 1;
      Z(this, c, u, d, w, 0);
    }
    var A = d - 1, F = 1;
    for (this[u + A] = c & 255; --A >= 0 && (F *= 256); )
      this[u + A] = c / F & 255;
    return u + d;
  }, a.prototype.writeUInt8 = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 1, 255, 0), a.TYPED_ARRAY_SUPPORT || (c = Math.floor(c)), this[u] = c & 255, u + 1;
  };
  function Le(h, c, u, d) {
    c < 0 && (c = 65535 + c + 1);
    for (var v = 0, w = Math.min(h.length - u, 2); v < w; ++v)
      h[u + v] = (c & 255 << 8 * (d ? v : 1 - v)) >>> (d ? v : 1 - v) * 8;
  }
  a.prototype.writeUInt16LE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 2, 65535, 0), a.TYPED_ARRAY_SUPPORT ? (this[u] = c & 255, this[u + 1] = c >>> 8) : Le(this, c, u, !0), u + 2;
  }, a.prototype.writeUInt16BE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 2, 65535, 0), a.TYPED_ARRAY_SUPPORT ? (this[u] = c >>> 8, this[u + 1] = c & 255) : Le(this, c, u, !1), u + 2;
  };
  function Fe(h, c, u, d) {
    c < 0 && (c = 4294967295 + c + 1);
    for (var v = 0, w = Math.min(h.length - u, 4); v < w; ++v)
      h[u + v] = c >>> (d ? v : 3 - v) * 8 & 255;
  }
  a.prototype.writeUInt32LE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 4, 4294967295, 0), a.TYPED_ARRAY_SUPPORT ? (this[u + 3] = c >>> 24, this[u + 2] = c >>> 16, this[u + 1] = c >>> 8, this[u] = c & 255) : Fe(this, c, u, !0), u + 4;
  }, a.prototype.writeUInt32BE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 4, 4294967295, 0), a.TYPED_ARRAY_SUPPORT ? (this[u] = c >>> 24, this[u + 1] = c >>> 16, this[u + 2] = c >>> 8, this[u + 3] = c & 255) : Fe(this, c, u, !1), u + 4;
  }, a.prototype.writeIntLE = function(c, u, d, v) {
    if (c = +c, u = u | 0, !v) {
      var w = Math.pow(2, 8 * d - 1);
      Z(this, c, u, d, w - 1, -w);
    }
    var A = 0, F = 1, B = 0;
    for (this[u] = c & 255; ++A < d && (F *= 256); )
      c < 0 && B === 0 && this[u + A - 1] !== 0 && (B = 1), this[u + A] = (c / F >> 0) - B & 255;
    return u + d;
  }, a.prototype.writeIntBE = function(c, u, d, v) {
    if (c = +c, u = u | 0, !v) {
      var w = Math.pow(2, 8 * d - 1);
      Z(this, c, u, d, w - 1, -w);
    }
    var A = d - 1, F = 1, B = 0;
    for (this[u + A] = c & 255; --A >= 0 && (F *= 256); )
      c < 0 && B === 0 && this[u + A + 1] !== 0 && (B = 1), this[u + A] = (c / F >> 0) - B & 255;
    return u + d;
  }, a.prototype.writeInt8 = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 1, 127, -128), a.TYPED_ARRAY_SUPPORT || (c = Math.floor(c)), c < 0 && (c = 255 + c + 1), this[u] = c & 255, u + 1;
  }, a.prototype.writeInt16LE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 2, 32767, -32768), a.TYPED_ARRAY_SUPPORT ? (this[u] = c & 255, this[u + 1] = c >>> 8) : Le(this, c, u, !0), u + 2;
  }, a.prototype.writeInt16BE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 2, 32767, -32768), a.TYPED_ARRAY_SUPPORT ? (this[u] = c >>> 8, this[u + 1] = c & 255) : Le(this, c, u, !1), u + 2;
  }, a.prototype.writeInt32LE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 4, 2147483647, -2147483648), a.TYPED_ARRAY_SUPPORT ? (this[u] = c & 255, this[u + 1] = c >>> 8, this[u + 2] = c >>> 16, this[u + 3] = c >>> 24) : Fe(this, c, u, !0), u + 4;
  }, a.prototype.writeInt32BE = function(c, u, d) {
    return c = +c, u = u | 0, d || Z(this, c, u, 4, 2147483647, -2147483648), c < 0 && (c = 4294967295 + c + 1), a.TYPED_ARRAY_SUPPORT ? (this[u] = c >>> 24, this[u + 1] = c >>> 16, this[u + 2] = c >>> 8, this[u + 3] = c & 255) : Fe(this, c, u, !1), u + 4;
  };
  function Zt(h, c, u, d, v, w) {
    if (u + d > h.length) throw new RangeError("Index out of range");
    if (u < 0) throw new RangeError("Index out of range");
  }
  function nt(h, c, u, d, v) {
    return v || Zt(h, c, u, 4), n.write(h, c, u, d, 23, 4), u + 4;
  }
  a.prototype.writeFloatLE = function(c, u, d) {
    return nt(this, c, u, !0, d);
  }, a.prototype.writeFloatBE = function(c, u, d) {
    return nt(this, c, u, !1, d);
  };
  function D(h, c, u, d, v) {
    return v || Zt(h, c, u, 8), n.write(h, c, u, d, 52, 8), u + 8;
  }
  a.prototype.writeDoubleLE = function(c, u, d) {
    return D(this, c, u, !0, d);
  }, a.prototype.writeDoubleBE = function(c, u, d) {
    return D(this, c, u, !1, d);
  }, a.prototype.copy = function(c, u, d, v) {
    if (d || (d = 0), !v && v !== 0 && (v = this.length), u >= c.length && (u = c.length), u || (u = 0), v > 0 && v < d && (v = d), v === d || c.length === 0 || this.length === 0) return 0;
    if (u < 0)
      throw new RangeError("targetStart out of bounds");
    if (d < 0 || d >= this.length) throw new RangeError("sourceStart out of bounds");
    if (v < 0) throw new RangeError("sourceEnd out of bounds");
    v > this.length && (v = this.length), c.length - u < v - d && (v = c.length - u + d);
    var w = v - d, A;
    if (this === c && d < u && u < v)
      for (A = w - 1; A >= 0; --A)
        c[A + u] = this[A + d];
    else if (w < 1e3 || !a.TYPED_ARRAY_SUPPORT)
      for (A = 0; A < w; ++A)
        c[A + u] = this[A + d];
    else
      Uint8Array.prototype.set.call(
        c,
        this.subarray(d, d + w),
        u
      );
    return w;
  }, a.prototype.fill = function(c, u, d, v) {
    if (typeof c == "string") {
      if (typeof u == "string" ? (v = u, u = 0, d = this.length) : typeof d == "string" && (v = d, d = this.length), c.length === 1) {
        var w = c.charCodeAt(0);
        w < 256 && (c = w);
      }
      if (v !== void 0 && typeof v != "string")
        throw new TypeError("encoding must be a string");
      if (typeof v == "string" && !a.isEncoding(v))
        throw new TypeError("Unknown encoding: " + v);
    } else typeof c == "number" && (c = c & 255);
    if (u < 0 || this.length < u || this.length < d)
      throw new RangeError("Out of range index");
    if (d <= u)
      return this;
    u = u >>> 0, d = d === void 0 ? this.length : d >>> 0, c || (c = 0);
    var A;
    if (typeof c == "number")
      for (A = u; A < d; ++A)
        this[A] = c;
    else {
      var F = a.isBuffer(c) ? c : G(new a(c, v).toString()), B = F.length;
      for (A = 0; A < d - u; ++A)
        this[A + u] = F[A % B];
    }
    return this;
  };
  var T = /[^+\/0-9A-Za-z-_]/g;
  function O(h) {
    if (h = U(h).replace(T, ""), h.length < 2) return "";
    for (; h.length % 4 !== 0; )
      h = h + "=";
    return h;
  }
  function U(h) {
    return h.trim ? h.trim() : h.replace(/^\s+|\s+$/g, "");
  }
  function $(h) {
    return h < 16 ? "0" + h.toString(16) : h.toString(16);
  }
  function G(h, c) {
    c = c || 1 / 0;
    for (var u, d = h.length, v = null, w = [], A = 0; A < d; ++A) {
      if (u = h.charCodeAt(A), u > 55295 && u < 57344) {
        if (!v) {
          if (u > 56319) {
            (c -= 3) > -1 && w.push(239, 191, 189);
            continue;
          } else if (A + 1 === d) {
            (c -= 3) > -1 && w.push(239, 191, 189);
            continue;
          }
          v = u;
          continue;
        }
        if (u < 56320) {
          (c -= 3) > -1 && w.push(239, 191, 189), v = u;
          continue;
        }
        u = (v - 55296 << 10 | u - 56320) + 65536;
      } else v && (c -= 3) > -1 && w.push(239, 191, 189);
      if (v = null, u < 128) {
        if ((c -= 1) < 0) break;
        w.push(u);
      } else if (u < 2048) {
        if ((c -= 2) < 0) break;
        w.push(
          u >> 6 | 192,
          u & 63 | 128
        );
      } else if (u < 65536) {
        if ((c -= 3) < 0) break;
        w.push(
          u >> 12 | 224,
          u >> 6 & 63 | 128,
          u & 63 | 128
        );
      } else if (u < 1114112) {
        if ((c -= 4) < 0) break;
        w.push(
          u >> 18 | 240,
          u >> 12 & 63 | 128,
          u >> 6 & 63 | 128,
          u & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return w;
  }
  function k(h) {
    for (var c = [], u = 0; u < h.length; ++u)
      c.push(h.charCodeAt(u) & 255);
    return c;
  }
  function Te(h, c) {
    for (var u, d, v, w = [], A = 0; A < h.length && !((c -= 2) < 0); ++A)
      u = h.charCodeAt(A), d = u >> 8, v = u % 256, w.push(v), w.push(d);
    return w;
  }
  function ve(h) {
    return t.toByteArray(O(h));
  }
  function Re(h, c, u, d) {
    for (var v = 0; v < d && !(v + u >= c.length || v >= h.length); ++v)
      c[v + u] = h[v];
    return v;
  }
  function Qi(h) {
    return h !== h;
  }
})(M);
var he;
typeof window < "u" && window.crypto && (he = window.crypto);
!he && typeof window < "u" && window.msCrypto && (he = window.msCrypto);
!he && typeof global < "u" && global.crypto && (he = global.crypto);
if (!he && typeof require == "function")
  try {
    he = require("crypto");
  } catch {
  }
function lc() {
  if (he) {
    if (typeof he.getRandomValues == "function")
      try {
        return he.getRandomValues(new Uint32Array(1))[0];
      } catch {
      }
    if (typeof he.randomBytes == "function")
      try {
        return he.randomBytes(4).readInt32LE();
      } catch {
      }
  }
  throw new Error("Native crypto module could not be used to get secure random number.");
}
function fc(e) {
  for (var t = e.words, n = e.sigBytes, r = [], i = 0; i < n; i++) {
    var o = t[i >>> 2] >>> 24 - i % 4 * 8 & 255;
    r.push((o >>> 4).toString(16)), r.push((o & 15).toString(16));
  }
  return r.join("");
}
var hc = /* @__PURE__ */ function() {
  function e(n, r) {
    n = this.words = n || [], r != null ? this.sigBytes = r : this.sigBytes = n.length * 4;
  }
  var t = e.prototype;
  return t.random = function(r) {
    for (var i = [], o = 0; o < r; o += 4)
      i.push(lc());
    return new e(i, r);
  }, t.toString = function() {
    return fc(this);
  }, e;
}(), Je = {};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var yn = function(e, t) {
  return yn = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r) r.hasOwnProperty(i) && (n[i] = r[i]);
  }, yn(e, t);
};
function dc(e, t) {
  yn(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var Sn = function() {
  return Sn = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n) Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, Sn.apply(this, arguments);
};
function pc(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function gc(e, t, n, r) {
  var i = arguments.length, o = i < 3 ? t : r === null ? r = Object.getOwnPropertyDescriptor(t, n) : r, s;
  if (typeof Reflect == "object" && typeof Reflect.decorate == "function") o = Reflect.decorate(e, t, n, r);
  else for (var a = e.length - 1; a >= 0; a--) (s = e[a]) && (o = (i < 3 ? s(o) : i > 3 ? s(t, n, o) : s(t, n)) || o);
  return i > 3 && o && Object.defineProperty(t, n, o), o;
}
function mc(e, t) {
  return function(n, r) {
    t(n, r, e);
  };
}
function vc(e, t) {
  if (typeof Reflect == "object" && typeof Reflect.metadata == "function") return Reflect.metadata(e, t);
}
function yc(e, t, n, r) {
  function i(o) {
    return o instanceof n ? o : new n(function(s) {
      s(o);
    });
  }
  return new (n || (n = Promise))(function(o, s) {
    function a(g) {
      try {
        f(r.next(g));
      } catch (p) {
        s(p);
      }
    }
    function l(g) {
      try {
        f(r.throw(g));
      } catch (p) {
        s(p);
      }
    }
    function f(g) {
      g.done ? o(g.value) : i(g.value).then(a, l);
    }
    f((r = r.apply(e, t || [])).next());
  });
}
function Sc(e, t) {
  var n = { label: 0, sent: function() {
    if (o[0] & 1) throw o[1];
    return o[1];
  }, trys: [], ops: [] }, r, i, o, s;
  return s = { next: a(0), throw: a(1), return: a(2) }, typeof Symbol == "function" && (s[Symbol.iterator] = function() {
    return this;
  }), s;
  function a(f) {
    return function(g) {
      return l([f, g]);
    };
  }
  function l(f) {
    if (r) throw new TypeError("Generator is already executing.");
    for (; n; ) try {
      if (r = 1, i && (o = f[0] & 2 ? i.return : f[0] ? i.throw || ((o = i.return) && o.call(i), 0) : i.next) && !(o = o.call(i, f[1])).done) return o;
      switch (i = 0, o && (f = [f[0] & 2, o.value]), f[0]) {
        case 0:
        case 1:
          o = f;
          break;
        case 4:
          return n.label++, { value: f[1], done: !1 };
        case 5:
          n.label++, i = f[1], f = [0];
          continue;
        case 7:
          f = n.ops.pop(), n.trys.pop();
          continue;
        default:
          if (o = n.trys, !(o = o.length > 0 && o[o.length - 1]) && (f[0] === 6 || f[0] === 2)) {
            n = 0;
            continue;
          }
          if (f[0] === 3 && (!o || f[1] > o[0] && f[1] < o[3])) {
            n.label = f[1];
            break;
          }
          if (f[0] === 6 && n.label < o[1]) {
            n.label = o[1], o = f;
            break;
          }
          if (o && n.label < o[2]) {
            n.label = o[2], n.ops.push(f);
            break;
          }
          o[2] && n.ops.pop(), n.trys.pop();
          continue;
      }
      f = t.call(e, n);
    } catch (g) {
      f = [6, g], i = 0;
    } finally {
      r = o = 0;
    }
    if (f[0] & 5) throw f[1];
    return { value: f[0] ? f[1] : void 0, done: !0 };
  }
}
function Ec(e, t, n, r) {
  r === void 0 && (r = n), e[r] = t[n];
}
function _c(e, t) {
  for (var n in e) n !== "default" && !t.hasOwnProperty(n) && (t[n] = e[n]);
}
function En(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n) return n.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Fi(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n) return e;
  var r = n.call(e), i, o = [], s;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; ) o.push(i.value);
  } catch (a) {
    s = { error: a };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (s) throw s.error;
    }
  }
  return o;
}
function wc() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e = e.concat(Fi(arguments[t]));
  return e;
}
function Ac() {
  for (var e = 0, t = 0, n = arguments.length; t < n; t++) e += arguments[t].length;
  for (var r = Array(e), i = 0, t = 0; t < n; t++)
    for (var o = arguments[t], s = 0, a = o.length; s < a; s++, i++)
      r[i] = o[s];
  return r;
}
function yt(e) {
  return this instanceof yt ? (this.v = e, this) : new yt(e);
}
function Cc(e, t, n) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = n.apply(e, t || []), i, o = [];
  return i = {}, s("next"), s("throw"), s("return"), i[Symbol.asyncIterator] = function() {
    return this;
  }, i;
  function s(m) {
    r[m] && (i[m] = function(E) {
      return new Promise(function(_, S) {
        o.push([m, E, _, S]) > 1 || a(m, E);
      });
    });
  }
  function a(m, E) {
    try {
      l(r[m](E));
    } catch (_) {
      p(o[0][3], _);
    }
  }
  function l(m) {
    m.value instanceof yt ? Promise.resolve(m.value.v).then(f, g) : p(o[0][2], m);
  }
  function f(m) {
    a("next", m);
  }
  function g(m) {
    a("throw", m);
  }
  function p(m, E) {
    m(E), o.shift(), o.length && a(o[0][0], o[0][1]);
  }
}
function Tc(e) {
  var t, n;
  return t = {}, r("next"), r("throw", function(i) {
    throw i;
  }), r("return"), t[Symbol.iterator] = function() {
    return this;
  }, t;
  function r(i, o) {
    t[i] = e[i] ? function(s) {
      return (n = !n) ? { value: yt(e[i](s)), done: i === "return" } : o ? o(s) : s;
    } : o;
  }
}
function bc(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var t = e[Symbol.asyncIterator], n;
  return t ? t.call(e) : (e = typeof En == "function" ? En(e) : e[Symbol.iterator](), n = {}, r("next"), r("throw"), r("return"), n[Symbol.asyncIterator] = function() {
    return this;
  }, n);
  function r(o) {
    n[o] = e[o] && function(s) {
      return new Promise(function(a, l) {
        s = e[o](s), i(a, l, s.done, s.value);
      });
    };
  }
  function i(o, s, a, l) {
    Promise.resolve(l).then(function(f) {
      o({ value: f, done: a });
    }, s);
  }
}
function Ic(e, t) {
  return Object.defineProperty ? Object.defineProperty(e, "raw", { value: t }) : e.raw = t, e;
}
function Dc(e) {
  if (e && e.__esModule) return e;
  var t = {};
  if (e != null) for (var n in e) Object.hasOwnProperty.call(e, n) && (t[n] = e[n]);
  return t.default = e, t;
}
function Rc(e) {
  return e && e.__esModule ? e : { default: e };
}
function xc(e, t) {
  if (!t.has(e))
    throw new TypeError("attempted to get private field on non-instance");
  return t.get(e);
}
function Oc(e, t, n) {
  if (!t.has(e))
    throw new TypeError("attempted to set private field on non-instance");
  return t.set(e, n), n;
}
const Pc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get __assign() {
    return Sn;
  },
  __asyncDelegator: Tc,
  __asyncGenerator: Cc,
  __asyncValues: bc,
  __await: yt,
  __awaiter: yc,
  __classPrivateFieldGet: xc,
  __classPrivateFieldSet: Oc,
  __createBinding: Ec,
  __decorate: gc,
  __exportStar: _c,
  __extends: dc,
  __generator: Sc,
  __importDefault: Rc,
  __importStar: Dc,
  __makeTemplateObject: Ic,
  __metadata: vc,
  __param: mc,
  __read: Fi,
  __rest: pc,
  __spread: wc,
  __spreadArrays: Ac,
  __values: En
}, Symbol.toStringTag, { value: "Module" })), ki = /* @__PURE__ */ Gn(Pc);
var jt = {}, ce = {};
Object.defineProperty(ce, "__esModule", { value: !0 });
ce.MAX_HASHABLE_LENGTH = ce.INIT = ce.KEY = ce.DIGEST_LENGTH = ce.BLOCK_SIZE = void 0;
ce.BLOCK_SIZE = 64;
ce.DIGEST_LENGTH = 32;
ce.KEY = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]);
ce.INIT = [
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
];
ce.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
var Kt = {};
Object.defineProperty(Kt, "__esModule", { value: !0 });
Kt.RawSha256 = void 0;
var le = ce, Uc = (
  /** @class */
  function() {
    function e() {
      this.state = Int32Array.from(le.INIT), this.temp = new Int32Array(64), this.buffer = new Uint8Array(64), this.bufferLength = 0, this.bytesHashed = 0, this.finished = !1;
    }
    return e.prototype.update = function(t) {
      if (this.finished)
        throw new Error("Attempted to update an already finished hash.");
      var n = 0, r = t.byteLength;
      if (this.bytesHashed += r, this.bytesHashed * 8 > le.MAX_HASHABLE_LENGTH)
        throw new Error("Cannot hash more than 2^53 - 1 bits");
      for (; r > 0; )
        this.buffer[this.bufferLength++] = t[n++], r--, this.bufferLength === le.BLOCK_SIZE && (this.hashBuffer(), this.bufferLength = 0);
    }, e.prototype.digest = function() {
      if (!this.finished) {
        var t = this.bytesHashed * 8, n = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength), r = this.bufferLength;
        if (n.setUint8(this.bufferLength++, 128), r % le.BLOCK_SIZE >= le.BLOCK_SIZE - 8) {
          for (var i = this.bufferLength; i < le.BLOCK_SIZE; i++)
            n.setUint8(i, 0);
          this.hashBuffer(), this.bufferLength = 0;
        }
        for (var i = this.bufferLength; i < le.BLOCK_SIZE - 8; i++)
          n.setUint8(i, 0);
        n.setUint32(le.BLOCK_SIZE - 8, Math.floor(t / 4294967296), !0), n.setUint32(le.BLOCK_SIZE - 4, t), this.hashBuffer(), this.finished = !0;
      }
      for (var o = new Uint8Array(le.DIGEST_LENGTH), i = 0; i < 8; i++)
        o[i * 4] = this.state[i] >>> 24 & 255, o[i * 4 + 1] = this.state[i] >>> 16 & 255, o[i * 4 + 2] = this.state[i] >>> 8 & 255, o[i * 4 + 3] = this.state[i] >>> 0 & 255;
      return o;
    }, e.prototype.hashBuffer = function() {
      for (var t = this, n = t.buffer, r = t.state, i = r[0], o = r[1], s = r[2], a = r[3], l = r[4], f = r[5], g = r[6], p = r[7], m = 0; m < le.BLOCK_SIZE; m++) {
        if (m < 16)
          this.temp[m] = (n[m * 4] & 255) << 24 | (n[m * 4 + 1] & 255) << 16 | (n[m * 4 + 2] & 255) << 8 | n[m * 4 + 3] & 255;
        else {
          var E = this.temp[m - 2], _ = (E >>> 17 | E << 15) ^ (E >>> 19 | E << 13) ^ E >>> 10;
          E = this.temp[m - 15];
          var S = (E >>> 7 | E << 25) ^ (E >>> 18 | E << 14) ^ E >>> 3;
          this.temp[m] = (_ + this.temp[m - 7] | 0) + (S + this.temp[m - 16] | 0);
        }
        var b = (((l >>> 6 | l << 26) ^ (l >>> 11 | l << 21) ^ (l >>> 25 | l << 7)) + (l & f ^ ~l & g) | 0) + (p + (le.KEY[m] + this.temp[m] | 0) | 0) | 0, R = ((i >>> 2 | i << 30) ^ (i >>> 13 | i << 19) ^ (i >>> 22 | i << 10)) + (i & o ^ i & s ^ o & s) | 0;
        p = g, g = f, f = l, l = a + b | 0, a = s, s = o, o = i, i = b + R | 0;
      }
      r[0] += i, r[1] += o, r[2] += s, r[3] += a, r[4] += l, r[5] += f, r[6] += g, r[7] += p;
    }, e;
  }()
);
Kt.RawSha256 = Uc;
var Bi = {}, zt = {};
const Nc = (e) => {
  const t = [];
  for (let n = 0, r = e.length; n < r; n++) {
    const i = e.charCodeAt(n);
    if (i < 128)
      t.push(i);
    else if (i < 2048)
      t.push(i >> 6 | 192, i & 63 | 128);
    else if (n + 1 < e.length && (i & 64512) === 55296 && (e.charCodeAt(n + 1) & 64512) === 56320) {
      const o = 65536 + ((i & 1023) << 10) + (e.charCodeAt(++n) & 1023);
      t.push(o >> 18 | 240, o >> 12 & 63 | 128, o >> 6 & 63 | 128, o & 63 | 128);
    } else
      t.push(i >> 12 | 224, i >> 6 & 63 | 128, i & 63 | 128);
  }
  return Uint8Array.from(t);
}, Lc = (e) => {
  let t = "";
  for (let n = 0, r = e.length; n < r; n++) {
    const i = e[n];
    if (i < 128)
      t += String.fromCharCode(i);
    else if (192 <= i && i < 224) {
      const o = e[++n];
      t += String.fromCharCode((i & 31) << 6 | o & 63);
    } else if (240 <= i && i < 365) {
      const s = "%" + [i, e[++n], e[++n], e[++n]].map((a) => a.toString(16)).join("%");
      t += decodeURIComponent(s);
    } else
      t += String.fromCharCode((i & 15) << 12 | (e[++n] & 63) << 6 | e[++n] & 63);
  }
  return t;
};
function Fc(e) {
  return new TextEncoder().encode(e);
}
function kc(e) {
  return new TextDecoder("utf-8").decode(e);
}
const Bc = (e) => typeof TextEncoder == "function" ? Fc(e) : Nc(e), Mc = (e) => typeof TextDecoder == "function" ? kc(e) : Lc(e), Hc = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  fromUtf8: Bc,
  toUtf8: Mc
}, Symbol.toStringTag, { value: "Module" })), Gc = /* @__PURE__ */ Gn(Hc);
Object.defineProperty(zt, "__esModule", { value: !0 });
zt.convertToBuffer = void 0;
var Wc = Gc, Vc = typeof Buffer < "u" && Buffer.from ? function(e) {
  return Buffer.from(e, "utf8");
} : Wc.fromUtf8;
function $c(e) {
  return e instanceof Uint8Array ? e : typeof e == "string" ? Vc(e) : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength / Uint8Array.BYTES_PER_ELEMENT) : new Uint8Array(e);
}
zt.convertToBuffer = $c;
var qt = {};
Object.defineProperty(qt, "__esModule", { value: !0 });
qt.isEmptyData = void 0;
function jc(e) {
  return typeof e == "string" ? e.length === 0 : e.byteLength === 0;
}
qt.isEmptyData = jc;
var Yt = {};
Object.defineProperty(Yt, "__esModule", { value: !0 });
Yt.numToUint8 = void 0;
function Kc(e) {
  return new Uint8Array([
    (e & 4278190080) >> 24,
    (e & 16711680) >> 16,
    (e & 65280) >> 8,
    e & 255
  ]);
}
Yt.numToUint8 = Kc;
var Xt = {};
Object.defineProperty(Xt, "__esModule", { value: !0 });
Xt.uint32ArrayFrom = void 0;
function zc(e) {
  if (!Array.from) {
    for (var t = new Uint32Array(e.length), n = 0; n < e.length; )
      t[n] = e[n];
    return t;
  }
  return Uint32Array.from(e);
}
Xt.uint32ArrayFrom = zc;
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 }), e.uint32ArrayFrom = e.numToUint8 = e.isEmptyData = e.convertToBuffer = void 0;
  var t = zt;
  Object.defineProperty(e, "convertToBuffer", { enumerable: !0, get: function() {
    return t.convertToBuffer;
  } });
  var n = qt;
  Object.defineProperty(e, "isEmptyData", { enumerable: !0, get: function() {
    return n.isEmptyData;
  } });
  var r = Yt;
  Object.defineProperty(e, "numToUint8", { enumerable: !0, get: function() {
    return r.numToUint8;
  } });
  var i = Xt;
  Object.defineProperty(e, "uint32ArrayFrom", { enumerable: !0, get: function() {
    return i.uint32ArrayFrom;
  } });
})(Bi);
Object.defineProperty(jt, "__esModule", { value: !0 });
jt.Sha256 = void 0;
var Ir = ki, Nt = ce, _n = Kt, wn = Bi, qc = (
  /** @class */
  function() {
    function e(t) {
      if (this.hash = new _n.RawSha256(), t) {
        this.outer = new _n.RawSha256();
        var n = Yc(t), r = new Uint8Array(Nt.BLOCK_SIZE);
        r.set(n);
        for (var i = 0; i < Nt.BLOCK_SIZE; i++)
          n[i] ^= 54, r[i] ^= 92;
        this.hash.update(n), this.outer.update(r);
        for (var i = 0; i < n.byteLength; i++)
          n[i] = 0;
      }
    }
    return e.prototype.update = function(t) {
      if (!((0, wn.isEmptyData)(t) || this.error))
        try {
          this.hash.update((0, wn.convertToBuffer)(t));
        } catch (n) {
          this.error = n;
        }
    }, e.prototype.digestSync = function() {
      if (this.error)
        throw this.error;
      return this.outer ? (this.outer.finished || this.outer.update(this.hash.digest()), this.outer.digest()) : this.hash.digest();
    }, e.prototype.digest = function() {
      return (0, Ir.__awaiter)(this, void 0, void 0, function() {
        return (0, Ir.__generator)(this, function(t) {
          return [2, this.digestSync()];
        });
      });
    }, e;
  }()
);
jt.Sha256 = qc;
function Yc(e) {
  var t = (0, wn.convertToBuffer)(e);
  if (t.byteLength > Nt.BLOCK_SIZE) {
    var n = new _n.RawSha256();
    n.update(t), t = n.digest();
  }
  var r = new Uint8Array(Nt.BLOCK_SIZE);
  return r.set(t), r;
}
(function(e) {
  Object.defineProperty(e, "__esModule", { value: !0 });
  var t = ki;
  (0, t.__exportStar)(jt, e);
})(Je);
function I(e, t) {
  e != null && this.fromString(e, t);
}
function ie() {
  return new I(null);
}
var xe, Xc = 244837814094590, Dr = (Xc & 16777215) == 15715070;
function Jc(e, t, n, r, i, o) {
  for (; --o >= 0; ) {
    var s = t * this[e++] + n[r] + i;
    i = Math.floor(s / 67108864), n[r++] = s & 67108863;
  }
  return i;
}
function Zc(e, t, n, r, i, o) {
  for (var s = t & 32767, a = t >> 15; --o >= 0; ) {
    var l = this[e] & 32767, f = this[e++] >> 15, g = a * l + f * s;
    l = s * l + ((g & 32767) << 15) + n[r] + (i & 1073741823), i = (l >>> 30) + (g >>> 15) + a * f + (i >>> 30), n[r++] = l & 1073741823;
  }
  return i;
}
function Qc(e, t, n, r, i, o) {
  for (var s = t & 16383, a = t >> 14; --o >= 0; ) {
    var l = this[e] & 16383, f = this[e++] >> 14, g = a * l + f * s;
    l = s * l + ((g & 16383) << 14) + n[r] + i, i = (l >> 28) + (g >> 14) + a * f, n[r++] = l & 268435455;
  }
  return i;
}
var Rr = typeof navigator < "u";
Rr && Dr && navigator.appName == "Microsoft Internet Explorer" ? (I.prototype.am = Zc, xe = 30) : Rr && Dr && navigator.appName != "Netscape" ? (I.prototype.am = Jc, xe = 26) : (I.prototype.am = Qc, xe = 28);
I.prototype.DB = xe;
I.prototype.DM = (1 << xe) - 1;
I.prototype.DV = 1 << xe;
var nr = 52;
I.prototype.FV = Math.pow(2, nr);
I.prototype.F1 = nr - xe;
I.prototype.F2 = 2 * xe - nr;
var eu = "0123456789abcdefghijklmnopqrstuvwxyz", Jt = new Array(), Qe, pe;
Qe = 48;
for (pe = 0; pe <= 9; ++pe) Jt[Qe++] = pe;
Qe = 97;
for (pe = 10; pe < 36; ++pe) Jt[Qe++] = pe;
Qe = 65;
for (pe = 10; pe < 36; ++pe) Jt[Qe++] = pe;
function xr(e) {
  return eu.charAt(e);
}
function tu(e, t) {
  var n = Jt[e.charCodeAt(t)];
  return n ?? -1;
}
function nu(e) {
  for (var t = this.t - 1; t >= 0; --t) e[t] = this[t];
  e.t = this.t, e.s = this.s;
}
function ru(e) {
  this.t = 1, this.s = e < 0 ? -1 : 0, e > 0 ? this[0] = e : e < -1 ? this[0] = e + this.DV : this.t = 0;
}
function rr(e) {
  var t = ie();
  return t.fromInt(e), t;
}
function iu(e, t) {
  var n;
  if (t == 16) n = 4;
  else if (t == 8) n = 3;
  else if (t == 2) n = 1;
  else if (t == 32) n = 5;
  else if (t == 4) n = 2;
  else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  this.t = 0, this.s = 0;
  for (var r = e.length, i = !1, o = 0; --r >= 0; ) {
    var s = tu(e, r);
    if (s < 0) {
      e.charAt(r) == "-" && (i = !0);
      continue;
    }
    i = !1, o == 0 ? this[this.t++] = s : o + n > this.DB ? (this[this.t - 1] |= (s & (1 << this.DB - o) - 1) << o, this[this.t++] = s >> this.DB - o) : this[this.t - 1] |= s << o, o += n, o >= this.DB && (o -= this.DB);
  }
  this.clamp(), i && I.ZERO.subTo(this, this);
}
function ou() {
  for (var e = this.s & this.DM; this.t > 0 && this[this.t - 1] == e; ) --this.t;
}
function su(e) {
  if (this.s < 0) return "-" + this.negate().toString(e);
  var t;
  if (e == 16) t = 4;
  else if (e == 8) t = 3;
  else if (e == 2) t = 1;
  else if (e == 32) t = 5;
  else if (e == 4) t = 2;
  else throw new Error("Only radix 2, 4, 8, 16, 32 are supported");
  var n = (1 << t) - 1, r, i = !1, o = "", s = this.t, a = this.DB - s * this.DB % t;
  if (s-- > 0)
    for (a < this.DB && (r = this[s] >> a) > 0 && (i = !0, o = xr(r)); s >= 0; )
      a < t ? (r = (this[s] & (1 << a) - 1) << t - a, r |= this[--s] >> (a += this.DB - t)) : (r = this[s] >> (a -= t) & n, a <= 0 && (a += this.DB, --s)), r > 0 && (i = !0), i && (o += xr(r));
  return i ? o : "0";
}
function au() {
  var e = ie();
  return I.ZERO.subTo(this, e), e;
}
function cu() {
  return this.s < 0 ? this.negate() : this;
}
function uu(e) {
  var t = this.s - e.s;
  if (t != 0) return t;
  var n = this.t;
  if (t = n - e.t, t != 0) return this.s < 0 ? -t : t;
  for (; --n >= 0; ) if ((t = this[n] - e[n]) != 0) return t;
  return 0;
}
function ir(e) {
  var t = 1, n;
  return (n = e >>> 16) != 0 && (e = n, t += 16), (n = e >> 8) != 0 && (e = n, t += 8), (n = e >> 4) != 0 && (e = n, t += 4), (n = e >> 2) != 0 && (e = n, t += 2), (n = e >> 1) != 0 && (e = n, t += 1), t;
}
function lu() {
  return this.t <= 0 ? 0 : this.DB * (this.t - 1) + ir(this[this.t - 1] ^ this.s & this.DM);
}
function fu(e, t) {
  var n;
  for (n = this.t - 1; n >= 0; --n) t[n + e] = this[n];
  for (n = e - 1; n >= 0; --n) t[n] = 0;
  t.t = this.t + e, t.s = this.s;
}
function hu(e, t) {
  for (var n = e; n < this.t; ++n) t[n - e] = this[n];
  t.t = Math.max(this.t - e, 0), t.s = this.s;
}
function du(e, t) {
  var n = e % this.DB, r = this.DB - n, i = (1 << r) - 1, o = Math.floor(e / this.DB), s = this.s << n & this.DM, a;
  for (a = this.t - 1; a >= 0; --a)
    t[a + o + 1] = this[a] >> r | s, s = (this[a] & i) << n;
  for (a = o - 1; a >= 0; --a) t[a] = 0;
  t[o] = s, t.t = this.t + o + 1, t.s = this.s, t.clamp();
}
function pu(e, t) {
  t.s = this.s;
  var n = Math.floor(e / this.DB);
  if (n >= this.t) {
    t.t = 0;
    return;
  }
  var r = e % this.DB, i = this.DB - r, o = (1 << r) - 1;
  t[0] = this[n] >> r;
  for (var s = n + 1; s < this.t; ++s)
    t[s - n - 1] |= (this[s] & o) << i, t[s - n] = this[s] >> r;
  r > 0 && (t[this.t - n - 1] |= (this.s & o) << i), t.t = this.t - n, t.clamp();
}
function gu(e, t) {
  for (var n = 0, r = 0, i = Math.min(e.t, this.t); n < i; )
    r += this[n] - e[n], t[n++] = r & this.DM, r >>= this.DB;
  if (e.t < this.t) {
    for (r -= e.s; n < this.t; )
      r += this[n], t[n++] = r & this.DM, r >>= this.DB;
    r += this.s;
  } else {
    for (r += this.s; n < e.t; )
      r -= e[n], t[n++] = r & this.DM, r >>= this.DB;
    r -= e.s;
  }
  t.s = r < 0 ? -1 : 0, r < -1 ? t[n++] = this.DV + r : r > 0 && (t[n++] = r), t.t = n, t.clamp();
}
function mu(e, t) {
  var n = this.abs(), r = e.abs(), i = n.t;
  for (t.t = i + r.t; --i >= 0; ) t[i] = 0;
  for (i = 0; i < r.t; ++i) t[i + n.t] = n.am(0, r[i], t, i, 0, n.t);
  t.s = 0, t.clamp(), this.s != e.s && I.ZERO.subTo(t, t);
}
function vu(e) {
  for (var t = this.abs(), n = e.t = 2 * t.t; --n >= 0; ) e[n] = 0;
  for (n = 0; n < t.t - 1; ++n) {
    var r = t.am(n, t[n], e, 2 * n, 0, 1);
    (e[n + t.t] += t.am(n + 1, 2 * t[n], e, 2 * n + 1, r, t.t - n - 1)) >= t.DV && (e[n + t.t] -= t.DV, e[n + t.t + 1] = 1);
  }
  e.t > 0 && (e[e.t - 1] += t.am(n, t[n], e, 2 * n, 0, 1)), e.s = 0, e.clamp();
}
function yu(e, t, n) {
  var r = e.abs();
  if (!(r.t <= 0)) {
    var i = this.abs();
    if (i.t < r.t) {
      t != null && t.fromInt(0), n != null && this.copyTo(n);
      return;
    }
    n == null && (n = ie());
    var o = ie(), s = this.s, a = e.s, l = this.DB - ir(r[r.t - 1]);
    l > 0 ? (r.lShiftTo(l, o), i.lShiftTo(l, n)) : (r.copyTo(o), i.copyTo(n));
    var f = o.t, g = o[f - 1];
    if (g != 0) {
      var p = g * (1 << this.F1) + (f > 1 ? o[f - 2] >> this.F2 : 0), m = this.FV / p, E = (1 << this.F1) / p, _ = 1 << this.F2, S = n.t, b = S - f, R = t ?? ie();
      for (o.dlShiftTo(b, R), n.compareTo(R) >= 0 && (n[n.t++] = 1, n.subTo(R, n)), I.ONE.dlShiftTo(f, R), R.subTo(o, o); o.t < f; ) o[o.t++] = 0;
      for (; --b >= 0; ) {
        var L = n[--S] == g ? this.DM : Math.floor(n[S] * m + (n[S - 1] + _) * E);
        if ((n[S] += o.am(0, L, n, b, 0, f)) < L)
          for (o.dlShiftTo(b, R), n.subTo(R, n); n[S] < --L; ) n.subTo(R, n);
      }
      t != null && (n.drShiftTo(f, t), s != a && I.ZERO.subTo(t, t)), n.t = f, n.clamp(), l > 0 && n.rShiftTo(l, n), s < 0 && I.ZERO.subTo(n, n);
    }
  }
}
function Su(e) {
  var t = ie();
  return this.abs().divRemTo(e, null, t), this.s < 0 && t.compareTo(I.ZERO) > 0 && e.subTo(t, t), t;
}
function Eu() {
  if (this.t < 1) return 0;
  var e = this[0];
  if (!(e & 1)) return 0;
  var t = e & 3;
  return t = t * (2 - (e & 15) * t) & 15, t = t * (2 - (e & 255) * t) & 255, t = t * (2 - ((e & 65535) * t & 65535)) & 65535, t = t * (2 - e * t % this.DV) % this.DV, t > 0 ? this.DV - t : -t;
}
function _u(e) {
  return this.compareTo(e) == 0;
}
function wu(e, t) {
  for (var n = 0, r = 0, i = Math.min(e.t, this.t); n < i; )
    r += this[n] + e[n], t[n++] = r & this.DM, r >>= this.DB;
  if (e.t < this.t) {
    for (r += e.s; n < this.t; )
      r += this[n], t[n++] = r & this.DM, r >>= this.DB;
    r += this.s;
  } else {
    for (r += this.s; n < e.t; )
      r += e[n], t[n++] = r & this.DM, r >>= this.DB;
    r += e.s;
  }
  t.s = r < 0 ? -1 : 0, r > 0 ? t[n++] = r : r < -1 && (t[n++] = this.DV + r), t.t = n, t.clamp();
}
function Au(e) {
  var t = ie();
  return this.addTo(e, t), t;
}
function Cu(e) {
  var t = ie();
  return this.subTo(e, t), t;
}
function Tu(e) {
  var t = ie();
  return this.multiplyTo(e, t), t;
}
function bu(e) {
  var t = ie();
  return this.divRemTo(e, t, null), t;
}
function et(e) {
  this.m = e, this.mp = e.invDigit(), this.mpl = this.mp & 32767, this.mph = this.mp >> 15, this.um = (1 << e.DB - 15) - 1, this.mt2 = 2 * e.t;
}
function Iu(e) {
  var t = ie();
  return e.abs().dlShiftTo(this.m.t, t), t.divRemTo(this.m, null, t), e.s < 0 && t.compareTo(I.ZERO) > 0 && this.m.subTo(t, t), t;
}
function Du(e) {
  var t = ie();
  return e.copyTo(t), this.reduce(t), t;
}
function Ru(e) {
  for (; e.t <= this.mt2; )
    e[e.t++] = 0;
  for (var t = 0; t < this.m.t; ++t) {
    var n = e[t] & 32767, r = n * this.mpl + ((n * this.mph + (e[t] >> 15) * this.mpl & this.um) << 15) & e.DM;
    for (n = t + this.m.t, e[n] += this.m.am(0, r, e, t, 0, this.m.t); e[n] >= e.DV; )
      e[n] -= e.DV, e[++n]++;
  }
  e.clamp(), e.drShiftTo(this.m.t, e), e.compareTo(this.m) >= 0 && e.subTo(this.m, e);
}
function xu(e, t) {
  e.squareTo(t), this.reduce(t);
}
function Ou(e, t, n) {
  e.multiplyTo(t, n), this.reduce(n);
}
et.prototype.convert = Iu;
et.prototype.revert = Du;
et.prototype.reduce = Ru;
et.prototype.mulTo = Ou;
et.prototype.sqrTo = xu;
function Pu(e, t, n) {
  var r = e.bitLength(), i, o = rr(1), s = new et(t);
  if (r <= 0) return o;
  r < 18 ? i = 1 : r < 48 ? i = 3 : r < 144 ? i = 4 : r < 768 ? i = 5 : i = 6;
  var a = new Array(), l = 3, f = i - 1, g = (1 << i) - 1;
  if (a[1] = s.convert(this), i > 1) {
    var p = ie();
    for (s.sqrTo(a[1], p); l <= g; )
      a[l] = ie(), s.mulTo(p, a[l - 2], a[l]), l += 2;
  }
  var m = e.t - 1, E, _ = !0, S = ie(), b;
  for (r = ir(e[m]) - 1; m >= 0; ) {
    for (r >= f ? E = e[m] >> r - f & g : (E = (e[m] & (1 << r + 1) - 1) << f - r, m > 0 && (E |= e[m - 1] >> this.DB + r - f)), l = i; !(E & 1); )
      E >>= 1, --l;
    if ((r -= l) < 0 && (r += this.DB, --m), _)
      a[E].copyTo(o), _ = !1;
    else {
      for (; l > 1; )
        s.sqrTo(o, S), s.sqrTo(S, o), l -= 2;
      l > 0 ? s.sqrTo(o, S) : (b = o, o = S, S = b), s.mulTo(S, a[E], o);
    }
    for (; m >= 0 && !(e[m] & 1 << r); )
      s.sqrTo(o, S), b = o, o = S, S = b, --r < 0 && (r = this.DB - 1, --m);
  }
  var R = s.revert(o);
  return n(null, R), R;
}
I.prototype.copyTo = nu;
I.prototype.fromInt = ru;
I.prototype.fromString = iu;
I.prototype.clamp = ou;
I.prototype.dlShiftTo = fu;
I.prototype.drShiftTo = hu;
I.prototype.lShiftTo = du;
I.prototype.rShiftTo = pu;
I.prototype.subTo = gu;
I.prototype.multiplyTo = mu;
I.prototype.squareTo = vu;
I.prototype.divRemTo = yu;
I.prototype.invDigit = Eu;
I.prototype.addTo = wu;
I.prototype.toString = su;
I.prototype.negate = au;
I.prototype.abs = cu;
I.prototype.compareTo = uu;
I.prototype.bitLength = lu;
I.prototype.mod = Su;
I.prototype.equals = _u;
I.prototype.add = Au;
I.prototype.subtract = Cu;
I.prototype.multiply = Tu;
I.prototype.divide = bu;
I.prototype.modPow = Pu;
I.ZERO = rr(0);
I.ONE = rr(1);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
function rn(e) {
  return M.Buffer.from(new hc().random(e).toString(), "hex");
}
var Uu = /^[89a-f]/i, Nu = "FFFFFFFFFFFFFFFFC90FDAA22168C234C4C6628B80DC1CD129024E088A67CC74020BBEA63B139B22514A08798E3404DDEF9519B3CD3A431B302B0A6DF25F14374FE1356D6D51C245E485B576625E7EC6F44C42E9A637ED6B0BFF5CB6F406B7EDEE386BFB5A899FA5AE9F24117C4B1FE649286651ECE45B3DC2007CB8A163BF0598DA48361C55D39A69163FA8FD24CF5F83655D23DCA3AD961C62F356208552BB9ED529077096966D670C354E4ABC9804F1746C08CA18217C32905E462E36CE3BE39E772C180E86039B2783A2EC07A28FB5C55DF06F4C52C9DE2BCBF6955817183995497CEA956AE515D2261898FA051015728E5A8AAAC42DAD33170D04507A33A85521ABDF1CBA64ECFB850458DBEF0A8AEA71575D060C7DB3970F85A6E1E4C7ABF5AE8CDB0933D71E8C94E04A25619DCEE3D2261AD2EE6BF12FFA06D98A0864D87602733EC86A64521F2B18177B200CBBE117577A615D6C770988C0BAD946E208E24FA074E5AB3143DB5BFCE0FD108E4B82D120A93AD2CAFFFFFFFFFFFFFFFF", Lu = "userAttributes.", Ye = /* @__PURE__ */ function() {
  function e(n) {
    this.N = new I(Nu, 16), this.g = new I("2", 16), this.k = new I(this.hexHash("" + this.padHex(this.N) + this.padHex(this.g)), 16), this.smallAValue = this.generateRandomSmallA(), this.getLargeAValue(function() {
    }), this.infoBits = M.Buffer.from("Caldera Derived Key", "utf8"), this.poolName = n;
  }
  var t = e.prototype;
  return t.getSmallAValue = function() {
    return this.smallAValue;
  }, t.getLargeAValue = function(r) {
    var i = this;
    this.largeAValue ? r(null, this.largeAValue) : this.calculateA(this.smallAValue, function(o, s) {
      o && r(o, null), i.largeAValue = s, r(null, i.largeAValue);
    });
  }, t.generateRandomSmallA = function() {
    var r = rn(128).toString("hex"), i = new I(r, 16);
    return i;
  }, t.generateRandomString = function() {
    return rn(40).toString("base64");
  }, t.getRandomPassword = function() {
    return this.randomPassword;
  }, t.getSaltDevices = function() {
    return this.SaltToHashDevices;
  }, t.getVerifierDevices = function() {
    return this.verifierDevices;
  }, t.generateHashDevice = function(r, i, o) {
    var s = this;
    this.randomPassword = this.generateRandomString();
    var a = "" + r + i + ":" + this.randomPassword, l = this.hash(a), f = rn(16).toString("hex");
    this.SaltToHashDevices = this.padHex(new I(f, 16)), this.g.modPow(new I(this.hexHash(this.SaltToHashDevices + l), 16), this.N, function(g, p) {
      g && o(g, null), s.verifierDevices = s.padHex(p), o(null, null);
    });
  }, t.calculateA = function(r, i) {
    var o = this;
    this.g.modPow(r, this.N, function(s, a) {
      s && i(s, null), a.mod(o.N).equals(I.ZERO) && i(new Error("Illegal paramater. A mod N cannot be 0."), null), i(null, a);
    });
  }, t.calculateU = function(r, i) {
    this.UHexHash = this.hexHash(this.padHex(r) + this.padHex(i));
    var o = new I(this.UHexHash, 16);
    return o;
  }, t.hash = function(r) {
    var i = new Je.Sha256();
    i.update(r);
    var o = i.digestSync(), s = M.Buffer.from(o).toString("hex");
    return new Array(64 - s.length).join("0") + s;
  }, t.hexHash = function(r) {
    return this.hash(M.Buffer.from(r, "hex"));
  }, t.computehkdf = function(r, i) {
    var o = M.Buffer.concat([this.infoBits, M.Buffer.from("", "utf8")]), s = new Je.Sha256(i);
    s.update(r);
    var a = s.digestSync(), l = new Je.Sha256(a);
    l.update(o);
    var f = l.digestSync(), g = f, p = g.slice(0, 16);
    return p;
  }, t.getPasswordAuthenticationKey = function(r, i, o, s, a) {
    var l = this;
    if (o.mod(this.N).equals(I.ZERO))
      throw new Error("B cannot be zero.");
    if (this.UValue = this.calculateU(this.largeAValue, o), this.UValue.equals(I.ZERO))
      throw new Error("U cannot be zero.");
    var f = "" + this.poolName + r + ":" + i, g = this.hash(f), p = new I(this.hexHash(this.padHex(s) + g), 16);
    this.calculateS(p, o, function(m, E) {
      m && a(m, null);
      var _ = l.computehkdf(M.Buffer.from(l.padHex(E), "hex"), M.Buffer.from(l.padHex(l.UValue), "hex"));
      a(null, _);
    });
  }, t.calculateS = function(r, i, o) {
    var s = this;
    this.g.modPow(r, this.N, function(a, l) {
      a && o(a, null);
      var f = i.subtract(s.k.multiply(l));
      f.modPow(s.smallAValue.add(s.UValue.multiply(r)), s.N, function(g, p) {
        g && o(g, null), o(null, p.mod(s.N));
      });
    });
  }, t.getNewPasswordRequiredChallengeUserAttributePrefix = function() {
    return Lu;
  }, t.padHex = function(r) {
    if (!(r instanceof I))
      throw new Error("Not a BigInteger");
    var i = r.compareTo(I.ZERO) < 0, o = r.abs().toString(16);
    if (o = o.length % 2 !== 0 ? "0" + o : o, o = Uu.test(o) ? "00" + o : o, i) {
      var s = o.split("").map(function(l) {
        var f = ~parseInt(l, 16) & 15;
        return "0123456789ABCDEF".charAt(f);
      }).join(""), a = new I(s, 16).add(I.ONE);
      o = a.toString(16), o.toUpperCase().startsWith("FF8") && (o = o.substring(2));
    }
    return o;
  }, e;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Mi = /* @__PURE__ */ function() {
  function e(n) {
    this.jwtToken = n || "", this.payload = this.decodePayload();
  }
  var t = e.prototype;
  return t.getJwtToken = function() {
    return this.jwtToken;
  }, t.getExpiration = function() {
    return this.payload.exp;
  }, t.getIssuedAt = function() {
    return this.payload.iat;
  }, t.decodePayload = function() {
    var r = this.jwtToken.split(".")[1];
    try {
      return JSON.parse(M.Buffer.from(r, "base64").toString("utf8"));
    } catch {
      return {};
    }
  }, e;
}();
function Fu(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, An(e, t);
}
function An(e, t) {
  return An = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, An(e, t);
}
var Or = /* @__PURE__ */ function(e) {
  Fu(t, e);
  function t(n) {
    var r = n === void 0 ? {} : n, i = r.AccessToken;
    return e.call(this, i || "") || this;
  }
  return t;
}(Mi);
function ku(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, Cn(e, t);
}
function Cn(e, t) {
  return Cn = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Cn(e, t);
}
var Pr = /* @__PURE__ */ function(e) {
  ku(t, e);
  function t(n) {
    var r = n === void 0 ? {} : n, i = r.IdToken;
    return e.call(this, i || "") || this;
  }
  return t;
}(Mi);
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Ur = /* @__PURE__ */ function() {
  function e(n) {
    var r = n === void 0 ? {} : n, i = r.RefreshToken;
    this.token = i || "";
  }
  var t = e.prototype;
  return t.getToken = function() {
    return this.token;
  }, e;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Bu = {
  isReactNative: typeof navigator < "u" && navigator.product === "ReactNative"
};
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Nr = /* @__PURE__ */ function() {
  function e(n) {
    var r = n === void 0 ? {} : n, i = r.IdToken, o = r.RefreshToken, s = r.AccessToken, a = r.ClockDrift;
    if (s == null || i == null)
      throw new Error("Id token and Access Token must be present.");
    this.idToken = i, this.refreshToken = o, this.accessToken = s, this.clockDrift = a === void 0 ? this.calculateClockDrift() : a;
  }
  var t = e.prototype;
  return t.getIdToken = function() {
    return this.idToken;
  }, t.getRefreshToken = function() {
    return this.refreshToken;
  }, t.getAccessToken = function() {
    return this.accessToken;
  }, t.getClockDrift = function() {
    return this.clockDrift;
  }, t.calculateClockDrift = function() {
    var r = Math.floor(/* @__PURE__ */ new Date() / 1e3), i = Math.min(this.accessToken.getIssuedAt(), this.idToken.getIssuedAt());
    return r - i;
  }, t.isValid = function() {
    var r = Math.floor(/* @__PURE__ */ new Date() / 1e3), i = r - this.clockDrift;
    return i < this.accessToken.getExpiration() && i < this.idToken.getExpiration();
  }, e;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Mu = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"], Hu = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"], Lr = /* @__PURE__ */ function() {
  function e() {
  }
  var t = e.prototype;
  return t.getNowString = function() {
    var r = /* @__PURE__ */ new Date(), i = Hu[r.getUTCDay()], o = Mu[r.getUTCMonth()], s = r.getUTCDate(), a = r.getUTCHours();
    a < 10 && (a = "0" + a);
    var l = r.getUTCMinutes();
    l < 10 && (l = "0" + l);
    var f = r.getUTCSeconds();
    f < 10 && (f = "0" + f);
    var g = r.getUTCFullYear(), p = i + " " + o + " " + s + " " + a + ":" + l + ":" + f + " UTC " + g;
    return p;
  }, e;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Gu = /* @__PURE__ */ function() {
  function e(n) {
    var r = n === void 0 ? {} : n, i = r.Name, o = r.Value;
    this.Name = i || "", this.Value = o || "";
  }
  var t = e.prototype;
  return t.getValue = function() {
    return this.Value;
  }, t.setValue = function(r) {
    return this.Value = r, this;
  }, t.getName = function() {
    return this.Name;
  }, t.setName = function(r) {
    return this.Name = r, this;
  }, t.toString = function() {
    return JSON.stringify(this);
  }, t.toJSON = function() {
    return {
      Name: this.Name,
      Value: this.Value
    };
  }, e;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var Be = {}, Wu = /* @__PURE__ */ function() {
  function e() {
  }
  return e.setItem = function(n, r) {
    return Be[n] = r, Be[n];
  }, e.getItem = function(n) {
    return Object.prototype.hasOwnProperty.call(Be, n) ? Be[n] : void 0;
  }, e.removeItem = function(n) {
    return delete Be[n];
  }, e.clear = function() {
    return Be = {}, Be;
  }, e;
}(), Vu = /* @__PURE__ */ function() {
  function e() {
    try {
      this.storageWindow = window.localStorage, this.storageWindow.setItem("aws.cognito.test-ls", 1), this.storageWindow.removeItem("aws.cognito.test-ls");
    } catch {
      this.storageWindow = Wu;
    }
  }
  var t = e.prototype;
  return t.getStorage = function() {
    return this.storageWindow;
  }, e;
}();
/*!
 * Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
 * SPDX-License-Identifier: Apache-2.0
 */
var $u = typeof navigator < "u", Fr = $u ? Bu.isReactNative ? "react-native" : navigator.userAgent : "nodejs", on = /* @__PURE__ */ function() {
  function e(n) {
    if (n == null || n.Username == null || n.Pool == null)
      throw new Error("Username and Pool information are required.");
    this.username = n.Username || "", this.pool = n.Pool, this.Session = null, this.client = n.Pool.client, this.signInUserSession = null, this.authenticationFlowType = "USER_SRP_AUTH", this.storage = n.Storage || new Vu().getStorage(), this.keyPrefix = "CognitoIdentityServiceProvider." + this.pool.getClientId(), this.userDataKey = this.keyPrefix + "." + this.username + ".userData";
  }
  var t = e.prototype;
  return t.setSignInUserSession = function(r) {
    this.clearCachedUserData(), this.signInUserSession = r, this.cacheTokens();
  }, t.getSignInUserSession = function() {
    return this.signInUserSession;
  }, t.getUsername = function() {
    return this.username;
  }, t.getAuthenticationFlowType = function() {
    return this.authenticationFlowType;
  }, t.setAuthenticationFlowType = function(r) {
    this.authenticationFlowType = r;
  }, t.initiateAuth = function(r, i) {
    var o = this, s = r.getAuthParameters();
    s.USERNAME = this.username;
    var a = Object.keys(r.getValidationData()).length !== 0 ? r.getValidationData() : r.getClientMetadata(), l = {
      AuthFlow: "CUSTOM_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: s,
      ClientMetadata: a
    };
    this.getUserContextData() && (l.UserContextData = this.getUserContextData()), this.client.request("InitiateAuth", l, function(f, g) {
      if (f)
        return i.onFailure(f);
      var p = g.ChallengeName, m = g.ChallengeParameters;
      return p === "CUSTOM_CHALLENGE" ? (o.Session = g.Session, i.customChallenge(m)) : (o.signInUserSession = o.getCognitoUserSession(g.AuthenticationResult), o.cacheTokens(), i.onSuccess(o.signInUserSession));
    });
  }, t.authenticateUser = function(r, i) {
    return this.authenticationFlowType === "USER_PASSWORD_AUTH" ? this.authenticateUserPlainUsernamePassword(r, i) : this.authenticationFlowType === "USER_SRP_AUTH" || this.authenticationFlowType === "CUSTOM_AUTH" ? this.authenticateUserDefaultAuth(r, i) : i.onFailure(new Error("Authentication flow type is invalid."));
  }, t.authenticateUserDefaultAuth = function(r, i) {
    var o = this, s = new Ye(this.pool.getUserPoolName()), a = new Lr(), l, f, g = {};
    this.deviceKey != null && (g.DEVICE_KEY = this.deviceKey), g.USERNAME = this.username, s.getLargeAValue(function(p, m) {
      p && i.onFailure(p), g.SRP_A = m.toString(16), o.authenticationFlowType === "CUSTOM_AUTH" && (g.CHALLENGE_NAME = "SRP_A");
      var E = Object.keys(r.getValidationData()).length !== 0 ? r.getValidationData() : r.getClientMetadata(), _ = {
        AuthFlow: o.authenticationFlowType,
        ClientId: o.pool.getClientId(),
        AuthParameters: g,
        ClientMetadata: E
      };
      o.getUserContextData(o.username) && (_.UserContextData = o.getUserContextData(o.username)), o.client.request("InitiateAuth", _, function(S, b) {
        if (S)
          return i.onFailure(S);
        var R = b.ChallengeParameters;
        o.username = R.USER_ID_FOR_SRP, o.userDataKey = o.keyPrefix + "." + o.username + ".userData", l = new I(R.SRP_B, 16), f = new I(R.SALT, 16), o.getCachedDeviceKeyAndPassword(), s.getPasswordAuthenticationKey(o.username, r.getPassword(), l, f, function(L, ge) {
          L && i.onFailure(L);
          var q = a.getNowString(), me = M.Buffer.concat([M.Buffer.from(o.pool.getUserPoolName(), "utf8"), M.Buffer.from(o.username, "utf8"), M.Buffer.from(R.SECRET_BLOCK, "base64"), M.Buffer.from(q, "utf8")]), ue = new Je.Sha256(ge);
          ue.update(me);
          var Se = ue.digestSync(), V = M.Buffer.from(Se).toString("base64"), Y = {};
          Y.USERNAME = o.username, Y.PASSWORD_CLAIM_SECRET_BLOCK = R.SECRET_BLOCK, Y.TIMESTAMP = q, Y.PASSWORD_CLAIM_SIGNATURE = V, o.deviceKey != null && (Y.DEVICE_KEY = o.deviceKey);
          var J = function Ae(X, De) {
            return o.client.request("RespondToAuthChallenge", X, function(Ee, Ce) {
              return Ee && Ee.code === "ResourceNotFoundException" && Ee.message.toLowerCase().indexOf("device") !== -1 ? (Y.DEVICE_KEY = null, o.deviceKey = null, o.randomPassword = null, o.deviceGroupKey = null, o.clearCachedDeviceKeyAndPassword(), Ae(X, De)) : De(Ee, Ce);
            });
          }, we = {
            ChallengeName: "PASSWORD_VERIFIER",
            ClientId: o.pool.getClientId(),
            ChallengeResponses: Y,
            Session: b.Session,
            ClientMetadata: E
          };
          o.getUserContextData() && (we.UserContextData = o.getUserContextData()), J(we, function(Ae, X) {
            return Ae ? i.onFailure(Ae) : o.authenticateUserInternal(X, s, i);
          });
        });
      });
    });
  }, t.authenticateUserPlainUsernamePassword = function(r, i) {
    var o = this, s = {};
    if (s.USERNAME = this.username, s.PASSWORD = r.getPassword(), !s.PASSWORD) {
      i.onFailure(new Error("PASSWORD parameter is required"));
      return;
    }
    var a = new Ye(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword(), this.deviceKey != null && (s.DEVICE_KEY = this.deviceKey);
    var l = Object.keys(r.getValidationData()).length !== 0 ? r.getValidationData() : r.getClientMetadata(), f = {
      AuthFlow: "USER_PASSWORD_AUTH",
      ClientId: this.pool.getClientId(),
      AuthParameters: s,
      ClientMetadata: l
    };
    this.getUserContextData(this.username) && (f.UserContextData = this.getUserContextData(this.username)), this.client.request("InitiateAuth", f, function(g, p) {
      return g ? i.onFailure(g) : o.authenticateUserInternal(p, a, i);
    });
  }, t.authenticateUserInternal = function(r, i, o) {
    var s = this, a = r.ChallengeName, l = r.ChallengeParameters;
    if (a === "SMS_MFA")
      return this.Session = r.Session, o.mfaRequired(a, l);
    if (a === "SELECT_MFA_TYPE")
      return this.Session = r.Session, o.selectMFAType(a, l);
    if (a === "MFA_SETUP")
      return this.Session = r.Session, o.mfaSetup(a, l);
    if (a === "SOFTWARE_TOKEN_MFA")
      return this.Session = r.Session, o.totpRequired(a, l);
    if (a === "CUSTOM_CHALLENGE")
      return this.Session = r.Session, o.customChallenge(l);
    if (a === "NEW_PASSWORD_REQUIRED") {
      this.Session = r.Session;
      var f = null, g = null, p = [], m = i.getNewPasswordRequiredChallengeUserAttributePrefix();
      if (l && (f = JSON.parse(r.ChallengeParameters.userAttributes), g = JSON.parse(r.ChallengeParameters.requiredAttributes)), g)
        for (var E = 0; E < g.length; E++)
          p[E] = g[E].substr(m.length);
      return o.newPasswordRequired(f, p);
    }
    if (a === "DEVICE_SRP_AUTH") {
      this.Session = r.Session, this.getDeviceResponse(o);
      return;
    }
    this.signInUserSession = this.getCognitoUserSession(r.AuthenticationResult), this.challengeName = a, this.cacheTokens();
    var _ = r.AuthenticationResult.NewDeviceMetadata;
    if (_ == null)
      return o.onSuccess(this.signInUserSession);
    i.generateHashDevice(r.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, r.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(S) {
      if (S)
        return o.onFailure(S);
      var b = {
        Salt: M.Buffer.from(i.getSaltDevices(), "hex").toString("base64"),
        PasswordVerifier: M.Buffer.from(i.getVerifierDevices(), "hex").toString("base64")
      };
      s.verifierDevices = b.PasswordVerifier, s.deviceGroupKey = _.DeviceGroupKey, s.randomPassword = i.getRandomPassword(), s.client.request("ConfirmDevice", {
        DeviceKey: _.DeviceKey,
        AccessToken: s.signInUserSession.getAccessToken().getJwtToken(),
        DeviceSecretVerifierConfig: b,
        DeviceName: Fr
      }, function(R, L) {
        return R ? o.onFailure(R) : (s.deviceKey = r.AuthenticationResult.NewDeviceMetadata.DeviceKey, s.cacheDeviceKeyAndPassword(), L.UserConfirmationNecessary === !0 ? o.onSuccess(s.signInUserSession, L.UserConfirmationNecessary) : o.onSuccess(s.signInUserSession));
      });
    });
  }, t.completeNewPasswordChallenge = function(r, i, o, s) {
    var a = this;
    if (!r)
      return o.onFailure(new Error("New password is required."));
    var l = new Ye(this.pool.getUserPoolName()), f = l.getNewPasswordRequiredChallengeUserAttributePrefix(), g = {};
    i && Object.keys(i).forEach(function(m) {
      g[f + m] = i[m];
    }), g.NEW_PASSWORD = r, g.USERNAME = this.username;
    var p = {
      ChallengeName: "NEW_PASSWORD_REQUIRED",
      ClientId: this.pool.getClientId(),
      ChallengeResponses: g,
      Session: this.Session,
      ClientMetadata: s
    };
    this.getUserContextData() && (p.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", p, function(m, E) {
      return m ? o.onFailure(m) : a.authenticateUserInternal(E, l, o);
    });
  }, t.getDeviceResponse = function(r, i) {
    var o = this, s = new Ye(this.deviceGroupKey), a = new Lr(), l = {};
    l.USERNAME = this.username, l.DEVICE_KEY = this.deviceKey, s.getLargeAValue(function(f, g) {
      f && r.onFailure(f), l.SRP_A = g.toString(16);
      var p = {
        ChallengeName: "DEVICE_SRP_AUTH",
        ClientId: o.pool.getClientId(),
        ChallengeResponses: l,
        ClientMetadata: i,
        Session: o.Session
      };
      o.getUserContextData() && (p.UserContextData = o.getUserContextData()), o.client.request("RespondToAuthChallenge", p, function(m, E) {
        if (m)
          return r.onFailure(m);
        var _ = E.ChallengeParameters, S = new I(_.SRP_B, 16), b = new I(_.SALT, 16);
        s.getPasswordAuthenticationKey(o.deviceKey, o.randomPassword, S, b, function(R, L) {
          if (R)
            return r.onFailure(R);
          var ge = a.getNowString(), q = M.Buffer.concat([M.Buffer.from(o.deviceGroupKey, "utf8"), M.Buffer.from(o.deviceKey, "utf8"), M.Buffer.from(_.SECRET_BLOCK, "base64"), M.Buffer.from(ge, "utf8")]), me = new Je.Sha256(L);
          me.update(q);
          var ue = me.digestSync(), Se = M.Buffer.from(ue).toString("base64"), V = {};
          V.USERNAME = o.username, V.PASSWORD_CLAIM_SECRET_BLOCK = _.SECRET_BLOCK, V.TIMESTAMP = ge, V.PASSWORD_CLAIM_SIGNATURE = Se, V.DEVICE_KEY = o.deviceKey;
          var Y = {
            ChallengeName: "DEVICE_PASSWORD_VERIFIER",
            ClientId: o.pool.getClientId(),
            ChallengeResponses: V,
            Session: E.Session
          };
          o.getUserContextData() && (Y.UserContextData = o.getUserContextData()), o.client.request("RespondToAuthChallenge", Y, function(J, we) {
            return J ? r.onFailure(J) : (o.signInUserSession = o.getCognitoUserSession(we.AuthenticationResult), o.cacheTokens(), r.onSuccess(o.signInUserSession));
          });
        });
      });
    });
  }, t.confirmRegistration = function(r, i, o, s) {
    var a = {
      ClientId: this.pool.getClientId(),
      ConfirmationCode: r,
      Username: this.username,
      ForceAliasCreation: i,
      ClientMetadata: s
    };
    this.getUserContextData() && (a.UserContextData = this.getUserContextData()), this.client.request("ConfirmSignUp", a, function(l) {
      return l ? o(l, null) : o(null, "SUCCESS");
    });
  }, t.sendCustomChallengeAnswer = function(r, i, o) {
    var s = this, a = {};
    a.USERNAME = this.username, a.ANSWER = r;
    var l = new Ye(this.pool.getUserPoolName());
    this.getCachedDeviceKeyAndPassword(), this.deviceKey != null && (a.DEVICE_KEY = this.deviceKey);
    var f = {
      ChallengeName: "CUSTOM_CHALLENGE",
      ChallengeResponses: a,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: o
    };
    this.getUserContextData() && (f.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", f, function(g, p) {
      return g ? i.onFailure(g) : s.authenticateUserInternal(p, l, i);
    });
  }, t.sendMFACode = function(r, i, o, s) {
    var a = this, l = {};
    l.USERNAME = this.username, l.SMS_MFA_CODE = r;
    var f = o || "SMS_MFA";
    f === "SOFTWARE_TOKEN_MFA" && (l.SOFTWARE_TOKEN_MFA_CODE = r), this.deviceKey != null && (l.DEVICE_KEY = this.deviceKey);
    var g = {
      ChallengeName: f,
      ChallengeResponses: l,
      ClientId: this.pool.getClientId(),
      Session: this.Session,
      ClientMetadata: s
    };
    this.getUserContextData() && (g.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", g, function(p, m) {
      if (p)
        return i.onFailure(p);
      var E = m.ChallengeName;
      if (E === "DEVICE_SRP_AUTH") {
        a.getDeviceResponse(i);
        return;
      }
      if (a.signInUserSession = a.getCognitoUserSession(m.AuthenticationResult), a.cacheTokens(), m.AuthenticationResult.NewDeviceMetadata == null)
        return i.onSuccess(a.signInUserSession);
      var _ = new Ye(a.pool.getUserPoolName());
      _.generateHashDevice(m.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, m.AuthenticationResult.NewDeviceMetadata.DeviceKey, function(S) {
        if (S)
          return i.onFailure(S);
        var b = {
          Salt: M.Buffer.from(_.getSaltDevices(), "hex").toString("base64"),
          PasswordVerifier: M.Buffer.from(_.getVerifierDevices(), "hex").toString("base64")
        };
        a.verifierDevices = b.PasswordVerifier, a.deviceGroupKey = m.AuthenticationResult.NewDeviceMetadata.DeviceGroupKey, a.randomPassword = _.getRandomPassword(), a.client.request("ConfirmDevice", {
          DeviceKey: m.AuthenticationResult.NewDeviceMetadata.DeviceKey,
          AccessToken: a.signInUserSession.getAccessToken().getJwtToken(),
          DeviceSecretVerifierConfig: b,
          DeviceName: Fr
        }, function(R, L) {
          return R ? i.onFailure(R) : (a.deviceKey = m.AuthenticationResult.NewDeviceMetadata.DeviceKey, a.cacheDeviceKeyAndPassword(), L.UserConfirmationNecessary === !0 ? i.onSuccess(a.signInUserSession, L.UserConfirmationNecessary) : i.onSuccess(a.signInUserSession));
        });
      });
    });
  }, t.changePassword = function(r, i, o, s) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return o(new Error("User is not authenticated"), null);
    this.client.request("ChangePassword", {
      PreviousPassword: r,
      ProposedPassword: i,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: s
    }, function(a) {
      return a ? o(a, null) : o(null, "SUCCESS");
    });
  }, t.enableMFA = function(r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r(new Error("User is not authenticated"), null);
    var i = [], o = {
      DeliveryMedium: "SMS",
      AttributeName: "phone_number"
    };
    i.push(o), this.client.request("SetUserSettings", {
      MFAOptions: i,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(s) {
      return s ? r(s, null) : r(null, "SUCCESS");
    });
  }, t.setUserMfaPreference = function(r, i, o) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return o(new Error("User is not authenticated"), null);
    this.client.request("SetUserMFAPreference", {
      SMSMfaSettings: r,
      SoftwareTokenMfaSettings: i,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(s) {
      return s ? o(s, null) : o(null, "SUCCESS");
    });
  }, t.disableMFA = function(r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r(new Error("User is not authenticated"), null);
    var i = [];
    this.client.request("SetUserSettings", {
      MFAOptions: i,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(o) {
      return o ? r(o, null) : r(null, "SUCCESS");
    });
  }, t.deleteUser = function(r, i) {
    var o = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r(new Error("User is not authenticated"), null);
    this.client.request("DeleteUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: i
    }, function(s) {
      return s ? r(s, null) : (o.clearCachedUser(), r(null, "SUCCESS"));
    });
  }, t.updateAttributes = function(r, i, o) {
    var s = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i(new Error("User is not authenticated"), null);
    this.client.request("UpdateUserAttributes", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserAttributes: r,
      ClientMetadata: o
    }, function(a, l) {
      return a ? i(a, null) : s.getUserData(function() {
        return i(null, "SUCCESS", l);
      }, {
        bypassCache: !0
      });
    });
  }, t.getUserAttributes = function(r) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return r(new Error("User is not authenticated"), null);
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(i, o) {
      if (i)
        return r(i, null);
      for (var s = [], a = 0; a < o.UserAttributes.length; a++) {
        var l = {
          Name: o.UserAttributes[a].Name,
          Value: o.UserAttributes[a].Value
        }, f = new Gu(l);
        s.push(f);
      }
      return r(null, s);
    });
  }, t.getMFAOptions = function(r) {
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return r(new Error("User is not authenticated"), null);
    this.client.request("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(i, o) {
      return i ? r(i, null) : r(null, o.MFAOptions);
    });
  }, t.createGetUserRequest = function() {
    return this.client.promisifyRequest("GetUser", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    });
  }, t.refreshSessionIfPossible = function(r) {
    var i = this;
    return r === void 0 && (r = {}), new Promise(function(o) {
      var s = i.signInUserSession.getRefreshToken();
      s && s.getToken() ? i.refreshSession(s, o, r.clientMetadata) : o();
    });
  }, t.getUserData = function(r, i) {
    var o = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return this.clearCachedUserData(), r(new Error("User is not authenticated"), null);
    var s = this.getUserDataFromCache();
    if (!s) {
      this.fetchUserData().then(function(a) {
        r(null, a);
      }).catch(r);
      return;
    }
    if (this.isFetchUserDataAndTokenRequired(i)) {
      this.fetchUserData().then(function(a) {
        return o.refreshSessionIfPossible(i).then(function() {
          return a;
        });
      }).then(function(a) {
        return r(null, a);
      }).catch(r);
      return;
    }
    try {
      r(null, JSON.parse(s));
      return;
    } catch (a) {
      this.clearCachedUserData(), r(a, null);
      return;
    }
  }, t.getUserDataFromCache = function() {
    var r = this.storage.getItem(this.userDataKey);
    return r;
  }, t.isFetchUserDataAndTokenRequired = function(r) {
    var i = r || {}, o = i.bypassCache, s = o === void 0 ? !1 : o;
    return s;
  }, t.fetchUserData = function() {
    var r = this;
    return this.createGetUserRequest().then(function(i) {
      return r.cacheUserData(i), i;
    });
  }, t.deleteAttributes = function(r, i) {
    var o = this;
    if (!(this.signInUserSession != null && this.signInUserSession.isValid()))
      return i(new Error("User is not authenticated"), null);
    this.client.request("DeleteUserAttributes", {
      UserAttributeNames: r,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(s) {
      return s ? i(s, null) : o.getUserData(function() {
        return i(null, "SUCCESS");
      }, {
        bypassCache: !0
      });
    });
  }, t.resendConfirmationCode = function(r, i) {
    var o = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: i
    };
    this.client.request("ResendConfirmationCode", o, function(s, a) {
      return s ? r(s, null) : r(null, a);
    });
  }, t.getSession = function(r, i) {
    if (i === void 0 && (i = {}), this.username == null)
      return r(new Error("Username is null. Cannot retrieve a new session"), null);
    if (this.signInUserSession != null && this.signInUserSession.isValid())
      return r(null, this.signInUserSession);
    var o = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, s = o + ".idToken", a = o + ".accessToken", l = o + ".refreshToken", f = o + ".clockDrift";
    if (this.storage.getItem(s)) {
      var g = new Pr({
        IdToken: this.storage.getItem(s)
      }), p = new Or({
        AccessToken: this.storage.getItem(a)
      }), m = new Ur({
        RefreshToken: this.storage.getItem(l)
      }), E = parseInt(this.storage.getItem(f), 0) || 0, _ = {
        IdToken: g,
        AccessToken: p,
        RefreshToken: m,
        ClockDrift: E
      }, S = new Nr(_);
      if (S.isValid())
        return this.signInUserSession = S, r(null, this.signInUserSession);
      if (!m.getToken())
        return r(new Error("Cannot retrieve a new session. Please authenticate."), null);
      this.refreshSession(m, r, i.clientMetadata);
    } else
      r(new Error("Local storage is missing an ID Token, Please authenticate"), null);
  }, t.refreshSession = function(r, i, o) {
    var s = this, a = this.pool.wrapRefreshSessionCallback ? this.pool.wrapRefreshSessionCallback(i) : i, l = {};
    l.REFRESH_TOKEN = r.getToken();
    var f = "CognitoIdentityServiceProvider." + this.pool.getClientId(), g = f + ".LastAuthUser";
    if (this.storage.getItem(g)) {
      this.username = this.storage.getItem(g);
      var p = f + "." + this.username + ".deviceKey";
      this.deviceKey = this.storage.getItem(p), l.DEVICE_KEY = this.deviceKey;
    }
    var m = {
      ClientId: this.pool.getClientId(),
      AuthFlow: "REFRESH_TOKEN_AUTH",
      AuthParameters: l,
      ClientMetadata: o
    };
    this.getUserContextData() && (m.UserContextData = this.getUserContextData()), this.client.request("InitiateAuth", m, function(E, _) {
      if (E)
        return E.code === "NotAuthorizedException" && s.clearCachedUser(), a(E, null);
      if (_) {
        var S = _.AuthenticationResult;
        return Object.prototype.hasOwnProperty.call(S, "RefreshToken") || (S.RefreshToken = r.getToken()), s.signInUserSession = s.getCognitoUserSession(S), s.cacheTokens(), a(null, s.signInUserSession);
      }
    });
  }, t.cacheTokens = function() {
    var r = "CognitoIdentityServiceProvider." + this.pool.getClientId(), i = r + "." + this.username + ".idToken", o = r + "." + this.username + ".accessToken", s = r + "." + this.username + ".refreshToken", a = r + "." + this.username + ".clockDrift", l = r + ".LastAuthUser";
    this.storage.setItem(i, this.signInUserSession.getIdToken().getJwtToken()), this.storage.setItem(o, this.signInUserSession.getAccessToken().getJwtToken()), this.storage.setItem(s, this.signInUserSession.getRefreshToken().getToken()), this.storage.setItem(a, "" + this.signInUserSession.getClockDrift()), this.storage.setItem(l, this.username);
  }, t.cacheUserData = function(r) {
    this.storage.setItem(this.userDataKey, JSON.stringify(r));
  }, t.clearCachedUserData = function() {
    this.storage.removeItem(this.userDataKey);
  }, t.clearCachedUser = function() {
    this.clearCachedTokens(), this.clearCachedUserData();
  }, t.cacheDeviceKeyAndPassword = function() {
    var r = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, i = r + ".deviceKey", o = r + ".randomPasswordKey", s = r + ".deviceGroupKey";
    this.storage.setItem(i, this.deviceKey), this.storage.setItem(o, this.randomPassword), this.storage.setItem(s, this.deviceGroupKey);
  }, t.getCachedDeviceKeyAndPassword = function() {
    var r = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, i = r + ".deviceKey", o = r + ".randomPasswordKey", s = r + ".deviceGroupKey";
    this.storage.getItem(i) && (this.deviceKey = this.storage.getItem(i), this.randomPassword = this.storage.getItem(o), this.deviceGroupKey = this.storage.getItem(s));
  }, t.clearCachedDeviceKeyAndPassword = function() {
    var r = "CognitoIdentityServiceProvider." + this.pool.getClientId() + "." + this.username, i = r + ".deviceKey", o = r + ".randomPasswordKey", s = r + ".deviceGroupKey";
    this.storage.removeItem(i), this.storage.removeItem(o), this.storage.removeItem(s);
  }, t.clearCachedTokens = function() {
    var r = "CognitoIdentityServiceProvider." + this.pool.getClientId(), i = r + "." + this.username + ".idToken", o = r + "." + this.username + ".accessToken", s = r + "." + this.username + ".refreshToken", a = r + ".LastAuthUser", l = r + "." + this.username + ".clockDrift";
    this.storage.removeItem(i), this.storage.removeItem(o), this.storage.removeItem(s), this.storage.removeItem(a), this.storage.removeItem(l);
  }, t.getCognitoUserSession = function(r) {
    var i = new Pr(r), o = new Or(r), s = new Ur(r), a = {
      IdToken: i,
      AccessToken: o,
      RefreshToken: s
    };
    return new Nr(a);
  }, t.forgotPassword = function(r, i) {
    var o = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ClientMetadata: i
    };
    this.getUserContextData() && (o.UserContextData = this.getUserContextData()), this.client.request("ForgotPassword", o, function(s, a) {
      return s ? r.onFailure(s) : typeof r.inputVerificationCode == "function" ? r.inputVerificationCode(a) : r.onSuccess(a);
    });
  }, t.confirmPassword = function(r, i, o, s) {
    var a = {
      ClientId: this.pool.getClientId(),
      Username: this.username,
      ConfirmationCode: r,
      Password: i,
      ClientMetadata: s
    };
    this.getUserContextData() && (a.UserContextData = this.getUserContextData()), this.client.request("ConfirmForgotPassword", a, function(l) {
      return l ? o.onFailure(l) : o.onSuccess("SUCCESS");
    });
  }, t.getAttributeVerificationCode = function(r, i, o) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i.onFailure(new Error("User is not authenticated"));
    this.client.request("GetUserAttributeVerificationCode", {
      AttributeName: r,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      ClientMetadata: o
    }, function(s, a) {
      return s ? i.onFailure(s) : typeof i.inputVerificationCode == "function" ? i.inputVerificationCode(a) : i.onSuccess("SUCCESS");
    });
  }, t.verifyAttribute = function(r, i, o) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return o.onFailure(new Error("User is not authenticated"));
    this.client.request("VerifyUserAttribute", {
      AttributeName: r,
      Code: i,
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(s) {
      return s ? o.onFailure(s) : o.onSuccess("SUCCESS");
    });
  }, t.getDevice = function(r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r.onFailure(new Error("User is not authenticated"));
    this.client.request("GetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey
    }, function(i, o) {
      return i ? r.onFailure(i) : r.onSuccess(o);
    });
  }, t.forgetSpecificDevice = function(r, i) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return i.onFailure(new Error("User is not authenticated"));
    this.client.request("ForgetDevice", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: r
    }, function(o) {
      return o ? i.onFailure(o) : i.onSuccess("SUCCESS");
    });
  }, t.forgetDevice = function(r) {
    var i = this;
    this.forgetSpecificDevice(this.deviceKey, {
      onFailure: r.onFailure,
      onSuccess: function(s) {
        return i.deviceKey = null, i.deviceGroupKey = null, i.randomPassword = null, i.clearCachedDeviceKeyAndPassword(), r.onSuccess(s);
      }
    });
  }, t.setDeviceStatusRemembered = function(r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r.onFailure(new Error("User is not authenticated"));
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "remembered"
    }, function(i) {
      return i ? r.onFailure(i) : r.onSuccess("SUCCESS");
    });
  }, t.setDeviceStatusNotRemembered = function(r) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r.onFailure(new Error("User is not authenticated"));
    this.client.request("UpdateDeviceStatus", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      DeviceKey: this.deviceKey,
      DeviceRememberedStatus: "not_remembered"
    }, function(i) {
      return i ? r.onFailure(i) : r.onSuccess("SUCCESS");
    });
  }, t.listDevices = function(r, i, o) {
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return o.onFailure(new Error("User is not authenticated"));
    var s = {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      Limit: r
    };
    i && (s.PaginationToken = i), this.client.request("ListDevices", s, function(a, l) {
      return a ? o.onFailure(a) : o.onSuccess(l);
    });
  }, t.globalSignOut = function(r) {
    var i = this;
    if (this.signInUserSession == null || !this.signInUserSession.isValid())
      return r.onFailure(new Error("User is not authenticated"));
    this.client.request("GlobalSignOut", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(o) {
      return o ? r.onFailure(o) : (i.clearCachedUser(), r.onSuccess("SUCCESS"));
    });
  }, t.signOut = function(r) {
    var i = this;
    if (!r || typeof r != "function") {
      this.cleanClientData();
      return;
    }
    this.getSession(function(o, s) {
      if (o)
        return r(o);
      i.revokeTokens(function(a) {
        i.cleanClientData(), r(a);
      });
    });
  }, t.revokeTokens = function(r) {
    if (r === void 0 && (r = function() {
    }), typeof r != "function")
      throw new Error("Invalid revokeTokenCallback. It should be a function.");
    if (!this.signInUserSession) {
      var i = new Error("User is not authenticated");
      return r(i);
    }
    if (!this.signInUserSession.getAccessToken()) {
      var o = new Error("No Access token available");
      return r(o);
    }
    var s = this.signInUserSession.getRefreshToken().getToken(), a = this.signInUserSession.getAccessToken();
    if (this.isSessionRevocable(a) && s)
      return this.revokeToken({
        token: s,
        callback: r
      });
    r();
  }, t.isSessionRevocable = function(r) {
    if (r && typeof r.decodePayload == "function")
      try {
        var i = r.decodePayload(), o = i.origin_jti;
        return !!o;
      } catch {
      }
    return !1;
  }, t.cleanClientData = function() {
    this.signInUserSession = null, this.clearCachedUser();
  }, t.revokeToken = function(r) {
    var i = r.token, o = r.callback;
    this.client.requestWithRetry("RevokeToken", {
      Token: i,
      ClientId: this.pool.getClientId()
    }, function(s) {
      if (s)
        return o(s);
      o();
    });
  }, t.sendMFASelectionAnswer = function(r, i) {
    var o = this, s = {};
    s.USERNAME = this.username, s.ANSWER = r;
    var a = {
      ChallengeName: "SELECT_MFA_TYPE",
      ChallengeResponses: s,
      ClientId: this.pool.getClientId(),
      Session: this.Session
    };
    this.getUserContextData() && (a.UserContextData = this.getUserContextData()), this.client.request("RespondToAuthChallenge", a, function(l, f) {
      if (l)
        return i.onFailure(l);
      if (o.Session = f.Session, r === "SMS_MFA")
        return i.mfaRequired(f.ChallengeName, f.ChallengeParameters);
      if (r === "SOFTWARE_TOKEN_MFA")
        return i.totpRequired(f.ChallengeName, f.ChallengeParameters);
    });
  }, t.getUserContextData = function() {
    var r = this.pool;
    return r.getUserContextData(this.username);
  }, t.associateSoftwareToken = function(r) {
    var i = this;
    this.signInUserSession != null && this.signInUserSession.isValid() ? this.client.request("AssociateSoftwareToken", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken()
    }, function(o, s) {
      return o ? r.onFailure(o) : r.associateSecretCode(s.SecretCode);
    }) : this.client.request("AssociateSoftwareToken", {
      Session: this.Session
    }, function(o, s) {
      return o ? r.onFailure(o) : (i.Session = s.Session, r.associateSecretCode(s.SecretCode));
    });
  }, t.verifySoftwareToken = function(r, i, o) {
    var s = this;
    this.signInUserSession != null && this.signInUserSession.isValid() ? this.client.request("VerifySoftwareToken", {
      AccessToken: this.signInUserSession.getAccessToken().getJwtToken(),
      UserCode: r,
      FriendlyDeviceName: i
    }, function(a, l) {
      return a ? o.onFailure(a) : o.onSuccess(l);
    }) : this.client.request("VerifySoftwareToken", {
      Session: this.Session,
      UserCode: r,
      FriendlyDeviceName: i
    }, function(a, l) {
      if (a)
        return o.onFailure(a);
      s.Session = l.Session;
      var f = {};
      f.USERNAME = s.username;
      var g = {
        ChallengeName: "MFA_SETUP",
        ClientId: s.pool.getClientId(),
        ChallengeResponses: f,
        Session: s.Session
      };
      s.getUserContextData() && (g.UserContextData = s.getUserContextData()), s.client.request("RespondToAuthChallenge", g, function(p, m) {
        return p ? o.onFailure(p) : (s.signInUserSession = s.getCognitoUserSession(m.AuthenticationResult), s.cacheTokens(), o.onSuccess(s.signInUserSession));
      });
    });
  }, e;
}();
function ju(e, t) {
  return t = t || {}, new Promise(function(n, r) {
    var i = new XMLHttpRequest(), o = [], s = [], a = {}, l = function() {
      return { ok: (i.status / 100 | 0) == 2, statusText: i.statusText, status: i.status, url: i.responseURL, text: function() {
        return Promise.resolve(i.responseText);
      }, json: function() {
        return Promise.resolve(i.responseText).then(JSON.parse);
      }, blob: function() {
        return Promise.resolve(new Blob([i.response]));
      }, clone: l, headers: { keys: function() {
        return o;
      }, entries: function() {
        return s;
      }, get: function(g) {
        return a[g.toLowerCase()];
      }, has: function(g) {
        return g.toLowerCase() in a;
      } } };
    };
    for (var f in i.open(t.method || "get", e, !0), i.onload = function() {
      i.getAllResponseHeaders().replace(/^(.*?):[^\S\n]*([\s\S]*?)$/gm, function(g, p, m) {
        o.push(p = p.toLowerCase()), s.push([p, m]), a[p] = a[p] ? a[p] + "," + m : m;
      }), n(l());
    }, i.onerror = r, i.withCredentials = t.credentials == "include", t.headers) i.setRequestHeader(f, t.headers[f]);
    i.send(t.body || null);
  });
}
const Ku = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: ju
}, Symbol.toStringTag, { value: "Module" })), kr = /* @__PURE__ */ Gn(Ku);
self.fetch || (self.fetch = kr.default || kr);
var zu = { exports: {} };
/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
(function(e, t) {
  (function(n) {
    var r;
    if (e.exports = n(), r = !0, !r) {
      var i = window.Cookies, o = window.Cookies = n();
      o.noConflict = function() {
        return window.Cookies = i, o;
      };
    }
  })(function() {
    function n() {
      for (var o = 0, s = {}; o < arguments.length; o++) {
        var a = arguments[o];
        for (var l in a)
          s[l] = a[l];
      }
      return s;
    }
    function r(o) {
      return o.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
    }
    function i(o) {
      function s() {
      }
      function a(f, g, p) {
        if (!(typeof document > "u")) {
          p = n({
            path: "/"
          }, s.defaults, p), typeof p.expires == "number" && (p.expires = new Date(/* @__PURE__ */ new Date() * 1 + p.expires * 864e5)), p.expires = p.expires ? p.expires.toUTCString() : "";
          try {
            var m = JSON.stringify(g);
            /^[\{\[]/.test(m) && (g = m);
          } catch {
          }
          g = o.write ? o.write(g, f) : encodeURIComponent(String(g)).replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent), f = encodeURIComponent(String(f)).replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent).replace(/[\(\)]/g, escape);
          var E = "";
          for (var _ in p)
            p[_] && (E += "; " + _, p[_] !== !0 && (E += "=" + p[_].split(";")[0]));
          return document.cookie = f + "=" + g + E;
        }
      }
      function l(f, g) {
        if (!(typeof document > "u")) {
          for (var p = {}, m = document.cookie ? document.cookie.split("; ") : [], E = 0; E < m.length; E++) {
            var _ = m[E].split("="), S = _.slice(1).join("=");
            !g && S.charAt(0) === '"' && (S = S.slice(1, -1));
            try {
              var b = r(_[0]);
              if (S = (o.read || o)(S, b) || r(S), g)
                try {
                  S = JSON.parse(S);
                } catch {
                }
              if (p[b] = S, f === b)
                break;
            } catch {
            }
          }
          return f ? p[f] : p;
        }
      }
      return s.set = a, s.get = function(f) {
        return l(
          f,
          !1
          /* read as raw */
        );
      }, s.getJSON = function(f) {
        return l(
          f,
          !0
          /* read as json */
        );
      }, s.remove = function(f, g) {
        a(f, "", n(g, {
          expires: -1
        }));
      }, s.defaults = {}, s.withConverter = i, s;
    }
    return i(function() {
    });
  });
})(zu);
var Hi = { exports: {} };
(function(e, t) {
  (function(n, r) {
    e.exports = r(po);
  })(j, function(n) {
    return function() {
      var r = { 593: function(a, l, f) {
        Object.defineProperty(l, "__esModule", { value: !0 }), l.resendFailedRequest = l.getRetryInstance = l.unsetCache = l.createRequestQueueInterceptor = l.createRefreshCall = l.shouldInterceptError = l.mergeOptions = l.defaultOptions = void 0;
        const g = f(300);
        l.defaultOptions = { statusCodes: [401], pauseInstanceWhileRefreshing: !1 }, l.mergeOptions = function(p, m) {
          return Object.assign(Object.assign(Object.assign({}, p), { pauseInstanceWhileRefreshing: m.skipWhileRefreshing }), m);
        }, l.shouldInterceptError = function(p, m, E, _) {
          var S, b;
          return !!p && !(!((S = p.config) === null || S === void 0) && S.skipAuthRefresh) && !!(m.interceptNetworkError && !p.response && p.request.status === 0 || p.response && (m != null && m.shouldRefresh ? m.shouldRefresh(p) : !((b = m.statusCodes) === null || b === void 0) && b.includes(parseInt(p.response.status)))) && (p.response || (p.response = { config: p.config }), !m.pauseInstanceWhileRefreshing || !_.skipInstances.includes(E));
        }, l.createRefreshCall = function(p, m, E) {
          return E.refreshCall || (E.refreshCall = m(p), typeof E.refreshCall.then == "function") ? E.refreshCall : (console.warn("axios-auth-refresh requires `refreshTokenCall` to return a promise."), Promise.reject());
        }, l.createRequestQueueInterceptor = function(p, m, E) {
          return m.requestQueueInterceptorId === void 0 && (m.requestQueueInterceptorId = p.interceptors.request.use((_) => m.refreshCall.catch(() => {
            throw new g.default.Cancel("Request call failed");
          }).then(() => E.onRetry ? E.onRetry(_) : _))), m.requestQueueInterceptorId;
        }, l.unsetCache = function(p, m) {
          p.interceptors.request.eject(m.requestQueueInterceptorId), m.requestQueueInterceptorId = void 0, m.refreshCall = void 0, m.skipInstances = m.skipInstances.filter((E) => E !== p);
        }, l.getRetryInstance = function(p, m) {
          return m.retryInstance || p;
        }, l.resendFailedRequest = function(p, m) {
          return p.config.skipAuthRefresh = !0, m(p.response.config);
        };
      }, 300: function(a) {
        a.exports = n;
      } }, i = {};
      function o(a) {
        var l = i[a];
        if (l !== void 0) return l.exports;
        var f = i[a] = { exports: {} };
        return r[a](f, f.exports, o), f.exports;
      }
      var s = {};
      return function() {
        var a = s;
        Object.defineProperty(a, "__esModule", { value: !0 });
        const l = o(593);
        a.default = function(f, g, p = {}) {
          if (typeof g != "function") throw new Error("axios-auth-refresh requires `refreshAuthCall` to be a function that returns a promise.");
          const m = { skipInstances: [], refreshCall: void 0, requestQueueInterceptorId: void 0 };
          return f.interceptors.response.use((E) => E, (E) => {
            if (p = (0, l.mergeOptions)(l.defaultOptions, p), !(0, l.shouldInterceptError)(E, p, f, m)) return Promise.reject(E);
            p.pauseInstanceWhileRefreshing && m.skipInstances.push(f);
            const _ = (0, l.createRefreshCall)(E, g, m);
            return (0, l.createRequestQueueInterceptor)(f, m, p), _.catch((S) => Promise.reject(S)).then(() => (0, l.resendFailedRequest)(E, (0, l.getRetryInstance)(f, p))).finally(() => (0, l.unsetCache)(f, m));
          });
        };
      }(), s;
    }();
  });
})(Hi);
var qu = Hi.exports;
const Yu = /* @__PURE__ */ Hn(qu);
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Gi = function(e) {
  const t = [];
  let n = 0;
  for (let r = 0; r < e.length; r++) {
    let i = e.charCodeAt(r);
    i < 128 ? t[n++] = i : i < 2048 ? (t[n++] = i >> 6 | 192, t[n++] = i & 63 | 128) : (i & 64512) === 55296 && r + 1 < e.length && (e.charCodeAt(r + 1) & 64512) === 56320 ? (i = 65536 + ((i & 1023) << 10) + (e.charCodeAt(++r) & 1023), t[n++] = i >> 18 | 240, t[n++] = i >> 12 & 63 | 128, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128) : (t[n++] = i >> 12 | 224, t[n++] = i >> 6 & 63 | 128, t[n++] = i & 63 | 128);
  }
  return t;
}, Xu = function(e) {
  const t = [];
  let n = 0, r = 0;
  for (; n < e.length; ) {
    const i = e[n++];
    if (i < 128)
      t[r++] = String.fromCharCode(i);
    else if (i > 191 && i < 224) {
      const o = e[n++];
      t[r++] = String.fromCharCode((i & 31) << 6 | o & 63);
    } else if (i > 239 && i < 365) {
      const o = e[n++], s = e[n++], a = e[n++], l = ((i & 7) << 18 | (o & 63) << 12 | (s & 63) << 6 | a & 63) - 65536;
      t[r++] = String.fromCharCode(55296 + (l >> 10)), t[r++] = String.fromCharCode(56320 + (l & 1023));
    } else {
      const o = e[n++], s = e[n++];
      t[r++] = String.fromCharCode((i & 15) << 12 | (o & 63) << 6 | s & 63);
    }
  }
  return t.join("");
}, Wi = {
  /**
   * Maps bytes to characters.
   */
  byteToCharMap_: null,
  /**
   * Maps characters to bytes.
   */
  charToByteMap_: null,
  /**
   * Maps bytes to websafe characters.
   * @private
   */
  byteToCharMapWebSafe_: null,
  /**
   * Maps websafe characters to bytes.
   * @private
   */
  charToByteMapWebSafe_: null,
  /**
   * Our default alphabet, shared between
   * ENCODED_VALS and ENCODED_VALS_WEBSAFE
   */
  ENCODED_VALS_BASE: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789",
  /**
   * Our default alphabet. Value 64 (=) is special; it means "nothing."
   */
  get ENCODED_VALS() {
    return this.ENCODED_VALS_BASE + "+/=";
  },
  /**
   * Our websafe alphabet.
   */
  get ENCODED_VALS_WEBSAFE() {
    return this.ENCODED_VALS_BASE + "-_.";
  },
  /**
   * Whether this browser supports the atob and btoa functions. This extension
   * started at Mozilla but is now implemented by many browsers. We use the
   * ASSUME_* variables to avoid pulling in the full useragent detection library
   * but still allowing the standard per-browser compilations.
   *
   */
  HAS_NATIVE_SUPPORT: typeof atob == "function",
  /**
   * Base64-encode an array of bytes.
   *
   * @param input An array of bytes (numbers with
   *     value in [0, 255]) to encode.
   * @param webSafe Boolean indicating we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeByteArray(e, t) {
    if (!Array.isArray(e))
      throw Error("encodeByteArray takes an array as a parameter");
    this.init_();
    const n = t ? this.byteToCharMapWebSafe_ : this.byteToCharMap_, r = [];
    for (let i = 0; i < e.length; i += 3) {
      const o = e[i], s = i + 1 < e.length, a = s ? e[i + 1] : 0, l = i + 2 < e.length, f = l ? e[i + 2] : 0, g = o >> 2, p = (o & 3) << 4 | a >> 4;
      let m = (a & 15) << 2 | f >> 6, E = f & 63;
      l || (E = 64, s || (m = 64)), r.push(n[g], n[p], n[m], n[E]);
    }
    return r.join("");
  },
  /**
   * Base64-encode a string.
   *
   * @param input A string to encode.
   * @param webSafe If true, we should use the
   *     alternative alphabet.
   * @return The base64 encoded string.
   */
  encodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? btoa(e) : this.encodeByteArray(Gi(e), t);
  },
  /**
   * Base64-decode a string.
   *
   * @param input to decode.
   * @param webSafe True if we should use the
   *     alternative alphabet.
   * @return string representing the decoded value.
   */
  decodeString(e, t) {
    return this.HAS_NATIVE_SUPPORT && !t ? atob(e) : Xu(this.decodeStringToByteArray(e, t));
  },
  /**
   * Base64-decode a string.
   *
   * In base-64 decoding, groups of four characters are converted into three
   * bytes.  If the encoder did not apply padding, the input length may not
   * be a multiple of 4.
   *
   * In this case, the last group will have fewer than 4 characters, and
   * padding will be inferred.  If the group has one or two characters, it decodes
   * to one byte.  If the group has three characters, it decodes to two bytes.
   *
   * @param input Input to decode.
   * @param webSafe True if we should use the web-safe alphabet.
   * @return bytes representing the decoded value.
   */
  decodeStringToByteArray(e, t) {
    this.init_();
    const n = t ? this.charToByteMapWebSafe_ : this.charToByteMap_, r = [];
    for (let i = 0; i < e.length; ) {
      const o = n[e.charAt(i++)], a = i < e.length ? n[e.charAt(i)] : 0;
      ++i;
      const f = i < e.length ? n[e.charAt(i)] : 64;
      ++i;
      const p = i < e.length ? n[e.charAt(i)] : 64;
      if (++i, o == null || a == null || f == null || p == null)
        throw new Ju();
      const m = o << 2 | a >> 4;
      if (r.push(m), f !== 64) {
        const E = a << 4 & 240 | f >> 2;
        if (r.push(E), p !== 64) {
          const _ = f << 6 & 192 | p;
          r.push(_);
        }
      }
    }
    return r;
  },
  /**
   * Lazy static initialization function. Called before
   * accessing any of the static map variables.
   * @private
   */
  init_() {
    if (!this.byteToCharMap_) {
      this.byteToCharMap_ = {}, this.charToByteMap_ = {}, this.byteToCharMapWebSafe_ = {}, this.charToByteMapWebSafe_ = {};
      for (let e = 0; e < this.ENCODED_VALS.length; e++)
        this.byteToCharMap_[e] = this.ENCODED_VALS.charAt(e), this.charToByteMap_[this.byteToCharMap_[e]] = e, this.byteToCharMapWebSafe_[e] = this.ENCODED_VALS_WEBSAFE.charAt(e), this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[e]] = e, e >= this.ENCODED_VALS_BASE.length && (this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(e)] = e, this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(e)] = e);
    }
  }
};
class Ju extends Error {
  constructor() {
    super(...arguments), this.name = "DecodeBase64StringError";
  }
}
const Zu = function(e) {
  const t = Gi(e);
  return Wi.encodeByteArray(t, !0);
}, Vi = function(e) {
  return Zu(e).replace(/\./g, "");
}, Qu = function(e) {
  try {
    return Wi.decodeString(e, !0);
  } catch (t) {
    console.error("base64Decode failed: ", t);
  }
  return null;
};
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function el() {
  if (typeof self < "u")
    return self;
  if (typeof window < "u")
    return window;
  if (typeof global < "u")
    return global;
  throw new Error("Unable to locate global object.");
}
/**
 * @license
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const tl = () => el().__FIREBASE_DEFAULTS__, nl = () => {
  if (typeof process > "u" || typeof process.env > "u")
    return;
  const e = process.env.__FIREBASE_DEFAULTS__;
  if (e)
    return JSON.parse(e);
}, rl = () => {
  if (typeof document > "u")
    return;
  let e;
  try {
    e = document.cookie.match(/__FIREBASE_DEFAULTS__=([^;]+)/);
  } catch {
    return;
  }
  const t = e && Qu(e[1]);
  return t && JSON.parse(t);
}, or = () => {
  try {
    return tl() || nl() || rl();
  } catch (e) {
    console.info(`Unable to get __FIREBASE_DEFAULTS__ due to: ${e}`);
    return;
  }
}, ch = (e) => {
  var t, n;
  return (n = (t = or()) === null || t === void 0 ? void 0 : t.emulatorHosts) === null || n === void 0 ? void 0 : n[e];
}, $i = () => {
  var e;
  return (e = or()) === null || e === void 0 ? void 0 : e.config;
}, uh = (e) => {
  var t;
  return (t = or()) === null || t === void 0 ? void 0 : t[`_${e}`];
};
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class il {
  constructor() {
    this.reject = () => {
    }, this.resolve = () => {
    }, this.promise = new Promise((t, n) => {
      this.resolve = t, this.reject = n;
    });
  }
  /**
   * Our API internals are not promisified and cannot because our callback APIs have subtle expectations around
   * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
   * and returns a node-style callback which will resolve or reject the Deferred's promise.
   */
  wrapCallback(t) {
    return (n, r) => {
      n ? this.reject(n) : this.resolve(r), typeof t == "function" && (this.promise.catch(() => {
      }), t.length === 1 ? t(n) : t(n, r));
    };
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function ji() {
  return typeof navigator < "u" && typeof navigator.userAgent == "string" ? navigator.userAgent : "";
}
function lh() {
  return typeof window < "u" && // @ts-ignore Setting up an broadly applicable index signature for Window
  // just to deal with this case would probably be a bad idea.
  !!(window.cordova || window.phonegap || window.PhoneGap) && /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(ji());
}
function fh() {
  return typeof navigator < "u" && navigator.userAgent === "Cloudflare-Workers";
}
function hh() {
  const e = typeof chrome == "object" ? chrome.runtime : typeof browser == "object" ? browser.runtime : void 0;
  return typeof e == "object" && e.id !== void 0;
}
function dh() {
  return typeof navigator == "object" && navigator.product === "ReactNative";
}
function ph() {
  const e = ji();
  return e.indexOf("MSIE ") >= 0 || e.indexOf("Trident/") >= 0;
}
function ol() {
  try {
    return typeof indexedDB == "object";
  } catch {
    return !1;
  }
}
function sl() {
  return new Promise((e, t) => {
    try {
      let n = !0;
      const r = "validate-browser-context-for-indexeddb-analytics-module", i = self.indexedDB.open(r);
      i.onsuccess = () => {
        i.result.close(), n || self.indexedDB.deleteDatabase(r), e(!0);
      }, i.onupgradeneeded = () => {
        n = !1;
      }, i.onerror = () => {
        var o;
        t(((o = i.error) === null || o === void 0 ? void 0 : o.message) || "");
      };
    } catch (n) {
      t(n);
    }
  });
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const al = "FirebaseError";
class _t extends Error {
  constructor(t, n, r) {
    super(n), this.code = t, this.customData = r, this.name = al, Object.setPrototypeOf(this, _t.prototype), Error.captureStackTrace && Error.captureStackTrace(this, Ki.prototype.create);
  }
}
class Ki {
  constructor(t, n, r) {
    this.service = t, this.serviceName = n, this.errors = r;
  }
  create(t, ...n) {
    const r = n[0] || {}, i = `${this.service}/${t}`, o = this.errors[t], s = o ? cl(o, r) : "Error", a = `${this.serviceName}: ${s} (${i}).`;
    return new _t(i, a, r);
  }
}
function cl(e, t) {
  return e.replace(ul, (n, r) => {
    const i = t[r];
    return i != null ? String(i) : `<${r}?>`;
  });
}
const ul = /\{\$([^}]+)}/g;
function gh(e) {
  for (const t in e)
    if (Object.prototype.hasOwnProperty.call(e, t))
      return !1;
  return !0;
}
function Tn(e, t) {
  if (e === t)
    return !0;
  const n = Object.keys(e), r = Object.keys(t);
  for (const i of n) {
    if (!r.includes(i))
      return !1;
    const o = e[i], s = t[i];
    if (Br(o) && Br(s)) {
      if (!Tn(o, s))
        return !1;
    } else if (o !== s)
      return !1;
  }
  for (const i of r)
    if (!n.includes(i))
      return !1;
  return !0;
}
function Br(e) {
  return e !== null && typeof e == "object";
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function mh(e) {
  const t = [];
  for (const [n, r] of Object.entries(e))
    Array.isArray(r) ? r.forEach((i) => {
      t.push(encodeURIComponent(n) + "=" + encodeURIComponent(i));
    }) : t.push(encodeURIComponent(n) + "=" + encodeURIComponent(r));
  return t.length ? "&" + t.join("&") : "";
}
function vh(e) {
  const t = {};
  return e.replace(/^\?/, "").split("&").forEach((r) => {
    if (r) {
      const [i, o] = r.split("=");
      t[decodeURIComponent(i)] = decodeURIComponent(o);
    }
  }), t;
}
function yh(e) {
  const t = e.indexOf("?");
  if (!t)
    return "";
  const n = e.indexOf("#", t);
  return e.substring(t, n > 0 ? n : void 0);
}
function Sh(e, t) {
  const n = new ll(e, t);
  return n.subscribe.bind(n);
}
class ll {
  /**
   * @param executor Function which can make calls to a single Observer
   *     as a proxy.
   * @param onNoObservers Callback when count of Observers goes to zero.
   */
  constructor(t, n) {
    this.observers = [], this.unsubscribes = [], this.observerCount = 0, this.task = Promise.resolve(), this.finalized = !1, this.onNoObservers = n, this.task.then(() => {
      t(this);
    }).catch((r) => {
      this.error(r);
    });
  }
  next(t) {
    this.forEachObserver((n) => {
      n.next(t);
    });
  }
  error(t) {
    this.forEachObserver((n) => {
      n.error(t);
    }), this.close(t);
  }
  complete() {
    this.forEachObserver((t) => {
      t.complete();
    }), this.close();
  }
  /**
   * Subscribe function that can be used to add an Observer to the fan-out list.
   *
   * - We require that no event is sent to a subscriber synchronously to their
   *   call to subscribe().
   */
  subscribe(t, n, r) {
    let i;
    if (t === void 0 && n === void 0 && r === void 0)
      throw new Error("Missing Observer.");
    fl(t, [
      "next",
      "error",
      "complete"
    ]) ? i = t : i = {
      next: t,
      error: n,
      complete: r
    }, i.next === void 0 && (i.next = sn), i.error === void 0 && (i.error = sn), i.complete === void 0 && (i.complete = sn);
    const o = this.unsubscribeOne.bind(this, this.observers.length);
    return this.finalized && this.task.then(() => {
      try {
        this.finalError ? i.error(this.finalError) : i.complete();
      } catch {
      }
    }), this.observers.push(i), o;
  }
  // Unsubscribe is synchronous - we guarantee that no events are sent to
  // any unsubscribed Observer.
  unsubscribeOne(t) {
    this.observers === void 0 || this.observers[t] === void 0 || (delete this.observers[t], this.observerCount -= 1, this.observerCount === 0 && this.onNoObservers !== void 0 && this.onNoObservers(this));
  }
  forEachObserver(t) {
    if (!this.finalized)
      for (let n = 0; n < this.observers.length; n++)
        this.sendOne(n, t);
  }
  // Call the Observer via one of it's callback function. We are careful to
  // confirm that the observe has not been unsubscribed since this asynchronous
  // function had been queued.
  sendOne(t, n) {
    this.task.then(() => {
      if (this.observers !== void 0 && this.observers[t] !== void 0)
        try {
          n(this.observers[t]);
        } catch (r) {
          typeof console < "u" && console.error && console.error(r);
        }
    });
  }
  close(t) {
    this.finalized || (this.finalized = !0, t !== void 0 && (this.finalError = t), this.task.then(() => {
      this.observers = void 0, this.onNoObservers = void 0;
    }));
  }
}
function fl(e, t) {
  if (typeof e != "object" || e === null)
    return !1;
  for (const n of t)
    if (n in e && typeof e[n] == "function")
      return !0;
  return !1;
}
function sn() {
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function Eh(e) {
  return e && e._delegate ? e._delegate : e;
}
class Lt {
  /**
   *
   * @param name The public service name, e.g. app, auth, firestore, database
   * @param instanceFactory Service factory responsible for creating the public interface
   * @param type whether the service provided by the component is public or private
   */
  constructor(t, n, r) {
    this.name = t, this.instanceFactory = n, this.type = r, this.multipleInstances = !1, this.serviceProps = {}, this.instantiationMode = "LAZY", this.onInstanceCreated = null;
  }
  setInstantiationMode(t) {
    return this.instantiationMode = t, this;
  }
  setMultipleInstances(t) {
    return this.multipleInstances = t, this;
  }
  setServiceProps(t) {
    return this.serviceProps = t, this;
  }
  setInstanceCreatedCallback(t) {
    return this.onInstanceCreated = t, this;
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Me = "[DEFAULT]";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class hl {
  constructor(t, n) {
    this.name = t, this.container = n, this.component = null, this.instances = /* @__PURE__ */ new Map(), this.instancesDeferred = /* @__PURE__ */ new Map(), this.instancesOptions = /* @__PURE__ */ new Map(), this.onInitCallbacks = /* @__PURE__ */ new Map();
  }
  /**
   * @param identifier A provider can provide multiple instances of a service
   * if this.component.multipleInstances is true.
   */
  get(t) {
    const n = this.normalizeInstanceIdentifier(t);
    if (!this.instancesDeferred.has(n)) {
      const r = new il();
      if (this.instancesDeferred.set(n, r), this.isInitialized(n) || this.shouldAutoInitialize())
        try {
          const i = this.getOrInitializeService({
            instanceIdentifier: n
          });
          i && r.resolve(i);
        } catch {
        }
    }
    return this.instancesDeferred.get(n).promise;
  }
  getImmediate(t) {
    var n;
    const r = this.normalizeInstanceIdentifier(t == null ? void 0 : t.identifier), i = (n = t == null ? void 0 : t.optional) !== null && n !== void 0 ? n : !1;
    if (this.isInitialized(r) || this.shouldAutoInitialize())
      try {
        return this.getOrInitializeService({
          instanceIdentifier: r
        });
      } catch (o) {
        if (i)
          return null;
        throw o;
      }
    else {
      if (i)
        return null;
      throw Error(`Service ${this.name} is not available`);
    }
  }
  getComponent() {
    return this.component;
  }
  setComponent(t) {
    if (t.name !== this.name)
      throw Error(`Mismatching Component ${t.name} for Provider ${this.name}.`);
    if (this.component)
      throw Error(`Component for ${this.name} has already been provided`);
    if (this.component = t, !!this.shouldAutoInitialize()) {
      if (pl(t))
        try {
          this.getOrInitializeService({ instanceIdentifier: Me });
        } catch {
        }
      for (const [n, r] of this.instancesDeferred.entries()) {
        const i = this.normalizeInstanceIdentifier(n);
        try {
          const o = this.getOrInitializeService({
            instanceIdentifier: i
          });
          r.resolve(o);
        } catch {
        }
      }
    }
  }
  clearInstance(t = Me) {
    this.instancesDeferred.delete(t), this.instancesOptions.delete(t), this.instances.delete(t);
  }
  // app.delete() will call this method on every provider to delete the services
  // TODO: should we mark the provider as deleted?
  async delete() {
    const t = Array.from(this.instances.values());
    await Promise.all([
      ...t.filter((n) => "INTERNAL" in n).map((n) => n.INTERNAL.delete()),
      ...t.filter((n) => "_delete" in n).map((n) => n._delete())
    ]);
  }
  isComponentSet() {
    return this.component != null;
  }
  isInitialized(t = Me) {
    return this.instances.has(t);
  }
  getOptions(t = Me) {
    return this.instancesOptions.get(t) || {};
  }
  initialize(t = {}) {
    const { options: n = {} } = t, r = this.normalizeInstanceIdentifier(t.instanceIdentifier);
    if (this.isInitialized(r))
      throw Error(`${this.name}(${r}) has already been initialized`);
    if (!this.isComponentSet())
      throw Error(`Component ${this.name} has not been registered yet`);
    const i = this.getOrInitializeService({
      instanceIdentifier: r,
      options: n
    });
    for (const [o, s] of this.instancesDeferred.entries()) {
      const a = this.normalizeInstanceIdentifier(o);
      r === a && s.resolve(i);
    }
    return i;
  }
  /**
   *
   * @param callback - a function that will be invoked  after the provider has been initialized by calling provider.initialize().
   * The function is invoked SYNCHRONOUSLY, so it should not execute any longrunning tasks in order to not block the program.
   *
   * @param identifier An optional instance identifier
   * @returns a function to unregister the callback
   */
  onInit(t, n) {
    var r;
    const i = this.normalizeInstanceIdentifier(n), o = (r = this.onInitCallbacks.get(i)) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set();
    o.add(t), this.onInitCallbacks.set(i, o);
    const s = this.instances.get(i);
    return s && t(s, i), () => {
      o.delete(t);
    };
  }
  /**
   * Invoke onInit callbacks synchronously
   * @param instance the service instance`
   */
  invokeOnInitCallbacks(t, n) {
    const r = this.onInitCallbacks.get(n);
    if (r)
      for (const i of r)
        try {
          i(t, n);
        } catch {
        }
  }
  getOrInitializeService({ instanceIdentifier: t, options: n = {} }) {
    let r = this.instances.get(t);
    if (!r && this.component && (r = this.component.instanceFactory(this.container, {
      instanceIdentifier: dl(t),
      options: n
    }), this.instances.set(t, r), this.instancesOptions.set(t, n), this.invokeOnInitCallbacks(r, t), this.component.onInstanceCreated))
      try {
        this.component.onInstanceCreated(this.container, t, r);
      } catch {
      }
    return r || null;
  }
  normalizeInstanceIdentifier(t = Me) {
    return this.component ? this.component.multipleInstances ? t : Me : t;
  }
  shouldAutoInitialize() {
    return !!this.component && this.component.instantiationMode !== "EXPLICIT";
  }
}
function dl(e) {
  return e === Me ? void 0 : e;
}
function pl(e) {
  return e.instantiationMode === "EAGER";
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class gl {
  constructor(t) {
    this.name = t, this.providers = /* @__PURE__ */ new Map();
  }
  /**
   *
   * @param component Component being added
   * @param overwrite When a component with the same name has already been registered,
   * if overwrite is true: overwrite the existing component with the new component and create a new
   * provider with the new component. It can be useful in tests where you want to use different mocks
   * for different tests.
   * if overwrite is false: throw an exception
   */
  addComponent(t) {
    const n = this.getProvider(t.name);
    if (n.isComponentSet())
      throw new Error(`Component ${t.name} has already been registered with ${this.name}`);
    n.setComponent(t);
  }
  addOrOverwriteComponent(t) {
    this.getProvider(t.name).isComponentSet() && this.providers.delete(t.name), this.addComponent(t);
  }
  /**
   * getProvider provides a type safe interface where it can only be called with a field name
   * present in NameServiceMapping interface.
   *
   * Firebase SDKs providing services should extend NameServiceMapping interface to register
   * themselves.
   */
  getProvider(t) {
    if (this.providers.has(t))
      return this.providers.get(t);
    const n = new hl(t, this);
    return this.providers.set(t, n), n;
  }
  getProviders() {
    return Array.from(this.providers.values());
  }
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var H;
(function(e) {
  e[e.DEBUG = 0] = "DEBUG", e[e.VERBOSE = 1] = "VERBOSE", e[e.INFO = 2] = "INFO", e[e.WARN = 3] = "WARN", e[e.ERROR = 4] = "ERROR", e[e.SILENT = 5] = "SILENT";
})(H || (H = {}));
const ml = {
  debug: H.DEBUG,
  verbose: H.VERBOSE,
  info: H.INFO,
  warn: H.WARN,
  error: H.ERROR,
  silent: H.SILENT
}, vl = H.INFO, yl = {
  [H.DEBUG]: "log",
  [H.VERBOSE]: "log",
  [H.INFO]: "info",
  [H.WARN]: "warn",
  [H.ERROR]: "error"
}, Sl = (e, t, ...n) => {
  if (t < e.logLevel)
    return;
  const r = (/* @__PURE__ */ new Date()).toISOString(), i = yl[t];
  if (i)
    console[i](`[${r}]  ${e.name}:`, ...n);
  else
    throw new Error(`Attempted to log a message with an invalid logType (value: ${t})`);
};
class El {
  /**
   * Gives you an instance of a Logger to capture messages according to
   * Firebase's logging scheme.
   *
   * @param name The name that the logs will be associated with
   */
  constructor(t) {
    this.name = t, this._logLevel = vl, this._logHandler = Sl, this._userLogHandler = null;
  }
  get logLevel() {
    return this._logLevel;
  }
  set logLevel(t) {
    if (!(t in H))
      throw new TypeError(`Invalid value "${t}" assigned to \`logLevel\``);
    this._logLevel = t;
  }
  // Workaround for setter/getter having to be the same type.
  setLogLevel(t) {
    this._logLevel = typeof t == "string" ? ml[t] : t;
  }
  get logHandler() {
    return this._logHandler;
  }
  set logHandler(t) {
    if (typeof t != "function")
      throw new TypeError("Value assigned to `logHandler` must be a function");
    this._logHandler = t;
  }
  get userLogHandler() {
    return this._userLogHandler;
  }
  set userLogHandler(t) {
    this._userLogHandler = t;
  }
  /**
   * The functions below are all based on the `console` interface
   */
  debug(...t) {
    this._userLogHandler && this._userLogHandler(this, H.DEBUG, ...t), this._logHandler(this, H.DEBUG, ...t);
  }
  log(...t) {
    this._userLogHandler && this._userLogHandler(this, H.VERBOSE, ...t), this._logHandler(this, H.VERBOSE, ...t);
  }
  info(...t) {
    this._userLogHandler && this._userLogHandler(this, H.INFO, ...t), this._logHandler(this, H.INFO, ...t);
  }
  warn(...t) {
    this._userLogHandler && this._userLogHandler(this, H.WARN, ...t), this._logHandler(this, H.WARN, ...t);
  }
  error(...t) {
    this._userLogHandler && this._userLogHandler(this, H.ERROR, ...t), this._logHandler(this, H.ERROR, ...t);
  }
}
const _l = (e, t) => t.some((n) => e instanceof n);
let Mr, Hr;
function wl() {
  return Mr || (Mr = [
    IDBDatabase,
    IDBObjectStore,
    IDBIndex,
    IDBCursor,
    IDBTransaction
  ]);
}
function Al() {
  return Hr || (Hr = [
    IDBCursor.prototype.advance,
    IDBCursor.prototype.continue,
    IDBCursor.prototype.continuePrimaryKey
  ]);
}
const zi = /* @__PURE__ */ new WeakMap(), bn = /* @__PURE__ */ new WeakMap(), qi = /* @__PURE__ */ new WeakMap(), an = /* @__PURE__ */ new WeakMap(), sr = /* @__PURE__ */ new WeakMap();
function Cl(e) {
  const t = new Promise((n, r) => {
    const i = () => {
      e.removeEventListener("success", o), e.removeEventListener("error", s);
    }, o = () => {
      n(Oe(e.result)), i();
    }, s = () => {
      r(e.error), i();
    };
    e.addEventListener("success", o), e.addEventListener("error", s);
  });
  return t.then((n) => {
    n instanceof IDBCursor && zi.set(n, e);
  }).catch(() => {
  }), sr.set(t, e), t;
}
function Tl(e) {
  if (bn.has(e))
    return;
  const t = new Promise((n, r) => {
    const i = () => {
      e.removeEventListener("complete", o), e.removeEventListener("error", s), e.removeEventListener("abort", s);
    }, o = () => {
      n(), i();
    }, s = () => {
      r(e.error || new DOMException("AbortError", "AbortError")), i();
    };
    e.addEventListener("complete", o), e.addEventListener("error", s), e.addEventListener("abort", s);
  });
  bn.set(e, t);
}
let In = {
  get(e, t, n) {
    if (e instanceof IDBTransaction) {
      if (t === "done")
        return bn.get(e);
      if (t === "objectStoreNames")
        return e.objectStoreNames || qi.get(e);
      if (t === "store")
        return n.objectStoreNames[1] ? void 0 : n.objectStore(n.objectStoreNames[0]);
    }
    return Oe(e[t]);
  },
  set(e, t, n) {
    return e[t] = n, !0;
  },
  has(e, t) {
    return e instanceof IDBTransaction && (t === "done" || t === "store") ? !0 : t in e;
  }
};
function bl(e) {
  In = e(In);
}
function Il(e) {
  return e === IDBDatabase.prototype.transaction && !("objectStoreNames" in IDBTransaction.prototype) ? function(t, ...n) {
    const r = e.call(cn(this), t, ...n);
    return qi.set(r, t.sort ? t.sort() : [t]), Oe(r);
  } : Al().includes(e) ? function(...t) {
    return e.apply(cn(this), t), Oe(zi.get(this));
  } : function(...t) {
    return Oe(e.apply(cn(this), t));
  };
}
function Dl(e) {
  return typeof e == "function" ? Il(e) : (e instanceof IDBTransaction && Tl(e), _l(e, wl()) ? new Proxy(e, In) : e);
}
function Oe(e) {
  if (e instanceof IDBRequest)
    return Cl(e);
  if (an.has(e))
    return an.get(e);
  const t = Dl(e);
  return t !== e && (an.set(e, t), sr.set(t, e)), t;
}
const cn = (e) => sr.get(e);
function Rl(e, t, { blocked: n, upgrade: r, blocking: i, terminated: o } = {}) {
  const s = indexedDB.open(e, t), a = Oe(s);
  return r && s.addEventListener("upgradeneeded", (l) => {
    r(Oe(s.result), l.oldVersion, l.newVersion, Oe(s.transaction), l);
  }), n && s.addEventListener("blocked", (l) => n(
    // Casting due to https://github.com/microsoft/TypeScript-DOM-lib-generator/pull/1405
    l.oldVersion,
    l.newVersion,
    l
  )), a.then((l) => {
    o && l.addEventListener("close", () => o()), i && l.addEventListener("versionchange", (f) => i(f.oldVersion, f.newVersion, f));
  }).catch(() => {
  }), a;
}
const xl = ["get", "getKey", "getAll", "getAllKeys", "count"], Ol = ["put", "add", "delete", "clear"], un = /* @__PURE__ */ new Map();
function Gr(e, t) {
  if (!(e instanceof IDBDatabase && !(t in e) && typeof t == "string"))
    return;
  if (un.get(t))
    return un.get(t);
  const n = t.replace(/FromIndex$/, ""), r = t !== n, i = Ol.includes(n);
  if (
    // Bail if the target doesn't exist on the target. Eg, getAll isn't in Edge.
    !(n in (r ? IDBIndex : IDBObjectStore).prototype) || !(i || xl.includes(n))
  )
    return;
  const o = async function(s, ...a) {
    const l = this.transaction(s, i ? "readwrite" : "readonly");
    let f = l.store;
    return r && (f = f.index(a.shift())), (await Promise.all([
      f[n](...a),
      i && l.done
    ]))[0];
  };
  return un.set(t, o), o;
}
bl((e) => ({
  ...e,
  get: (t, n, r) => Gr(t, n) || e.get(t, n, r),
  has: (t, n) => !!Gr(t, n) || e.has(t, n)
}));
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class Pl {
  constructor(t) {
    this.container = t;
  }
  // In initial implementation, this will be called by installations on
  // auth token refresh, and installations will send this string.
  getPlatformInfoString() {
    return this.container.getProviders().map((n) => {
      if (Ul(n)) {
        const r = n.getImmediate();
        return `${r.library}/${r.version}`;
      } else
        return null;
    }).filter((n) => n).join(" ");
  }
}
function Ul(e) {
  const t = e.getComponent();
  return (t == null ? void 0 : t.type) === "VERSION";
}
const Dn = "@firebase/app", Wr = "0.10.18";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const be = new El("@firebase/app"), Nl = "@firebase/app-compat", Ll = "@firebase/analytics-compat", Fl = "@firebase/analytics", kl = "@firebase/app-check-compat", Bl = "@firebase/app-check", Ml = "@firebase/auth", Hl = "@firebase/auth-compat", Gl = "@firebase/database", Wl = "@firebase/data-connect", Vl = "@firebase/database-compat", $l = "@firebase/functions", jl = "@firebase/functions-compat", Kl = "@firebase/installations", zl = "@firebase/installations-compat", ql = "@firebase/messaging", Yl = "@firebase/messaging-compat", Xl = "@firebase/performance", Jl = "@firebase/performance-compat", Zl = "@firebase/remote-config", Ql = "@firebase/remote-config-compat", ef = "@firebase/storage", tf = "@firebase/storage-compat", nf = "@firebase/firestore", rf = "@firebase/vertexai", of = "@firebase/firestore-compat", sf = "firebase", af = "11.2.0";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Rn = "[DEFAULT]", cf = {
  [Dn]: "fire-core",
  [Nl]: "fire-core-compat",
  [Fl]: "fire-analytics",
  [Ll]: "fire-analytics-compat",
  [Bl]: "fire-app-check",
  [kl]: "fire-app-check-compat",
  [Ml]: "fire-auth",
  [Hl]: "fire-auth-compat",
  [Gl]: "fire-rtdb",
  [Wl]: "fire-data-connect",
  [Vl]: "fire-rtdb-compat",
  [$l]: "fire-fn",
  [jl]: "fire-fn-compat",
  [Kl]: "fire-iid",
  [zl]: "fire-iid-compat",
  [ql]: "fire-fcm",
  [Yl]: "fire-fcm-compat",
  [Xl]: "fire-perf",
  [Jl]: "fire-perf-compat",
  [Zl]: "fire-rc",
  [Ql]: "fire-rc-compat",
  [ef]: "fire-gcs",
  [tf]: "fire-gcs-compat",
  [nf]: "fire-fst",
  [of]: "fire-fst-compat",
  [rf]: "fire-vertex",
  "fire-js": "fire-js",
  // Platform identifier for JS SDK.
  [sf]: "fire-js-all"
};
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const St = /* @__PURE__ */ new Map(), uf = /* @__PURE__ */ new Map(), xn = /* @__PURE__ */ new Map();
function Vr(e, t) {
  try {
    e.container.addComponent(t);
  } catch (n) {
    be.debug(`Component ${t.name} failed to register with FirebaseApp ${e.name}`, n);
  }
}
function On(e) {
  const t = e.name;
  if (xn.has(t))
    return be.debug(`There were multiple attempts to register component ${t}.`), !1;
  xn.set(t, e);
  for (const n of St.values())
    Vr(n, e);
  for (const n of uf.values())
    Vr(n, e);
  return !0;
}
function _h(e, t) {
  const n = e.container.getProvider("heartbeat").getImmediate({ optional: !0 });
  return n && n.triggerHeartbeat(), e.container.getProvider(t);
}
function wh(e) {
  return e.settings !== void 0;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const lf = {
  "no-app": "No Firebase App '{$appName}' has been created - call initializeApp() first",
  "bad-app-name": "Illegal App name: '{$appName}'",
  "duplicate-app": "Firebase App named '{$appName}' already exists with different options or config",
  "app-deleted": "Firebase App named '{$appName}' already deleted",
  "server-app-deleted": "Firebase Server App has been deleted",
  "no-options": "Need to provide options, when not being deployed to hosting via source.",
  "invalid-app-argument": "firebase.{$appName}() takes either no argument or a Firebase App instance.",
  "invalid-log-argument": "First argument to `onLog` must be null or a function.",
  "idb-open": "Error thrown when opening IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-get": "Error thrown when reading from IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-set": "Error thrown when writing to IndexedDB. Original error: {$originalErrorMessage}.",
  "idb-delete": "Error thrown when deleting from IndexedDB. Original error: {$originalErrorMessage}.",
  "finalization-registry-not-supported": "FirebaseServerApp deleteOnDeref field defined but the JS runtime does not support FinalizationRegistry.",
  "invalid-server-app-environment": "FirebaseServerApp is not for use in browser environments."
}, Pe = new Ki("app", "Firebase", lf);
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
class ff {
  constructor(t, n, r) {
    this._isDeleted = !1, this._options = Object.assign({}, t), this._config = Object.assign({}, n), this._name = n.name, this._automaticDataCollectionEnabled = n.automaticDataCollectionEnabled, this._container = r, this.container.addComponent(new Lt(
      "app",
      () => this,
      "PUBLIC"
      /* ComponentType.PUBLIC */
    ));
  }
  get automaticDataCollectionEnabled() {
    return this.checkDestroyed(), this._automaticDataCollectionEnabled;
  }
  set automaticDataCollectionEnabled(t) {
    this.checkDestroyed(), this._automaticDataCollectionEnabled = t;
  }
  get name() {
    return this.checkDestroyed(), this._name;
  }
  get options() {
    return this.checkDestroyed(), this._options;
  }
  get config() {
    return this.checkDestroyed(), this._config;
  }
  get container() {
    return this._container;
  }
  get isDeleted() {
    return this._isDeleted;
  }
  set isDeleted(t) {
    this._isDeleted = t;
  }
  /**
   * This function will throw an Error if the App has already been deleted -
   * use before performing API actions on the App.
   */
  checkDestroyed() {
    if (this.isDeleted)
      throw Pe.create("app-deleted", { appName: this._name });
  }
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const Ah = af;
function Yi(e, t = {}) {
  let n = e;
  typeof t != "object" && (t = { name: t });
  const r = Object.assign({ name: Rn, automaticDataCollectionEnabled: !1 }, t), i = r.name;
  if (typeof i != "string" || !i)
    throw Pe.create("bad-app-name", {
      appName: String(i)
    });
  if (n || (n = $i()), !n)
    throw Pe.create(
      "no-options"
      /* AppError.NO_OPTIONS */
    );
  const o = St.get(i);
  if (o) {
    if (Tn(n, o.options) && Tn(r, o.config))
      return o;
    throw Pe.create("duplicate-app", { appName: i });
  }
  const s = new gl(i);
  for (const l of xn.values())
    s.addComponent(l);
  const a = new ff(n, r, s);
  return St.set(i, a), a;
}
function Ch(e = Rn) {
  const t = St.get(e);
  if (!t && e === Rn && $i())
    return Yi();
  if (!t)
    throw Pe.create("no-app", { appName: e });
  return t;
}
function hf() {
  return Array.from(St.values());
}
function Pt(e, t, n) {
  var r;
  let i = (r = cf[e]) !== null && r !== void 0 ? r : e;
  n && (i += `-${n}`);
  const o = i.match(/\s|\//), s = t.match(/\s|\//);
  if (o || s) {
    const a = [
      `Unable to register library "${i}" with version "${t}":`
    ];
    o && a.push(`library name "${i}" contains illegal characters (whitespace or "/")`), o && s && a.push("and"), s && a.push(`version name "${t}" contains illegal characters (whitespace or "/")`), be.warn(a.join(" "));
    return;
  }
  On(new Lt(
    `${i}-version`,
    () => ({ library: i, version: t }),
    "VERSION"
    /* ComponentType.VERSION */
  ));
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const df = "firebase-heartbeat-database", pf = 1, Et = "firebase-heartbeat-store";
let ln = null;
function Xi() {
  return ln || (ln = Rl(df, pf, {
    upgrade: (e, t) => {
      switch (t) {
        case 0:
          try {
            e.createObjectStore(Et);
          } catch (n) {
            console.warn(n);
          }
      }
    }
  }).catch((e) => {
    throw Pe.create("idb-open", {
      originalErrorMessage: e.message
    });
  })), ln;
}
async function gf(e) {
  try {
    const n = (await Xi()).transaction(Et), r = await n.objectStore(Et).get(Ji(e));
    return await n.done, r;
  } catch (t) {
    if (t instanceof _t)
      be.warn(t.message);
    else {
      const n = Pe.create("idb-get", {
        originalErrorMessage: t == null ? void 0 : t.message
      });
      be.warn(n.message);
    }
  }
}
async function $r(e, t) {
  try {
    const r = (await Xi()).transaction(Et, "readwrite");
    await r.objectStore(Et).put(t, Ji(e)), await r.done;
  } catch (n) {
    if (n instanceof _t)
      be.warn(n.message);
    else {
      const r = Pe.create("idb-set", {
        originalErrorMessage: n == null ? void 0 : n.message
      });
      be.warn(r.message);
    }
  }
}
function Ji(e) {
  return `${e.name}!${e.options.appId}`;
}
/**
 * @license
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const mf = 1024, vf = 30 * 24 * 60 * 60 * 1e3;
class yf {
  constructor(t) {
    this.container = t, this._heartbeatsCache = null;
    const n = this.container.getProvider("app").getImmediate();
    this._storage = new Ef(n), this._heartbeatsCachePromise = this._storage.read().then((r) => (this._heartbeatsCache = r, r));
  }
  /**
   * Called to report a heartbeat. The function will generate
   * a HeartbeatsByUserAgent object, update heartbeatsCache, and persist it
   * to IndexedDB.
   * Note that we only store one heartbeat per day. So if a heartbeat for today is
   * already logged, subsequent calls to this function in the same day will be ignored.
   */
  async triggerHeartbeat() {
    var t, n;
    try {
      const i = this.container.getProvider("platform-logger").getImmediate().getPlatformInfoString(), o = jr();
      return ((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null && (this._heartbeatsCache = await this._heartbeatsCachePromise, ((n = this._heartbeatsCache) === null || n === void 0 ? void 0 : n.heartbeats) == null) || this._heartbeatsCache.lastSentHeartbeatDate === o || this._heartbeatsCache.heartbeats.some((s) => s.date === o) ? void 0 : (this._heartbeatsCache.heartbeats.push({ date: o, agent: i }), this._heartbeatsCache.heartbeats = this._heartbeatsCache.heartbeats.filter((s) => {
        const a = new Date(s.date).valueOf();
        return Date.now() - a <= vf;
      }), this._storage.overwrite(this._heartbeatsCache));
    } catch (r) {
      be.warn(r);
    }
  }
  /**
   * Returns a base64 encoded string which can be attached to the heartbeat-specific header directly.
   * It also clears all heartbeats from memory as well as in IndexedDB.
   *
   * NOTE: Consuming product SDKs should not send the header if this method
   * returns an empty string.
   */
  async getHeartbeatsHeader() {
    var t;
    try {
      if (this._heartbeatsCache === null && await this._heartbeatsCachePromise, ((t = this._heartbeatsCache) === null || t === void 0 ? void 0 : t.heartbeats) == null || this._heartbeatsCache.heartbeats.length === 0)
        return "";
      const n = jr(), { heartbeatsToSend: r, unsentEntries: i } = Sf(this._heartbeatsCache.heartbeats), o = Vi(JSON.stringify({ version: 2, heartbeats: r }));
      return this._heartbeatsCache.lastSentHeartbeatDate = n, i.length > 0 ? (this._heartbeatsCache.heartbeats = i, await this._storage.overwrite(this._heartbeatsCache)) : (this._heartbeatsCache.heartbeats = [], this._storage.overwrite(this._heartbeatsCache)), o;
    } catch (n) {
      return be.warn(n), "";
    }
  }
}
function jr() {
  return (/* @__PURE__ */ new Date()).toISOString().substring(0, 10);
}
function Sf(e, t = mf) {
  const n = [];
  let r = e.slice();
  for (const i of e) {
    const o = n.find((s) => s.agent === i.agent);
    if (o) {
      if (o.dates.push(i.date), Kr(n) > t) {
        o.dates.pop();
        break;
      }
    } else if (n.push({
      agent: i.agent,
      dates: [i.date]
    }), Kr(n) > t) {
      n.pop();
      break;
    }
    r = r.slice(1);
  }
  return {
    heartbeatsToSend: n,
    unsentEntries: r
  };
}
class Ef {
  constructor(t) {
    this.app = t, this._canUseIndexedDBPromise = this.runIndexedDBEnvironmentCheck();
  }
  async runIndexedDBEnvironmentCheck() {
    return ol() ? sl().then(() => !0).catch(() => !1) : !1;
  }
  /**
   * Read all heartbeats.
   */
  async read() {
    if (await this._canUseIndexedDBPromise) {
      const n = await gf(this.app);
      return n != null && n.heartbeats ? n : { heartbeats: [] };
    } else
      return { heartbeats: [] };
  }
  // overwrite the storage with the provided heartbeats
  async overwrite(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return $r(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: t.heartbeats
      });
    } else
      return;
  }
  // add heartbeats
  async add(t) {
    var n;
    if (await this._canUseIndexedDBPromise) {
      const i = await this.read();
      return $r(this.app, {
        lastSentHeartbeatDate: (n = t.lastSentHeartbeatDate) !== null && n !== void 0 ? n : i.lastSentHeartbeatDate,
        heartbeats: [
          ...i.heartbeats,
          ...t.heartbeats
        ]
      });
    } else
      return;
  }
}
function Kr(e) {
  return Vi(
    // heartbeatsCache wrapper properties
    JSON.stringify({ version: 2, heartbeats: e })
  ).length;
}
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function _f(e) {
  On(new Lt(
    "platform-logger",
    (t) => new Pl(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), On(new Lt(
    "heartbeat",
    (t) => new yf(t),
    "PRIVATE"
    /* ComponentType.PRIVATE */
  )), Pt(Dn, Wr, e), Pt(Dn, Wr, "esm2017"), Pt("fire-js", "");
}
_f("");
var wf = "firebase", Af = "11.2.0";
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Pt(wf, Af, "app");
/*! js-cookie v3.0.5 | MIT */
function Ot(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t];
    for (var r in n)
      e[r] = n[r];
  }
  return e;
}
var Cf = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Pn(e, t) {
  function n(i, o, s) {
    if (!(typeof document > "u")) {
      s = Ot({}, t, s), typeof s.expires == "number" && (s.expires = new Date(Date.now() + s.expires * 864e5)), s.expires && (s.expires = s.expires.toUTCString()), i = encodeURIComponent(i).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var a = "";
      for (var l in s)
        s[l] && (a += "; " + l, s[l] !== !0 && (a += "=" + s[l].split(";")[0]));
      return document.cookie = i + "=" + e.write(o, i) + a;
    }
  }
  function r(i) {
    if (!(typeof document > "u" || arguments.length && !i)) {
      for (var o = document.cookie ? document.cookie.split("; ") : [], s = {}, a = 0; a < o.length; a++) {
        var l = o[a].split("="), f = l.slice(1).join("=");
        try {
          var g = decodeURIComponent(l[0]);
          if (s[g] = e.read(f, g), i === g)
            break;
        } catch {
        }
      }
      return i ? s[i] : s;
    }
  }
  return Object.create(
    {
      set: n,
      get: r,
      remove: function(i, o) {
        n(
          i,
          "",
          Ot({}, o, {
            expires: -1
          })
        );
      },
      withAttributes: function(i) {
        return Pn(this.converter, Ot({}, this.attributes, i));
      },
      withConverter: function(i) {
        return Pn(Ot({}, this.converter, i), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(t) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var at = Pn(Cf, { path: "/" });
const Un = Yr(null), fn = {
  status: void 0,
  // This is not required, but setting to show that it defaults to `undefined`
  isAuthenticating: !1,
  isFetchingUser: !1,
  authInfo: {},
  userInfo: {},
  apiError: void 0
};
function Th(e) {
  var nt;
  const {
    api: t,
    appAuthCookieName: n,
    authCookieDomain: r,
    children: i,
    firebaseConfig: o,
    isTest: s = !1,
    isWeb: a = !1,
    legacyAuthCookieName: l,
    queryClient: f,
    storage: g,
    storageAuthKey: p,
    userApi: m,
    userPool: E,
    userSyncApi: _,
    vgsApi: S
  } = e;
  if (Ln(Un)) throw new Error("AuthProvider must only be used once!");
  const [R, L] = de(fn), ge = at.get(l), q = pt(() => ({
    domain: r,
    expires: 30,
    sameSite: "none",
    secure: !0
  }), [r]);
  We(() => {
    (async () => {
      a && !s && (hf().length || Yi(o));
    })();
  }, [o, s, a]), We(() => {
    async function D() {
      s || await ze.addListener("authStateChange", async () => {
      });
    }
    async function T() {
      s || await ze.removeAllListeners();
    }
    return D(), () => {
      T();
    };
  }, [s]);
  const me = async () => {
    try {
      return (await ze.getCurrentUser()).user;
    } catch (D) {
      console.error("Firebase current user - error: ", D);
    }
  }, ue = Q(async (D) => {
    try {
      return (await ze.signInWithGoogle(D)).user;
    } catch (T) {
      console.error("onGoogleSignIn - error: ", T), ke(T).includes("popup-closed-by-user") || console.error(ke(T));
    }
  }, []), Se = Q(async (D) => {
    const T = new on({
      Username: D.email,
      Pool: E,
      Storage: g
    }), O = new Qa({
      Username: D.email,
      Password: D.password
    });
    return new Promise((U, $) => {
      const G = T.authenticateUser(O, {
        onSuccess: (k) => U(k),
        onFailure: (k) => (console.error("authenticateUser - error: ", k), $(k))
      });
      return s ? G.then((k) => U(k)).catch((k) => $(k)) : G;
    });
  }, [s, g, E]), V = Q(async () => await ze.signOut(), []), Y = Q(async () => new Promise((D, T) => {
    const O = E.getCurrentUser();
    return O ? D(O.signOut()) : T("No user found");
  }), [E]), J = Q((D) => {
    g.clear(), at.remove(n, q), at.remove(l, {
      path: "/",
      domain: r
    }), delete t.defaults.headers.common.Authorization, delete t.defaults.headers.common["authenticate-with-legacy-token"], S && delete S.defaults.headers.common.Authorization, L(() => ({
      ...fn,
      // We can safely assert that the user is not authenticated
      status: "UN_AUTHENTICATED",
      apiError: (D == null ? void 0 : D.apiError) ?? void 0
    })), f.removeQueries();
    const {
      history: T,
      redirectPath: O = "/"
    } = D ?? {};
    T && T.push(O);
  }, [t.defaults.headers.common, n, r, q, l, f, g, S]), we = Q(async (D) => {
    const T = new on({
      Username: D,
      Pool: E
    });
    return new Promise((O, U) => T.forgotPassword({
      onSuccess: ($) => O($),
      onFailure: ($) => (console.error("forgotPassword - error: ", $), U($)),
      // the user can input the verification code on another page or at a later time. By
      // setting inputVerificationCode to undefined the onSuccess method is called immediately
      // assuming there are no errors allowing this function to resolve
      inputVerificationCode: void 0
    }));
  }, [E]), Ae = Q(async (D, T, O) => {
    const U = new on({
      Username: D,
      Pool: E
    });
    return new Promise(($, G) => U.confirmPassword(T, O, {
      onSuccess: (k) => $(k),
      onFailure: (k) => (console.error("confirmPassword - error: ", k), G(k))
    }));
  }, [E]), X = Q(() => (J(), window.location.assign("/")), [J]), {
    refetch: De
  } = Xr({
    queryKey: ["userData"],
    queryFn: m,
    // "enabled" set to false so we don't run automatically as
    // we want to control when we call this query
    enabled: !1,
    // note: explicitly do not retry for 404 (user does not exist) or 500 (user exists but incorrect user type, i.e. an un-aliased admin)
    // by using a fn we cannot use default retry behavior and must handle all cases
    retry: (D, T) => {
      var O, U;
      return ((O = T.response) == null ? void 0 : O.status) === 404 || ((U = T.response) == null ? void 0 : U.status) === 500 ? (J({
        apiError: T
      }), !1) : D <= 3;
    }
    // note: we do not throw / bubble up error (default behavior)
    // throwOnError: false
  }, f), {
    mutateAsync: Ee
  } = eo({
    mutationFn: () => _(),
    // note: explicitly do not retry for 404 (user does not exist) or 500 (user exists but incorrect user type, i.e. an un-aliased admin)
    // by using a fn we cannot use default retry behavior and must handle all cases
    retry: (D, T) => {
      var O, U;
      return ((O = T.response) == null ? void 0 : O.status) === 404 || ((U = T.response) == null ? void 0 : U.status) === 500 ? (J({
        apiError: T
      }), !1) : D <= 3;
    }
    // note: we do not throw / bubble up error (default behavior)
    // throwOnError: false
  }, f), Ce = Q(async () => {
    var D;
    try {
      L((O) => ({
        ...O,
        isFetchingUser: !0
      }));
      const {
        data: T
      } = await De();
      return L((O) => ({
        ...O,
        userInfo: T ?? {},
        status: T && Object.keys(T).length > 0 ? "AUTHENTICATED" : "UN_AUTHENTICATED"
      })), L((O) => ({
        ...O,
        isFetchingUser: !1
      })), T;
    } catch (T) {
      console.error(ke(T)), T instanceof go && console.error((D = T.response) == null ? void 0 : D.data), J();
    }
  }, [De, J]);
  We(() => {
    const D = async () => await Ce(), T = (k) => {
      try {
        return JSON.parse(k);
      } catch {
        return JSON.parse(atob(k));
      }
    }, U = (() => {
      if (ge)
        try {
          const k = T(ge);
          return t.defaults.headers.common["authenticate-with-legacy-token"] = !0, k;
        } catch {
          at.remove(l, {
            path: "/",
            domain: r
          });
        }
    })(), $ = (k, Te) => {
      const ve = {};
      if (Te === "cognito") {
        const Re = new Date(Date.now() + 864e5).getTime();
        ve.refreshTokenExpiration = Re;
      }
      return ve.provider = Te, {
        ...k,
        ...ve
      };
    }, G = g.getItem(p) || U && $(U, U["google/token"] ? "google" : "cognito");
    if (G) {
      const k = new rt(G);
      L((Te) => ({
        ...Te,
        authInfo: k
      })), t.defaults.headers.common.Authorization = `Token ${k.token}`, S && (S.defaults.headers.common.Authorization = `Token ${k.token}`), D();
    } else
      L({
        ...fn,
        status: "UN_AUTHENTICATED"
      });
  }, []);
  const Ke = Q(async () => await me() ? (await ze.getIdToken()).token : X(), [X]), tt = Q(async (D, T) => {
    const O = {};
    if (T === "cognito") {
      const G = new Date(Date.now() + 25056e5).getTime();
      O.refreshTokenExpiration = G;
    }
    if (T === "google") {
      const G = await Ke();
      if (!G)
        return X();
      O.authentication = {
        idToken: G
      };
    }
    O.provider = T, g.setItem(p, {
      ...D,
      ...O
    });
    const U = new rt({
      ...D,
      ...O
    });
    L((G) => ({
      ...G,
      authInfo: U,
      apiError: void 0
    })), t.defaults.headers.common.Authorization = `Token ${U.token}`, S && (S.defaults.headers.common.Authorization = `Token ${U.token}`);
    const $ = await Ce();
    $ && !$.isAlias && at.set(n, `${U.token}`, q), $ != null && $.isAlias || await Ee();
  }, [t.defaults.headers.common, n, q, Ce, Ke, X, g, p, Ee, S]), wt = Q(async (D) => {
    try {
      const T = await Ke();
      if (!T)
        throw new Error("Retrieving token via firebaseAuthIdToken failed");
      if (!D.response)
        throw new Error("failedRequest response is missing so unable to assign token");
      D.response.config.headers.Authorization = `Token ${T}`, t.defaults.headers.common.Authorization = `Token ${T}`;
      const O = g.getItem(p);
      return O.authentication.idToken = T, g.setItem(p, O), L((U) => ({
        ...U,
        authInfo: new rt(O)
      })), Promise.resolve();
    } catch (T) {
      return (T.type === "userLoggedOut" ? console.info : console.error)("Unable to get new tokens for Google Auth: ", ke(T)), X();
    }
  }, [t.defaults.headers.common, Ke, X, g, p]), At = Q(async (D) => {
    const T = E.getCurrentUser();
    return T ? T == null ? void 0 : T.getSession((O, U) => {
      if (O)
        return console.error("getSession - error: ", O), X();
      const $ = U.getRefreshToken();
      return T.refreshSession($, (G, k) => {
        if (G)
          return console.error("refreshSession - error: ", G), X();
        const Te = k.idToken.jwtToken;
        if (!D.response)
          throw new Error("failedRequest response is missing so unable to assign token");
        D.response.config.headers.Authorization = `Token ${Te}`, t.defaults.headers.common.Authorization = `Token ${Te}`;
        let ve = g.getItem(p);
        return ve = {
          ...ve,
          idToken: k.idToken,
          accessToken: k.accessToken
        }, g.setItem(p, ve), L((Re) => ({
          ...Re,
          authInfo: new rt(ve)
        })), Promise.resolve();
      });
    }) : (console.error("No Cognito user found"), X());
  }, [t.defaults.headers.common, X, g, p, E]), z = Q(async (D, T) => {
    switch (T) {
      case "google":
        return await wt(D);
      case "cognito":
        return await At(D);
      default:
        return console.error(`provider ${T} unknown - unable to refresh tokens`), Promise.reject();
    }
  }, [At, wt]);
  We(() => {
    Yu(
      // @ts-expect-error is not assignable to parameter of type 'AxiosInstance'
      t,
      async (D) => {
        try {
          const T = g.getItem(p);
          if (T) {
            const O = new rt(T), {
              provider: U,
              refreshTokenExpiration: $
            } = O;
            return L((G) => ({
              ...G,
              authInfo: O
            })), Tf(U, $) ? (console.info(`provider ${U} refresh token expired`), X()) : await z(D, U);
          }
          throw new Error("localStorage data not available");
        } catch (T) {
          return console.error("createAuthRefreshInterceptor failed: ", ke(T)), X();
        }
      },
      {
        // 401 - token invalid or expired, 403 - token missing
        statusCodes: [401, 403],
        pauseInstanceWhileRefreshing: !0
      }
    );
  }, [t, X, z, g, p]);
  const Z = Q(async (D) => {
    const {
      provider: T
    } = D, O = "user" in D ? D.user : void 0;
    try {
      switch (L((U) => ({
        ...U,
        isAuthenticating: !0
      })), T) {
        case "google":
          {
            const U = await ue({
              scopes: ["openid", "profile", "email"],
              mode: "popup"
            });
            U && await tt(U, T);
          }
          break;
        case "cognito":
          {
            if (!O)
              throw new Error("user must be provided when Cognito login attempted!");
            const U = await Se(O);
            await tt(U, T);
          }
          break;
        default:
          throw new Error(`${T} is not a supported provider.`);
      }
    } catch (U) {
      throw new Error(ke(U));
    } finally {
      L((U) => ({
        ...U,
        isAuthenticating: !1
      }));
    }
  }, [Se, ue, tt]), Le = Q(async (D) => {
    var T, O;
    try {
      switch ((T = R.authInfo) == null ? void 0 : T.provider) {
        case "google":
          await V();
          break;
        case "cognito":
          await Y();
          break;
        default:
          throw new Error(`${(O = R.authInfo) == null ? void 0 : O.provider} is not a supported provider.`);
      }
    } catch (U) {
      throw new Error(ke(U));
    } finally {
      J(D);
    }
  }, [Y, V, J, (nt = R.authInfo) == null ? void 0 : nt.provider]), Fe = Q(() => Ce(), [Ce]);
  return pt(() => /* @__PURE__ */ y(Un.Provider, {
    value: {
      ...R,
      signIn: Z,
      signOut: Le,
      refreshUser: Fe,
      forgotPasswordRequest: we,
      forgotPasswordSubmit: Ae
    },
    children: i
  }), [R, Z, Le, Fe, we, Ae, i]);
}
function ar() {
  const e = Ln(Un);
  if (e === null) throw new Error("useAuth must be used within an AuthProvider!");
  return e;
}
function Tf(e, t) {
  return e === "cognito" ? !!(t && Date.now() >= t) : !1;
}
const Zi = Yr(null);
function bh(e) {
  var l;
  const {
    api: t,
    children: n
  } = e, {
    status: r
  } = ar(), {
    data: i,
    isLoading: o,
    error: s
  } = Xr({
    queryKey: ["feature-flags", r],
    queryFn: async () => {
      const {
        data: f
      } = await t({
        url: "/api/user/feature-flags"
      });
      return f;
    },
    /**
     * Only enable the query when AuthProvider has determined the auth status
     * This ensures the Authorization header is properly set (or not set) before making the request
     */
    enabled: r !== void 0,
    /**
     * Data is considered stale after 1 hour
     * Data stays in cache for 2 hours
     * Users see immediate data on mount (even if stale)
     * Fresh data is fetched in the background and cache updated
     * UI automatically updates when fresh data arrives
     * Memory is eventually cleaned up after 2 hours of inactivity
     */
    staleTime: 1 * 60 * 60 * 1e3,
    gcTime: 2 * 60 * 60 * 1e3
  }), a = {
    flags: ((l = i == null ? void 0 : i.data) == null ? void 0 : l.featureFlags) ?? {},
    isLoading: o,
    error: s
  };
  return /* @__PURE__ */ y(Zi.Provider, {
    value: a,
    children: n
  });
}
function Ih() {
  const e = Ln(Zi);
  if (!e)
    throw new Error("useFeatureFlags must be used within a FeatureFlagProvider");
  return e;
}
export {
  ji as $,
  mt as A,
  Eo as B,
  bh as C,
  Qf as D,
  Wn as E,
  sh as F,
  Ih as G,
  Pi as H,
  nh as I,
  ih as J,
  oh as K,
  ah as L,
  Ch as M,
  uh as N,
  ch as O,
  si as P,
  Eh as Q,
  wh as R,
  Ao as S,
  Zf as T,
  mh as U,
  bt as V,
  Tn as W,
  vh as X,
  yh as Y,
  _t as Z,
  _h as _,
  zf as a,
  Ki as a0,
  lh as a1,
  dh as a2,
  Qu as a3,
  ph as a4,
  gh as a5,
  Ah as a6,
  hh as a7,
  El as a8,
  H as a9,
  fh as aa,
  On as ab,
  Lt as ac,
  Pt as ad,
  Sh as ae,
  br as af,
  Tr as ag,
  So as b,
  qf as c,
  Yf as d,
  Xf as e,
  yo as f,
  _o as g,
  Jf as h,
  eh as i,
  th as j,
  Po as k,
  Go as l,
  Wo as m,
  es as n,
  rh as o,
  Oo as p,
  Oa as q,
  Pa as r,
  ka as s,
  Ma as t,
  Ui as u,
  Ba as v,
  Ni as w,
  Za as x,
  Th as y,
  ar as z
};
